/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  TranslationString: { input: any; output: any; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any; }
};

/** Activate a study participant */
export type ActivateParticipant = {
  __typename?: 'ActivateParticipant';
  /** Whether the study participant was activated successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GraphQL mutation for activating a user by access code.
 *
 * This mutation takes an access code (either practitioner or patient code),
 * links the corresponding care team, and activates the patient on that care
 * team. Only users with an associated patient object can use this mutation.
 *
 * Returns:
 *     success (bool): Whether user activation was successful.
 */
export type ActivateUserByAccessCode = {
  __typename?: 'ActivateUserByAccessCode';
  /** Whether user was activated successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Add a CoInvestigator */
export type AddStudyCoInvestigator = {
  __typename?: 'AddStudyCoInvestigator';
  /** Whether the Study CoInvestigator was addedd successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Add a Study Coordinator */
export type AddStudyCoordinator = {
  __typename?: 'AddStudyCoordinator';
  /** Whether the study coordinator was addedd successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Adverse event reported during use of a PDT */
export type AdverseEventType = {
  __typename?: 'AdverseEventType';
  description?: Maybe<Scalars['String']['output']>;
  isCausedByTreatment?: Maybe<Scalars['Boolean']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export type AnswerInputType = {
  assessmentValue?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<TextTranslationInputType>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** A potential answer to a question on an assessment */
export type AnswerType = {
  __typename?: 'AnswerType';
  assessmentValue?: Maybe<Scalars['Int']['output']>;
  /** Answer text */
  text?: Maybe<Scalars['TranslationString']['output']>;
  /** Answer text translations */
  textTranslations?: Maybe<TextTranslationType>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};


/** A potential answer to a question on an assessment */
export type AnswerTypeTextArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssessmentInputType = {
  contextText?: InputMaybe<TextTranslationInputType>;
  introText?: InputMaybe<TextTranslationInputType>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<TextTranslationInputType>;
  nameInternal?: InputMaybe<Scalars['String']['input']>;
  preQuestionText?: InputMaybe<TextTranslationInputType>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInputType>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of an Researcher completing an assessment */
export type AssessmentResultItemType = {
  __typename?: 'AssessmentResultItemType';
  /** The numerical assessment value of the response (for scoring) */
  assessmentValue?: Maybe<Scalars['Int']['output']>;
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  question: QuestionType;
  selectedAnswers: Array<AnswerType>;
  textValue?: Maybe<FreeFormTextType>;
  total?: Maybe<Scalars['Int']['output']>;
  /** The answer value as a string */
  value?: Maybe<Scalars['String']['output']>;
};

/** Result of an individual completing an assessment */
export type AssessmentResultType = {
  __typename?: 'AssessmentResultType';
  answers?: Maybe<Scalars['JSONString']['output']>;
  assessment?: Maybe<AssessmentType>;
  assessmentAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assessmentResultItems?: Maybe<Array<Maybe<AssessmentResultItemType>>>;
  assignment?: Maybe<StudyAssignmentsTableType>;
  createdAt: Scalars['DateTime']['output'];
  pdt?: Maybe<PdtType>;
  score?: Maybe<Scalars['Float']['output']>;
  scores?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Assessment that a study participant or user takes */
export type AssessmentType = {
  __typename?: 'AssessmentType';
  /** The context text for the top of the assessment */
  contextText?: Maybe<Scalars['TranslationString']['output']>;
  contextTextTranslations?: Maybe<TextTranslationType>;
  /** The intro text for the top of the assessment */
  introText?: Maybe<Scalars['TranslationString']['output']>;
  introTextTranslations?: Maybe<TextTranslationType>;
  isArchived: Scalars['Boolean']['output'];
  /** Whether the assessment is being used by a model that locks changes */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the assessment */
  name?: Maybe<Scalars['TranslationString']['output']>;
  nameInternal: Scalars['String']['output'];
  nameTranslations?: Maybe<TextTranslationType>;
  /** The pre question text for the top of the assessment */
  preQuestionText?: Maybe<Scalars['TranslationString']['output']>;
  preQuestionTextTranslations?: Maybe<TextTranslationType>;
  /** Questions that linked with an assessment */
  questions?: Maybe<Array<Maybe<QuestionType>>>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};


/** Assessment that a study participant or user takes */
export type AssessmentTypeContextTextArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Assessment that a study participant or user takes */
export type AssessmentTypeIntroTextArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Assessment that a study participant or user takes */
export type AssessmentTypeNameArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Assessment that a study participant or user takes */
export type AssessmentTypePreQuestionTextArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Create and assign a clinician report to a clinical concern */
export type AssignClinicianReport = {
  __typename?: 'AssignClinicianReport';
  /** clinical concern with assigned clinician report */
  clinicalConcern?: Maybe<ClinicalConcernType>;
};

/** An enumeration. */
export enum AssignmentAccountType {
  /** Adult account */
  Adult = 'ADULT',
  /** Child account */
  Child = 'CHILD',
  /** Parent account */
  Parent = 'PARENT',
  /** Research account */
  Research = 'RESEARCH'
}

/** An enumeration. */
export enum AssignmentScheduleAccountType {
  /** Adult account */
  Adult = 'ADULT',
  /** Child account */
  Child = 'CHILD',
  /** Parent account */
  Parent = 'PARENT',
  /** Research account */
  Research = 'RESEARCH'
}

export type AssignmentScheduleInputType = {
  accountType: Scalars['String']['input'];
  assessmentUid: Scalars['String']['input'];
  canEditAfterCompletion: Scalars['Boolean']['input'];
  canSkipQuestions: Scalars['Boolean']['input'];
  count: Scalars['Int']['input'];
  ordinal: Scalars['Int']['input'];
  repeatFrequencyDays: Scalars['Int']['input'];
  scheduleOnStudyState: Scalars['String']['input'];
  sendEmailNotifications: Scalars['Boolean']['input'];
  sendPushNotifications: Scalars['Boolean']['input'];
  sendSmsNotifications: Scalars['Boolean']['input'];
  startTimeOffsetDays: Scalars['Int']['input'];
  typeOfClientForAssignment: Scalars['String']['input'];
  typeOfNotificationForAssignment: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
  visibleDurationDays: Scalars['Int']['input'];
};

/** An enumeration. */
export enum AssignmentScheduleScheduleOnStudyState {
  /** Activation */
  Activation = 'ACTIVATION',
  /** Registration */
  Registration = 'REGISTRATION'
}

/** Assignment Schedule */
export type AssignmentScheduleType = {
  __typename?: 'AssignmentScheduleType';
  accountType: AssignmentScheduleAccountType;
  assessment?: Maybe<AssessmentType>;
  canEditAfterCompletion: Scalars['Boolean']['output'];
  canSkipQuestions: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  ordinal: Scalars['Int']['output'];
  organization?: Maybe<OrganizationType>;
  repeatFrequencyDays?: Maybe<Scalars['Int']['output']>;
  scheduleOnStudyState: AssignmentScheduleScheduleOnStudyState;
  sendEmailNotifications: Scalars['Boolean']['output'];
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  sendPushNotifications: Scalars['Boolean']['output'];
  sendSmsNotifications: Scalars['Boolean']['output'];
  startTimeOffsetDays?: Maybe<Scalars['Int']['output']>;
  study?: Maybe<LimbixStudyType>;
  total?: Maybe<Scalars['Int']['output']>;
  typeForAssignment: AssignmentScheduleTypeForAssignment;
  typeOfClientForAssignment: AssignmentScheduleTypeOfClientForAssignment;
  typeOfNotificationForAssignment: AssignmentScheduleTypeOfNotificationForAssignment;
  uid: Scalars['String']['output'];
  visibleDurationDays?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum AssignmentScheduleTypeForAssignment {
  /** Adverse Event */
  AdverseEvent = 'ADVERSE_EVENT',
  /** Assessment */
  Assessment = 'ASSESSMENT'
}

/** An enumeration. */
export enum AssignmentScheduleTypeOfClientForAssignment {
  /** Mobile Client */
  Mobile = 'MOBILE',
  /** Provider Portal Client */
  ProviderPortal = 'PROVIDER_PORTAL',
  /** ResOps Portal */
  ResopsPortal = 'RESOPS_PORTAL',
  /** Web Portal Client */
  WebPortal = 'WEB_PORTAL'
}

/** An enumeration. */
export enum AssignmentScheduleTypeOfNotificationForAssignment {
  /** Intra-study Notifications */
  IntraStudy = 'INTRA_STUDY',
  /** Post Study Notifications */
  PostStudy = 'POST_STUDY',
  /** Pre Study Notifications */
  PreStudy = 'PRE_STUDY'
}

/** Assignment that a user must complete by a certain time */
export type AssignmentType = {
  __typename?: 'AssignmentType';
  aboutStudyParticipant?: Maybe<StudyParticipantType>;
  aboutUser?: Maybe<UserType>;
  accountType: AssignmentAccountType;
  adverseEvent?: Maybe<AdverseEventType>;
  assessment?: Maybe<AssessmentType>;
  canEditAfterCompletion: Scalars['Boolean']['output'];
  canSkipQuestions: Scalars['Boolean']['output'];
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  ordinal: Scalars['Int']['output'];
  organization?: Maybe<OrganizationType>;
  participantAssessmentResult?: Maybe<ParticipantAssessmentResultType>;
  pdt: PdtType;
  researchAssessmentResult?: Maybe<ResearchAssessmentResultType>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study?: Maybe<LimbixStudyType>;
  studyParticipant?: Maybe<StudyParticipantType>;
  total?: Maybe<Scalars['Int']['output']>;
  typeOfAssignment: AssignmentTypeOfAssignment;
  typeOfClient: AssignmentTypeOfClient;
  uid: Scalars['String']['output'];
  user?: Maybe<UserType>;
  visibleDate: Scalars['DateTime']['output'];
  weekInProgram?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum AssignmentTypeOfAssignment {
  /** Adverse Event */
  AdverseEvent = 'ADVERSE_EVENT',
  /** Assessment */
  Assessment = 'ASSESSMENT'
}

/** An enumeration. */
export enum AssignmentTypeOfClient {
  /** Mobile Client */
  Mobile = 'MOBILE',
  /** Provider Portal Client */
  ProviderPortal = 'PROVIDER_PORTAL',
  /** ResOps Portal */
  ResopsPortal = 'RESOPS_PORTAL',
  /** Web Portal Client */
  WebPortal = 'WEB_PORTAL'
}

/** Legacy Behavioral activation task that a user engages in during use of a PDT */
export type BehavioralActivationTaskType = {
  __typename?: 'BehavioralActivationTaskType';
  activity?: Maybe<Scalars['String']['output']>;
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  didCompleteScheduledActivation: Scalars['Boolean']['output'];
  extraData?: Maybe<Scalars['JSONString']['output']>;
  moduleNumber?: Maybe<Scalars['Int']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  taskNumber?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export type BoxAccessToken = {
  __typename?: 'BoxAccessToken';
  /** The access token for the Box API */
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type CbtContent = {
  __typename?: 'CBTContent';
  completed?: Maybe<Scalars['Boolean']['output']>;
  contentfulDailySessionId?: Maybe<Scalars['GenericScalar']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
};

/** Cancel a particular periodic push notification */
export type CancelPeriodicPushNotification = {
  __typename?: 'CancelPeriodicPushNotification';
  /** Cancelled periodic notification */
  periodicNotification?: Maybe<PeriodicPushNotificationType>;
};

/** Cancel a periodic push notification */
export type CancelPeriodicPushNotificationByType = {
  __typename?: 'CancelPeriodicPushNotificationByType';
  /** Canceled periodic notifications */
  periodicNotifications?: Maybe<Array<Maybe<PeriodicPushNotificationType>>>;
};

/** Cancel a particular push notification */
export type CancelPushNotification = {
  __typename?: 'CancelPushNotification';
  /** Cancelled notification task */
  notificationTask?: Maybe<NotificationTaskType>;
};

/** Cancel push notifications with a particular notification_type */
export type CancelPushNotificationsByType = {
  __typename?: 'CancelPushNotificationsByType';
  /** Cancelled notification tasks */
  notificationTasks?: Maybe<Array<Maybe<NotificationTaskType>>>;
};

/** Active care team membership for migration provisioning. */
export type CareTeamEntitlementType = {
  __typename?: 'CareTeamEntitlementType';
  /** Organization slug */
  orgSlug?: Maybe<Scalars['String']['output']>;
  /** PDT slug (spark, daylight, etc.) */
  product?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum CareTeamPaymentType {
  /** Fixed */
  Fixed = 'FIXED',
  /** Free */
  Free = 'FREE',
  /** Variable */
  Variable = 'VARIABLE'
}

/** Care Team */
export type CareTeamType = {
  __typename?: 'CareTeamType';
  assignments?: Maybe<Array<Maybe<AssignmentType>>>;
  canAccessPdt?: Maybe<Scalars['Boolean']['output']>;
  completedTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discontinuedTime?: Maybe<Scalars['DateTime']['output']>;
  enrolledTime?: Maybe<Scalars['DateTime']['output']>;
  hasMobileTokens?: Maybe<Scalars['Boolean']['output']>;
  invitedTime?: Maybe<Scalars['DateTime']['output']>;
  lastNudgeSentAt?: Maybe<Scalars['DateTime']['output']>;
  organization: OrganizationType;
  patient: PatientType;
  paymentType?: Maybe<CareTeamPaymentType>;
  pdt: PdtType;
  practitioners: Array<PractitionerType>;
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalActiveDays?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userPdtData?: Maybe<UserPdtDataType>;
};

/**
 * GraphQL type representing CBT technique progress for a patient.
 *
 * This type combines manual practice logs with program progress-based credits
 * to provide a comprehensive count of how many times a technique has been
 * practiced. The practice_count includes:
 * - Manual practice logs (CbtTechniqueLog entries)
 * - Bonus credit for techniques the user has progressed past in the program
 *
 * Attributes:
 *     technique: The CBT technique this progress is for.
 *     practice_count: The total number of times the technique has been practiced,
 *         including both manual logs and program progress credits.
 */
export type CbtTechniqueProgressType = {
  __typename?: 'CbtTechniqueProgressType';
  /** The number of times the technique has been practiced. Includes both manual practice logs and program progress-based credits. */
  practiceCount?: Maybe<Scalars['Int']['output']>;
  technique?: Maybe<CbtTechniqueType>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A CBT technique type definition */
export type CbtTechniqueType = {
  __typename?: 'CbtTechniqueType';
  label?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** A CBT technique user data type definition */
export type CbtTechniqueUserDataType = {
  __typename?: 'CbtTechniqueUserDataType';
  introducedDate?: Maybe<Scalars['Date']['output']>;
  lastPracticedDate?: Maybe<Scalars['Date']['output']>;
  technique?: Maybe<CbtTechniqueType>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Assessment types for clinical check-ins. */
export enum ClinicalAssessmentType {
  Gad_2 = 'GAD_2',
  Gad_7 = 'GAD_7'
}

/** Clinical check-in to track improvement over time from baseline scores. */
export type ClinicalCheckInType = {
  __typename?: 'ClinicalCheckInType';
  /** When the clinical check-in was completed (set manually) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** GAD-2 responses only */
  gad2Responses?: Maybe<Array<Maybe<ClinicalUserResponseType>>>;
  /** GAD-2 score (0-6), calculated from GAD_2 responses or first 2 GAD_7 responses */
  gad2Score?: Maybe<Scalars['Int']['output']>;
  /** GAD-7 responses only */
  gad7Responses?: Maybe<Array<Maybe<ClinicalUserResponseType>>>;
  /** GAD-7 score (0-21), calculated from all GAD_7 responses */
  gad7Score?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the clinical check-in */
  id: Scalars['UUID']['output'];
  /** Flag indicating this is the baseline check-in for clinical improvement tracking */
  isBaseline: Scalars['Boolean']['output'];
  /** Whether GAD-2 responses exist or fallback available */
  isGad2Complete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether all 7 GAD-7 responses exist */
  isGad7Complete?: Maybe<Scalars['Boolean']['output']>;
  /** Clinical responses associated with this check-in */
  responses?: Maybe<Array<Maybe<ClinicalUserResponseType>>>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Clinical Concern related to an event while enrolled in a study */
export type ClinicalConcernType = {
  __typename?: 'ClinicalConcernType';
  answers?: Maybe<Scalars['JSONString']['output']>;
  assessment?: Maybe<AssessmentType>;
  assessmentAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assessmentResultItems?: Maybe<Array<Maybe<AssessmentResultItemType>>>;
  clinicianReport?: Maybe<StudyAssignmentsTableType>;
  createdAt: Scalars['DateTime']['output'];
  study: LimbixStudyType;
  studyParticipant?: Maybe<StudyParticipantType>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

/** Container for all available clinical data types. */
export type ClinicalDataDictType = {
  __typename?: 'ClinicalDataDictType';
  /** SCI-2 insomnia severity score data */
  sci2?: Maybe<ClinicalDataSetType>;
  /** Sleep efficiency percentage data */
  sleepEfficiency?: Maybe<ClinicalDataSetType>;
  /** Sleep quality/rest level data */
  sleepQuality?: Maybe<ClinicalDataSetType>;
  /** Total sleep time per night data */
  totalSleepTime?: Maybe<ClinicalDataSetType>;
};

/** A single data point in a clinical data series. */
export type ClinicalDataPointType = {
  __typename?: 'ClinicalDataPointType';
  /** The date for this data point */
  referenceDate: Scalars['Date']['output'];
  /** The clinical score value (may be None if no data available) */
  value?: Maybe<Scalars['Float']['output']>;
};

/** A complete clinical data set with normalization bounds and data points. */
export type ClinicalDataSetType = {
  __typename?: 'ClinicalDataSetType';
  /** List of data points for this clinical metric */
  data: Array<Maybe<ClinicalDataPointType>>;
  /** Lower bound of the normal range for this clinical score */
  lowerNorm: Scalars['Float']['output'];
  /** Units for the clinical score (e.g., 'Hours/Night', '%', or empty string) */
  units: Scalars['String']['output'];
  /** Upper bound of the normal range for this clinical score */
  upperNorm: Scalars['Float']['output'];
};

/** An enumeration. */
export enum ClinicalUserResponseClinicalQuestionType {
  /** GAD-2 */
  Gad_2 = 'GAD_2',
  /** GAD-7 */
  Gad_7 = 'GAD_7'
}

/** Input type for batch clinical user response creation/update. */
export type ClinicalUserResponseInput = {
  /** Type of clinical assessment (GAD_7, GAD_2, etc.) */
  clinicalQuestionType?: InputMaybe<ClinicalAssessmentType>;
  /** Contentful question ID */
  contentfulQuestionId: Scalars['String']['input'];
  /** Array of purpose types (e.g., 'employer_reporting', 'goal_setting') */
  purpose?: InputMaybe<Array<InputMaybe<ResponsePurposeType>>>;
  /** Order of the question within the assessment (1-indexed) */
  questionOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ID of existing response to update */
  responseId?: InputMaybe<Scalars['String']['input']>;
  /** Integer response (for clinical assessments) */
  responseInt?: InputMaybe<Scalars['Int']['input']>;
  /** Text response */
  responseText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * User responses to standardized clinical questions.
 * Used for priority modules (e.g., onboarding) with specific purposes.
 */
export type ClinicalUserResponseType = {
  __typename?: 'ClinicalUserResponseType';
  /** ID of the clinical check-in this response belongs to */
  clinicalCheckInId?: Maybe<Scalars['String']['output']>;
  /** Type of clinical assessment question (gad_2, gad_7) */
  clinicalQuestionType?: Maybe<ClinicalUserResponseClinicalQuestionType>;
  /** Reference to question ID from CBT Config/Contentful */
  contentfulQuestionId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user response */
  id: Scalars['UUID']['output'];
  /** Array of purposes this response can be used for (e.g., employer_reporting, goal_setting) */
  purpose: Array<Scalars['String']['output']>;
  /** Order of the question within the assessment (1-7 for GAD-7, 1-2 for GAD-2) */
  questionOrder?: Maybe<Scalars['Int']['output']>;
  respondedAt: Scalars['DateTime']['output'];
  /** Integer response for scale/numeric questions */
  responseInt?: Maybe<Scalars['Int']['output']>;
  /** Text response for text/multiple choice questions */
  responseText?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Result of completing an assignment */
export type CompleteAssignment = {
  __typename?: 'CompleteAssignment';
  /** Assignment that was completed */
  assignment?: Maybe<AssignmentType>;
};

/** Mark a study participant as Completed */
export type CompleteParticipant = {
  __typename?: 'CompleteParticipant';
  /** Whether the study participant was completed successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Result of completing a Researchassignment */
export type CompleteResearchAssignment = {
  __typename?: 'CompleteResearchAssignment';
  /**  Research assignment that was completed */
  assignment?: Maybe<AssignmentType>;
};

/** Create a new Assessment with new questions, answers, etc. */
export type CreateAssessment = {
  __typename?: 'CreateAssessment';
  assessment?: Maybe<AssessmentType>;
};

/** Legacy create a behavioral activation task */
export type CreateBehavioralActivationTask = {
  __typename?: 'CreateBehavioralActivationTask';
  /** Behavioral activation user engages in during use of a PDT */
  behavioralActivationTask?: Maybe<BehavioralActivationTaskType>;
};

/** Create the base Clinical Concern object with necessary data */
export type CreateClinicalConcern = {
  __typename?: 'CreateClinicalConcern';
  clinicalConcern?: Maybe<ClinicalConcernType>;
};

/** Create free-form text */
export type CreateFreeFormText = {
  __typename?: 'CreateFreeFormText';
  /** Free form text that was created */
  freeFormText?: Maybe<FreeFormTextType>;
};

/**
 * Create clinical concerns with mock data
 *
 * Create the given number of clinical concerns for the given user. If the study has a clinical report, also create
 * mock data for the clinical report.
 */
export type CreateMockClinicalConcerns = {
  __typename?: 'CreateMockClinicalConcerns';
  /** mock clinical concerns created */
  clinicalConcerns?: Maybe<Array<Maybe<ClinicalConcernType>>>;
};

export type CreateMockStudyAssignments = {
  __typename?: 'CreateMockStudyAssignments';
  assignments?: Maybe<Array<Maybe<AssignmentType>>>;
};

/** Legacy method for creating a mood log */
export type CreateMoodLog = {
  __typename?: 'CreateMoodLog';
  /** Mood log user creates during use of a PDT */
  moodLog?: Maybe<MoodLogType>;
};

/**
 * Create a new Order through GraphQL with minimum required parameters.
 *
 * WARNING: This mutation should only be used in very specific situations where a generic
 * order creation method is truly needed. Most order creation entry points should have their
 * own dedicated mutation methods that accommodate their particular requirements and validation
 * rules. The generic order creation method in order_utils.py should remain the single source
 * of truth for order creation logic, but each interface/entry point should have its own
 * GraphQL mutation that handles its specific needs.
 *
 * This mutation is provided as a fallback for cases where an entry point doesn't have specific
 * requirements, but it should NOT be the default approach for creating orders.
 *
 * This mutation requires only pdt_uid and organization_uid; all other fields are optional.
 */
export type CreateOrder = {
  __typename?: 'CreateOrder';
  /** The access code associated with the order */
  accessCode?: Maybe<Scalars['String']['output']>;
  /** The created order */
  order?: Maybe<OrderType>;
};

/** Create a new Order through GraphQL, to be called via the Provider Portal. */
export type CreateOrderWithProviderPortal = {
  __typename?: 'CreateOrderWithProviderPortal';
  /** The access code associated with the order */
  accessCode?: Maybe<Scalars['String']['output']>;
  /** The created order */
  order?: Maybe<OrderType>;
};

/**
 * Create a new Order through GraphQL web form.
 *
 * Uses ``order_source`` ``WEB_ORDER_FORM``.
 */
export type CreateOrderWithWebForm = {
  __typename?: 'CreateOrderWithWebForm';
  /** The access code associated with the order */
  accessCode?: Maybe<Scalars['String']['output']>;
  /** The created order */
  order?: Maybe<OrderType>;
};

/** Create a Sci2Data */
export type CreateSci2Data = {
  __typename?: 'CreateSci2Data';
  /** The Sci2Data that was created */
  sci2Data?: Maybe<Sci2DataType>;
};

/** Create a SleepioProgressReview and all its associated SleepioProgressReviewWeeks */
export type CreateSleepioProgressReview = {
  __typename?: 'CreateSleepioProgressReview';
  /** The SleepioProgressReview that was created */
  sleepioProgressReview?: Maybe<SleepioProgressReviewType>;
};

/** Create a SleepioSleepDiary */
export type CreateSleepioSleepDiary = {
  __typename?: 'CreateSleepioSleepDiary';
  /** The SleepioSleepDiary that was created */
  sleepioSleepDiary?: Maybe<SleepioSleepDiaryType>;
};

/** Create a TOTP Authenticator and require 2FA for a user account */
export type CreateTotpAuthenticator = {
  __typename?: 'CreateTOTPAuthenticator';
  /** TOTP Authenticator for the current user */
  totpAuthenticator?: Maybe<TotpAuthenticatorType>;
};

/** Create a user activity log */
export type CreateUserActivityLog = {
  __typename?: 'CreateUserActivityLog';
  /** Activity Log user engages in during use of a PDT */
  userActivityLog?: Maybe<UserActivityLogType>;
};

/** Create a log */
export type CreateUserLog = {
  __typename?: 'CreateUserLog';
  /** UserLog user creates during use of a PDT */
  userLog?: Maybe<UserLogType>;
};

/** Create a new Order from the Xealth integration */
export type CreateXealthOrder = {
  __typename?: 'CreateXealthOrder';
  /** The access code associated with the order */
  accessCode?: Maybe<Scalars['String']['output']>;
  /** The created order */
  order?: Maybe<OrderType>;
};

/** Daily check-in completed by user for their therapeutic session. */
export type DailyCheckInType = {
  __typename?: 'DailyCheckInType';
  /** When the check-in was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contentful module identifier for the check-in */
  contentfulModuleId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the daily check-in */
  id: Scalars['UUID']['output'];
  /** User responses to check-in questions */
  responses?: Maybe<Array<Maybe<UserResponseType>>>;
  /** Date of the check-in session */
  sessionDate: Scalars['Date']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Session linked to this check-in */
  userDailySession?: Maybe<UserDailySessionType>;
};

/**
 * Decode an organization signup (JWT) token. This separate mutation is needed so that a token can be
 * validated before the remaining user data is collected.
 */
export type DecodeOrganizationSignupToken = {
  __typename?: 'DecodeOrganizationSignupToken';
  /** The existing careteam associated with this token and PDT (if it exists) */
  existingCareTeam?: Maybe<CareTeamType>;
  /** The decoded JSON payload */
  tokenPayload?: Maybe<Scalars['JSONString']['output']>;
};

/** Legacy delete a behavioral activation task */
export type DeleteBehavioralActivationTask = {
  __typename?: 'DeleteBehavioralActivationTask';
  /** Behavioral activation that was deleted */
  behavioralActivationTask?: Maybe<BehavioralActivationTaskType>;
};

/** Delete a clinical concern */
export type DeleteClinicalConcern = {
  __typename?: 'DeleteClinicalConcern';
  /** clinical concern that was successfully deleted */
  clinicalConcern?: Maybe<ClinicalConcernType>;
};

/** Legacy method for deleting a mood log */
export type DeleteMoodLog = {
  __typename?: 'DeleteMoodLog';
  /** Mood log user that was deleted */
  moodLog?: Maybe<MoodLogType>;
};

/** Delete a study participant */
export type DeleteParticipant = {
  __typename?: 'DeleteParticipant';
  /** Whether the study participant was deleted successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Delete a Sci2Data */
export type DeleteSci2Data = {
  __typename?: 'DeleteSci2Data';
  /** The Sci2Data that was deleted */
  sci2Data?: Maybe<Sci2DataType>;
};

/** Delete a SleepioProgressReview */
export type DeleteSleepioProgressReview = {
  __typename?: 'DeleteSleepioProgressReview';
  /** The SleepioProgressReview that was deleted */
  sleepioProgressReview?: Maybe<SleepioProgressReviewType>;
};

/** Delete a SleepioSleepDiary */
export type DeleteSleepioSleepDiary = {
  __typename?: 'DeleteSleepioSleepDiary';
  /** SleepioSleepDiary that was deleted */
  sleepioSleepDiary?: Maybe<SleepioSleepDiaryType>;
};

/** Delete a study assignment schedule */
export type DeleteStudyAssignmentSchedule = {
  __typename?: 'DeleteStudyAssignmentSchedule';
  /** Assignment schedule that was deleted */
  assignmentSchedule?: Maybe<AssignmentScheduleType>;
};

/** Delete a user activity log */
export type DeleteUserActivityLog = {
  __typename?: 'DeleteUserActivityLog';
  /** User activity log that was deleted */
  userActivityLog?: Maybe<UserActivityLogType>;
};

/** Delete a log */
export type DeleteUserLog = {
  __typename?: 'DeleteUserLog';
  /** User log user that was deleted */
  userLog?: Maybe<UserLogType>;
};

/** Delete a user's reminder preference */
export type DeleteUserReminder = {
  __typename?: 'DeleteUserReminder';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Item that contains list of concerning terms */
export type DenyListItemType = {
  __typename?: 'DenyListItemType';
  terms: Array<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** List of deny list items */
export type DenyListType = {
  __typename?: 'DenyListType';
  denyListItems: Array<DenyListItemType>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** Discontinue care for a patient */
export type DiscontinueCare = {
  __typename?: 'DiscontinueCare';
  /** Whether the patients mobile access was discontinued successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename?: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions?: Maybe<Array<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename?: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String']['output'];
  /** The message of the exception */
  message: Scalars['String']['output'];
  /** The stack trace */
  stack: Scalars['String']['output'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String']['output'];
};

/** Drop a study participant */
export type DropParticipant = {
  __typename?: 'DropParticipant';
  /** Whether the study participant was dropped successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Edit an existing Assessment and its questions, answers, etc. */
export type EditAssessment = {
  __typename?: 'EditAssessment';
  assessment?: Maybe<AssessmentType>;
};

/** Edit a participant's parents */
export type EditParents = {
  __typename?: 'EditParents';
  /** Whether the parents have been edited successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Edit a Study Participant's Notes, ID, Language, Account Type, First Name, Last Name, Gender,
 * Date of Birth, and/or Referral Source
 */
export type EditParticipantData = {
  __typename?: 'EditParticipantData';
  /** Whether the participant data was updated successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Update patient profile and related ``LimbixUser`` fields.
 *
 * Wrapped with ``check_care_team_access``: ``has_care_team_access`` is ``True`` for superuser
 * or operations users, or when a practitioner passes ``_practitioner_care_team_access_granted``
 * for the request UIDs. Callers without care-team access may still edit only their own
 * patient record (resolved from optional ``patient_uid`` or the first ``Patient`` row for the
 * user). Editing another user's patient requires ``has_care_team_access`` and a ``change_reason``.
 *
 * Raises ``django.core.exceptions.ValidationError`` for missing ``patient_uid`` (when none can
 * be inferred) or missing ``change_reason`` when editing someone else's patient. Raises
 * ``permission_denied_error`` when the target patient does not exist or care-team access is
 * denied.
 */
export type EditPatientInfo = {
  __typename?: 'EditPatientInfo';
  /** Whether the patient info was updated successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update a Practitioner's Notes */
export type EditPractitionerNotes = {
  __typename?: 'EditPractitionerNotes';
  /** Whether the notes were updated successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Whether a potential commercial customer is eligible to access a pdt */
export type EligibilityConfigurationType = {
  __typename?: 'EligibilityConfigurationType';
  collectZipcodeForEligibility?: Maybe<Scalars['Boolean']['output']>;
  employeeIdAllowedChars?: Maybe<Scalars['String']['output']>;
  employeeIdExample?: Maybe<Scalars['String']['output']>;
  employeeIdFieldRename?: Maybe<Scalars['String']['output']>;
  employeeIdMaxLength?: Maybe<Scalars['Int']['output']>;
  employeeIdMinLength?: Maybe<Scalars['Int']['output']>;
  employeeIdValidationEnabled?: Maybe<Scalars['Boolean']['output']>;
  employeeIdValidationErrorMessage?: Maybe<Scalars['String']['output']>;
  hasAddressField?: Maybe<Scalars['Boolean']['output']>;
  hasEmployeeId?: Maybe<Scalars['Boolean']['output']>;
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
};

/** Whether a potential commercial customer is eligible to access a pdt */
export type EligibilityStatusType = {
  __typename?: 'EligibilityStatusType';
  isEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type EnrollDirectAccessPatient = {
  __typename?: 'EnrollDirectAccessPatient';
  /** The uid of the patient that was enrolled */
  patientUid?: Maybe<Scalars['String']['output']>;
  /** Whether patient was enrolled */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** This is used by the new activation flow that creates a patient with only an email address. */
export type EnrollDirectAccessPatientV2 = {
  __typename?: 'EnrollDirectAccessPatientV2';
  /** UID of the enrolled patient */
  patientUid?: Maybe<Scalars['String']['output']>;
  /** Whether patient was enrolled */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** UID of the enrolled user */
  userUid?: Maybe<Scalars['String']['output']>;
};

export type EnrollPatient = {
  __typename?: 'EnrollPatient';
  /** The Patient that was enrolled */
  patient?: Maybe<PatientType>;
  /** Whether patient was enrolled */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Create and immediately activate a patient account for Platgen enrollment.
 *
 * Note: This skips UserPdtData creation, as these Cortex accounts are stubs, and the
 * actual accounts are created in Platgen.
 */
export type EnrollPatientPlatgen = {
  __typename?: 'EnrollPatientPlatgen';
  /** UID of the enrolled patient */
  patientUid?: Maybe<Scalars['String']['output']>;
  /** Whether patient was enrolled */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** UID of the enrolled user */
  userUid?: Maybe<Scalars['String']['output']>;
};

/** Triggers creation of a user from a Solera enrollment ID */
export type EnrollSoleraPatient = {
  __typename?: 'EnrollSoleraPatient';
  /** UID of the care team tied to the patient */
  careTeamUid?: Maybe<Scalars['String']['output']>;
  /** The Patient that was created */
  patient?: Maybe<PatientType>;
  /** Whether patient was created */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Token for using to make follow up calls to finish enrolling */
  token?: Maybe<Scalars['String']['output']>;
};

/** Enrollment tracker result related to a study participant */
export type EnrollmentTrackerResultType = {
  __typename?: 'EnrollmentTrackerResultType';
  answers?: Maybe<Scalars['JSONString']['output']>;
  assessment?: Maybe<AssessmentType>;
  assessmentAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assessmentResultItems?: Maybe<Array<Maybe<AssessmentResultItemType>>>;
  createdAt: Scalars['DateTime']['output'];
  study: LimbixStudyType;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

/** An enumeration. */
export enum EntryType {
  EstimatedEntry = 'ESTIMATED_ENTRY',
  UserEntry = 'USER_ENTRY',
  WearableEntry = 'WEARABLE_ENTRY'
}

/** ExpireOutdatedNudges expires any triggered nudges that are not the most recent nudge in their category. */
export type ExpireOutdatedNudges = {
  __typename?: 'ExpireOutdatedNudges';
  /** Nudges expired by the mutation */
  expiredNudges?: Maybe<Array<Maybe<NudgeOpportunityType>>>;
};

/** Renew a patient's access using an external org signup (JWT) token */
export type ExternalOrganizationAccessRenewal = {
  __typename?: 'ExternalOrganizationAccessRenewal';
  /** The Care Team that was modified */
  careTeam?: Maybe<CareTeamType>;
  /** Whether the patient's access was renewed */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Create a patient account using an external org signup (JWT) token.
 * Note: this mutation currently does not allow users already signed up with an org to sign up again.
 */
export type ExternalOrganizationSignup = {
  __typename?: 'ExternalOrganizationSignup';
  /** The Care Team that was created */
  careTeam?: Maybe<CareTeamType>;
  /** Whether patient was created */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Firebase Cloud Messaging device description */
export type FcmDeviceType = {
  __typename?: 'FCMDeviceType';
  /** Inactive devices will not be sent notifications */
  active: Scalars['Boolean']['output'];
  registrationId: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

/** GraphQL type for feature flag assignments */
export type FeatureFlagAssignmentType = {
  __typename?: 'FeatureFlagAssignmentType';
  /** Timestamp when this variant was assigned to the user */
  assignedAt: Scalars['DateTime']['output'];
  /** Timestamp when this record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Feature flag name/identifier */
  name: Scalars['String']['output'];
  pdtSlug?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Assigned variant (e.g., 'control', 'variantA'). Null if flag is disabled. */
  variant?: Maybe<Scalars['String']['output']>;
};

/** Free-form text entered by a user */
export type FreeFormTextType = {
  __typename?: 'FreeFormTextType';
  createdAt: Scalars['DateTime']['output'];
  /** Deny list items that are matched by the free-form text */
  denyListMatches?: Maybe<Array<Maybe<DenyListItemType>>>;
  isEncrypted?: Maybe<Scalars['Boolean']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  sensitiveValue?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  value?: Maybe<Scalars['String']['output']>;
};

/** Generate case report forms for a study participant */
export type GenerateCaseReportForm = {
  __typename?: 'GenerateCaseReportForm';
  /** The url for the case report form */
  url?: Maybe<Scalars['String']['output']>;
};

/** Generate case report forms for a study */
export type GenerateCaseReportForms = {
  __typename?: 'GenerateCaseReportForms';
  /** The url for the case report forms */
  url?: Maybe<Scalars['String']['output']>;
};

/** Generate centralized change log CSV */
export type GenerateCentralizedChangeLogCsv = {
  __typename?: 'GenerateCentralizedChangeLogCSV';
  /** The url for the centralized change log csv */
  url?: Maybe<Scalars['String']['output']>;
};

/** Generate clinical concerns csv */
export type GenerateClinicalConcernsCsv = {
  __typename?: 'GenerateClinicalConcernsCSV';
  /** The url for the clinical concerns csv */
  url?: Maybe<Scalars['String']['output']>;
};

/** Get a list of urls for downloading access code CSV files */
export type GetAccessCodeCsvUrls = {
  __typename?: 'GetAccessCodeCsvUrls';
  /** List of pre-signed AWS S3 urls containing pre-generated access codes */
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Grant Provider Portal access to a practitioner */
export type GrantProviderPortalAccess = {
  __typename?: 'GrantProviderPortalAccess';
  /** Whether the practitioner's Provider Portal access was granted successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * M2M mutation for Entropy to ingest wearable sleep diary entries.
 * Validates the payload synchronously and dispatches creation to a Celery worker.
 */
export type IngestSleepDiary = {
  __typename?: 'IngestSleepDiary';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type IngestSleepDiaryInput = {
  /** Whether user was awake during the night */
  awakeDuringNight: Scalars['Boolean']['input'];
  /** Date that the sleep diary entry was logged */
  date: Scalars['DateTime']['input'];
  /** Things that disturbed user during sleep */
  disturbances: Array<InputMaybe<Scalars['String']['input']>>;
  /** Type of entry */
  entryType: EntryType;
  /** Time user got into bed */
  getIntoBedTime: Scalars['DateTime']['input'];
  /** Time user got out of bed */
  getOutOfBedTime: Scalars['DateTime']['input'];
  /** PDT UID */
  pdtUid: Scalars['String']['input'];
  /** User's rest level */
  restLevel: Scalars['Int']['input'];
  /** Whether user rose immediately */
  riseImmediately: Scalars['Boolean']['input'];
  /** Sleep efficiency */
  sleepEfficiency: Scalars['Float']['input'];
  /** Total time user was asleep, in minutes */
  timeAsleep: Scalars['Int']['input'];
  /** Time user was awake during the night, in minutes */
  timeAwake: Scalars['Int']['input'];
  /** Total time user was in bed, in minutes */
  timeInBed: Scalars['Int']['input'];
  /** Time it took user to fall asleep, in minutes */
  timeToFallAsleep: Scalars['Int']['input'];
  /** Time zone to set for sleep diary entry */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Time user tried to fall asleep */
  tryToSleepTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** LimbixUser UID */
  userId: Scalars['String']['input'];
  /** Whether user slept at all this night */
  userSlept: Scalars['Boolean']['input'];
  /** Time user woke up */
  wakeUpTime: Scalars['DateTime']['input'];
};

/**
 * Single data point for insights visualization.
 * Represents aggregated anxiety data for a time period (day/week/month).
 */
export type InsightsDataPointType = {
  __typename?: 'InsightsDataPointType';
  /** Average anxiety level for this period (1-5 scale) */
  averageAnxiety?: Maybe<Scalars['Float']['output']>;
  /** Start date of the period (day/week start/month start) */
  date: Scalars['Date']['output'];
  /** Number of unique days with data in this period */
  entryCount: Scalars['Int']['output'];
};

/** Response type for insights data with navigation information. */
export type InsightsResponseType = {
  __typename?: 'InsightsResponseType';
  /** End date of the current visible period (time window boundary, not user data) */
  currentPeriodEnd: Scalars['Date']['output'];
  /** Start date of the current visible period (time window boundary, not user data) */
  currentPeriodStart: Scalars['Date']['output'];
  /** Array of data points for visualization */
  dataPoints: Array<Maybe<InsightsDataPointType>>;
  /** Whether user has sufficient anxiety data (≥2 check-ins with anxiety responses) to display meaningful insights */
  hasSufficientData: Scalars['Boolean']['output'];
};

/** Intercom Identity Verification token response */
export type IntercomTokenType = {
  __typename?: 'IntercomTokenType';
  /** JWT token for Intercom Identity Verification */
  token?: Maybe<Scalars['String']['output']>;
};

/** Issue a new access code for a practitioner's a pdt */
export type IssueNewAccessCode = {
  __typename?: 'IssueNewAccessCode';
  /** Whether the practitioner's new access code was sent to them successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum LanguageType {
  En = 'EN',
  Es = 'ES',
  Ko = 'KO',
  Unspecified = 'Unspecified'
}

/** An enumeration. */
export enum LibraryItemCategory {
  /** Provider Portal */
  ProviderPortal = 'PROVIDER_PORTAL',
  /** Resources */
  Resources = 'RESOURCES',
  /** SparkRx */
  Sparkrx = 'SPARKRX'
}

/** Library item */
export type LibraryItemType = {
  __typename?: 'LibraryItemType';
  /** which card */
  cardTitle?: Maybe<Scalars['String']['output']>;
  category: LibraryItemCategory;
  link: Scalars['String']['output'];
  pdt?: Maybe<PdtType>;
  subcategory: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/**
 * Custom JWT refresh mutation for Limbix.
 *
 * Extends graphql_jwt's Refresh mutation to use Limbix-specific refresh tokens
 * that include client_type and PDT associations. This allows for proper tracking
 * and validation of refresh tokens across different client types.
 *
 * Key differences from graphql_jwt.Refresh:
 * - Uses limbix_refresh_token_lazy instead of refresh_token_lazy
 * - Preserves client_type and PDT across token refreshes
 * - Ignores Authorization header to prevent interference from expired tokens
 */
export type LimbixRefresh = {
  __typename?: 'LimbixRefresh';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** Limbix Study */
export type LimbixStudyType = {
  __typename?: 'LimbixStudyType';
  appAccessDurationDays?: Maybe<Scalars['Float']['output']>;
  canChangeStudy?: Maybe<Scalars['Boolean']['output']>;
  canDeleteParticipants?: Maybe<Scalars['Boolean']['output']>;
  canModifyParticipants?: Maybe<Scalars['Boolean']['output']>;
  canViewStudy?: Maybe<Scalars['Boolean']['output']>;
  caseReportFormTemplate?: Maybe<Scalars['String']['output']>;
  clinicalConcernAssessment?: Maybe<AssessmentType>;
  clinicianReportAssessment?: Maybe<AssessmentType>;
  coInvestigators: Array<UserType>;
  deteriorationAlerts?: Maybe<Array<Maybe<Scalars['JSONString']['output']>>>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  enrollmentTrackerAssessment?: Maybe<AssessmentType>;
  isBlinded?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageType>>>;
  minimumVersionNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pdt: PdtType;
  principalInvestigators: Array<UserType>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studyArms?: Maybe<Array<Maybe<StudyArmType>>>;
  studyCoordinators: Array<UserType>;
  studyParticipants?: Maybe<Array<Maybe<StudyParticipantType>>>;
  textEncryptionEnabled: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum LimbixUserAccountType {
  /** Adult account */
  Adult = 'ADULT',
  /** Child account */
  Child = 'CHILD',
  /** Parent account */
  Parent = 'PARENT',
  /** Research account */
  Research = 'RESEARCH'
}

/** An enumeration. */
export enum LimbixUserGender {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M',
  /** Other */
  O = 'O',
  /** Non-Binary */
  X = 'X'
}

/** An enumeration. */
export enum LimbixUserLanguage {
  /** US English */
  En = 'EN',
  /** Spanish / Español */
  Es = 'ES',
  /** Korean */
  Ko = 'KO',
  /** Unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** An enumeration. */
export enum LimbixUserLocalTimezone {
  /** Africa/Abidjan */
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AfricaAccra = 'AFRICA_ACCRA',
  /** Africa/Addis_Ababa */
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AfricaAlgiers = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AfricaAsmara = 'AFRICA_ASMARA',
  /** Africa/Asmera */
  AfricaAsmera = 'AFRICA_ASMERA',
  /** Africa/Bamako */
  AfricaBamako = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AfricaBangui = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AfricaBanjul = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AfricaBissau = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AfricaCairo = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AfricaCeuta = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AfricaConakry = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AfricaDakar = 'AFRICA_DAKAR',
  /** Africa/Dar_es_Salaam */
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AfricaDouala = 'AFRICA_DOUALA',
  /** Africa/El_Aaiun */
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AfricaFreetown = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AfricaGaborone = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AfricaHarare = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AfricaJuba = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AfricaKampala = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AfricaKigali = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AfricaKinshasa = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AfricaLagos = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AfricaLome = 'AFRICA_LOME',
  /** Africa/Luanda */
  AfricaLuanda = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AfricaLusaka = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AfricaMalabo = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AfricaMaputo = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AfricaMaseru = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AfricaMbabane = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AfricaMonrovia = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AfricaNairobi = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AfricaNiamey = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto-Novo */
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao_Tome */
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  /** Africa/Timbuktu */
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  /** Africa/Tripoli */
  AfricaTripoli = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AfricaTunis = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AmericaAdak = 'AMERICA_ADAK',
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AmericaAntigua = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  /** America/Argentina/Buenos_Aires */
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina/Catamarca */
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina/ComodRivadavia */
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  /** America/Argentina/Cordoba */
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina/Jujuy */
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina/La_Rioja */
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina/Mendoza */
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina/Rio_Gallegos */
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina/Salta */
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina/San_Juan */
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina/San_Luis */
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina/Tucuman */
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina/Ushuaia */
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AmericaAruba = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AmericaAsuncion = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  /** America/Atka */
  AmericaAtka = 'AMERICA_ATKA',
  /** America/Bahia */
  AmericaBahia = 'AMERICA_BAHIA',
  /** America/Bahia_Banderas */
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AmericaBarbados = 'AMERICA_BARBADOS',
  /** America/Belem */
  AmericaBelem = 'AMERICA_BELEM',
  /** America/Belize */
  AmericaBelize = 'AMERICA_BELIZE',
  /** America/Blanc-Sablon */
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  /** America/Boa_Vista */
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AmericaBogota = 'AMERICA_BOGOTA',
  /** America/Boise */
  AmericaBoise = 'AMERICA_BOISE',
  /** America/Buenos_Aires */
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  /** America/Cambridge_Bay */
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo_Grande */
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AmericaCancun = 'AMERICA_CANCUN',
  /** America/Caracas */
  AmericaCaracas = 'AMERICA_CARACAS',
  /** America/Catamarca */
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  /** America/Cayenne */
  AmericaCayenne = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AmericaCayman = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AmericaChicago = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  /** America/Ciudad_Juarez */
  AmericaCiudadJuarez = 'AMERICA_CIUDAD_JUAREZ',
  /** America/Coral_Harbour */
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  /** America/Cordoba */
  AmericaCordoba = 'AMERICA_CORDOBA',
  /** America/Costa_Rica */
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  /** America/Coyhaique */
  AmericaCoyhaique = 'AMERICA_COYHAIQUE',
  /** America/Creston */
  AmericaCreston = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AmericaCuiaba = 'AMERICA_CUIABA',
  /** America/Curacao */
  AmericaCuracao = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AmericaDawson = 'AMERICA_DAWSON',
  /** America/Dawson_Creek */
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AmericaDenver = 'AMERICA_DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA_DETROIT',
  /** America/Dominica */
  AmericaDominica = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AmericaEdmonton = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  /** America/El_Salvador */
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  /** America/Ensenada */
  AmericaEnsenada = 'AMERICA_ENSENADA',
  /** America/Fortaleza */
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  /** America/Fort_Nelson */
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  /** America/Fort_Wayne */
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  /** America/Glace_Bay */
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AmericaGodthab = 'AMERICA_GODTHAB',
  /** America/Goose_Bay */
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  /** America/Grand_Turk */
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AmericaGrenada = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AmericaGuyana = 'AMERICA_GUYANA',
  /** America/Halifax */
  AmericaHalifax = 'AMERICA_HALIFAX',
  /** America/Havana */
  AmericaHavana = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana/Tell_City */
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AmericaInuvik = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AmericaIqaluit = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AmericaJamaica = 'AMERICA_JAMAICA',
  /** America/Jujuy */
  AmericaJujuy = 'AMERICA_JUJUY',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA_JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Knox_IN */
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  /** America/Kralendijk */
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  /** America/La_Paz */
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AmericaLima = 'AMERICA_LIMA',
  /** America/Los_Angeles */
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  /** America/Louisville */
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  /** America/Lower_Princes */
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AmericaMaceio = 'AMERICA_MACEIO',
  /** America/Managua */
  AmericaManagua = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AmericaManaus = 'AMERICA_MANAUS',
  /** America/Marigot */
  AmericaMarigot = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  /** America/Mendoza */
  AmericaMendoza = 'AMERICA_MENDOZA',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AmericaMerida = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  /** America/Mexico_City */
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AmericaMiquelon = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AmericaMoncton = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AmericaMonterrey = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AmericaMontreal = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AmericaNassau = 'AMERICA_NASSAU',
  /** America/New_York */
  AmericaNewYork = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AmericaNipigon = 'AMERICA_NIPIGON',
  /** America/Nome */
  AmericaNome = 'AMERICA_NOME',
  /** America/Noronha */
  AmericaNoronha = 'AMERICA_NORONHA',
  /** America/North_Dakota/Beulah */
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North_Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North_Dakota/New_Salem */
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AmericaNuuk = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AmericaOjinaga = 'AMERICA_OJINAGA',
  /** America/Panama */
  AmericaPanama = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA_PHOENIX',
  /** America/Porto_Acre */
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  /** America/Porto_Velho */
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  /** America/Port-au-Prince */
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port_of_Spain */
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto_Rico */
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  /** America/Punta_Arenas */
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy_River */
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  /** America/Rankin_Inlet */
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AmericaRecife = 'AMERICA_RECIFE',
  /** America/Regina */
  AmericaRegina = 'AMERICA_REGINA',
  /** America/Resolute */
  AmericaResolute = 'AMERICA_RESOLUTE',
  /** America/Rio_Branco */
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  /** America/Rosario */
  AmericaRosario = 'AMERICA_ROSARIO',
  /** America/Santarem */
  AmericaSantarem = 'AMERICA_SANTAREM',
  /** America/Santa_Isabel */
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  /** America/Santiago */
  AmericaSantiago = 'AMERICA_SANTIAGO',
  /** America/Santo_Domingo */
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao_Paulo */
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA_SHIPROCK',
  /** America/Sitka */
  AmericaSitka = 'AMERICA_SITKA',
  /** America/St_Barthelemy */
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  /** America/St_Johns */
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  /** America/St_Kitts */
  AmericaStKitts = 'AMERICA_ST_KITTS',
  /** America/St_Lucia */
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  /** America/St_Thomas */
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  /** America/St_Vincent */
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  /** America/Swift_Current */
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AmericaThule = 'AMERICA_THULE',
  /** America/Thunder_Bay */
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AmericaTijuana = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AmericaToronto = 'AMERICA_TORONTO',
  /** America/Tortola */
  AmericaTortola = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AmericaVancouver = 'AMERICA_VANCOUVER',
  /** America/Virgin */
  AmericaVirgin = 'AMERICA_VIRGIN',
  /** America/Whitehorse */
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  /** Antarctica/DumontDUrville */
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  /** Antarctica/McMurdo */
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  /** Antarctica/South_Pole */
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  /** Antarctica/Syowa */
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  AsiaAden = 'ASIA_ADEN',
  /** Asia/Almaty */
  AsiaAlmaty = 'ASIA_ALMATY',
  /** Asia/Amman */
  AsiaAmman = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  AsiaAnadyr = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  AsiaAqtau = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  AsiaAqtobe = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  AsiaAshgabat = 'ASIA_ASHGABAT',
  /** Asia/Ashkhabad */
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  /** Asia/Atyrau */
  AsiaAtyrau = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  AsiaBaghdad = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  AsiaBahrain = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  AsiaBaku = 'ASIA_BAKU',
  /** Asia/Bangkok */
  AsiaBangkok = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  AsiaBarnaul = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  AsiaBeirut = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  AsiaBishkek = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  AsiaBrunei = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  AsiaCalcutta = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  AsiaChita = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  /** Asia/Chongqing */
  AsiaChongqing = 'ASIA_CHONGQING',
  /** Asia/Chungking */
  AsiaChungking = 'ASIA_CHUNGKING',
  /** Asia/Colombo */
  AsiaColombo = 'ASIA_COLOMBO',
  /** Asia/Dacca */
  AsiaDacca = 'ASIA_DACCA',
  /** Asia/Damascus */
  AsiaDamascus = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  AsiaDhaka = 'ASIA_DHAKA',
  /** Asia/Dili */
  AsiaDili = 'ASIA_DILI',
  /** Asia/Dubai */
  AsiaDubai = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  AsiaDushanbe = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  AsiaGaza = 'ASIA_GAZA',
  /** Asia/Harbin */
  AsiaHarbin = 'ASIA_HARBIN',
  /** Asia/Hebron */
  AsiaHebron = 'ASIA_HEBRON',
  /** Asia/Hong_Kong */
  AsiaHongKong = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  AsiaHovd = 'ASIA_HOVD',
  /** Asia/Ho_Chi_Minh */
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  AsiaIstanbul = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  AsiaJakarta = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  AsiaJayapura = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  AsiaJerusalem = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  AsiaKabul = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  AsiaKarachi = 'ASIA_KARACHI',
  /** Asia/Kashgar */
  AsiaKashgar = 'ASIA_KASHGAR',
  /** Asia/Kathmandu */
  AsiaKathmandu = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  AsiaKatmandu = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  AsiaKhandyga = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  AsiaKolkata = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala_Lumpur */
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  AsiaKuching = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  AsiaKuwait = 'ASIA_KUWAIT',
  /** Asia/Macao */
  AsiaMacao = 'ASIA_MACAO',
  /** Asia/Macau */
  AsiaMacau = 'ASIA_MACAU',
  /** Asia/Magadan */
  AsiaMagadan = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  AsiaMakassar = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  AsiaManila = 'ASIA_MANILA',
  /** Asia/Muscat */
  AsiaMuscat = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  AsiaNicosia = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  AsiaOmsk = 'ASIA_OMSK',
  /** Asia/Oral */
  AsiaOral = 'ASIA_ORAL',
  /** Asia/Phnom_Penh */
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  AsiaPontianak = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  AsiaPyongyang = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  AsiaQatar = 'ASIA_QATAR',
  /** Asia/Qostanay */
  AsiaQostanay = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  /** Asia/Rangoon */
  AsiaRangoon = 'ASIA_RANGOON',
  /** Asia/Riyadh */
  AsiaRiyadh = 'ASIA_RIYADH',
  /** Asia/Saigon */
  AsiaSaigon = 'ASIA_SAIGON',
  /** Asia/Sakhalin */
  AsiaSakhalin = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  AsiaSamarkand = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  AsiaSeoul = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  AsiaShanghai = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  AsiaSingapore = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  AsiaTaipei = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  AsiaTashkent = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  AsiaTbilisi = 'ASIA_TBILISI',
  /** Asia/Tehran */
  AsiaTehran = 'ASIA_TEHRAN',
  /** Asia/Tel_Aviv */
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  /** Asia/Thimbu */
  AsiaThimbu = 'ASIA_THIMBU',
  /** Asia/Thimphu */
  AsiaThimphu = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  AsiaTokyo = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  AsiaTomsk = 'ASIA_TOMSK',
  /** Asia/Ujung_Pandang */
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  /** Asia/Ulaanbaatar */
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  /** Asia/Ulan_Bator */
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  /** Asia/Urumqi */
  AsiaUrumqi = 'ASIA_URUMQI',
  /** Asia/Ust-Nera */
  AsiaUstNera = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  AsiaVientiane = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  AsiaYakutsk = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  AsiaYangon = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  AsiaYerevan = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  AtlanticAzores = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  AtlanticCanary = 'ATLANTIC_CANARY',
  /** Atlantic/Cape_Verde */
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faeroe */
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  /** Atlantic/Faroe */
  AtlanticFaroe = 'ATLANTIC_FAROE',
  /** Atlantic/Jan_Mayen */
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  /** Atlantic/Madeira */
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South_Georgia */
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  AtlanticStanley = 'ATLANTIC_STANLEY',
  /** Atlantic/St_Helena */
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA_ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken_Hill */
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Canberra */
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  /** Australia/Currie */
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA_HOBART',
  /** Australia/LHI */
  AustraliaLhi = 'AUSTRALIA_LHI',
  /** Australia/Lindeman */
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord_Howe */
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA_NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA_NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA_PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA_WEST',
  /** Australia/Yancowinna */
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  /** Brazil/Acre */
  BrazilAcre = 'BRAZIL_ACRE',
  /** Brazil/DeNoronha */
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  /** Brazil/East */
  BrazilEast = 'BRAZIL_EAST',
  /** Brazil/West */
  BrazilWest = 'BRAZIL_WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA_ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA_CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA_EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA_MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA_PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA_YUKON',
  /** CET */
  Cet = 'CET',
  /** Chile/Continental */
  ChileContinental = 'CHILE_CONTINENTAL',
  /** Chile/EasterIsland */
  ChileEasterisland = 'CHILE_EASTERISLAND',
  /** CST6CDT */
  Cst6Cdt = 'CST6CDT',
  /** Cuba */
  Cuba = 'CUBA',
  /** EET */
  Eet = 'EET',
  /** Egypt */
  Egypt = 'EGYPT',
  /** Eire */
  Eire = 'EIRE',
  /** EST */
  Est = 'EST',
  /** EST5EDT */
  Est5Edt = 'EST5EDT',
  /** Etc/GMT */
  EtcGmt = 'ETC_GMT',
  /** Etc/GMT0 */
  EtcGmt0 = 'ETC_GMT0',
  /** Etc/GMT+0 */
  EtcGmt_0 = 'ETC_GMT_0',
  /** Etc/GMT-0 */
  EtcGmt_0_406 = 'ETC_GMT_0_406',
  /** Etc/GMT+1 */
  EtcGmt_1 = 'ETC_GMT_1',
  /** Etc/GMT-1 */
  EtcGmt_1_407 = 'ETC_GMT_1_407',
  /** Etc/GMT+2 */
  EtcGmt_2 = 'ETC_GMT_2',
  /** Etc/GMT-2 */
  EtcGmt_2_413 = 'ETC_GMT_2_413',
  /** Etc/GMT+3 */
  EtcGmt_3 = 'ETC_GMT_3',
  /** Etc/GMT-3 */
  EtcGmt_3_414 = 'ETC_GMT_3_414',
  /** Etc/GMT+4 */
  EtcGmt_4 = 'ETC_GMT_4',
  /** Etc/GMT-4 */
  EtcGmt_4_415 = 'ETC_GMT_4_415',
  /** Etc/GMT+5 */
  EtcGmt_5 = 'ETC_GMT_5',
  /** Etc/GMT-5 */
  EtcGmt_5_416 = 'ETC_GMT_5_416',
  /** Etc/GMT+6 */
  EtcGmt_6 = 'ETC_GMT_6',
  /** Etc/GMT-6 */
  EtcGmt_6_417 = 'ETC_GMT_6_417',
  /** Etc/GMT+7 */
  EtcGmt_7 = 'ETC_GMT_7',
  /** Etc/GMT-7 */
  EtcGmt_7_418 = 'ETC_GMT_7_418',
  /** Etc/GMT+8 */
  EtcGmt_8 = 'ETC_GMT_8',
  /** Etc/GMT-8 */
  EtcGmt_8_419 = 'ETC_GMT_8_419',
  /** Etc/GMT+9 */
  EtcGmt_9 = 'ETC_GMT_9',
  /** Etc/GMT-9 */
  EtcGmt_9_420 = 'ETC_GMT_9_420',
  /** Etc/GMT+10 */
  EtcGmt_10 = 'ETC_GMT_10',
  /** Etc/GMT-10 */
  EtcGmt_10_408 = 'ETC_GMT_10_408',
  /** Etc/GMT+11 */
  EtcGmt_11 = 'ETC_GMT_11',
  /** Etc/GMT-11 */
  EtcGmt_11_409 = 'ETC_GMT_11_409',
  /** Etc/GMT+12 */
  EtcGmt_12 = 'ETC_GMT_12',
  /** Etc/GMT-12 */
  EtcGmt_12_410 = 'ETC_GMT_12_410',
  /** Etc/GMT-13 */
  EtcGmt_13 = 'ETC_GMT_13',
  /** Etc/GMT-14 */
  EtcGmt_14 = 'ETC_GMT_14',
  /** Etc/Greenwich */
  EtcGreenwich = 'ETC_GREENWICH',
  /** Etc/UCT */
  EtcUct = 'ETC_UCT',
  /** Etc/Universal */
  EtcUniversal = 'ETC_UNIVERSAL',
  /** Etc/UTC */
  EtcUtc = 'ETC_UTC',
  /** Etc/Zulu */
  EtcZulu = 'ETC_ZULU',
  /** Europe/Amsterdam */
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EuropeAndorra = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EuropeAthens = 'EUROPE_ATHENS',
  /** Europe/Belfast */
  EuropeBelfast = 'EUROPE_BELFAST',
  /** Europe/Belgrade */
  EuropeBelgrade = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EuropeBerlin = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EuropeBrussels = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EuropeBucharest = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EuropeBudapest = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EuropeBusingen = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EuropeChisinau = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EuropeDublin = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EuropeHelsinki = 'EUROPE_HELSINKI',
  /** Europe/Isle_of_Man */
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EuropeJersey = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EuropeKiev = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EuropeKirov = 'EUROPE_KIROV',
  /** Europe/Kyiv */
  EuropeKyiv = 'EUROPE_KYIV',
  /** Europe/Lisbon */
  EuropeLisbon = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EuropeLondon = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EuropeMadrid = 'EUROPE_MADRID',
  /** Europe/Malta */
  EuropeMalta = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EuropeMinsk = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EuropeMonaco = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EuropeMoscow = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EuropeNicosia = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EuropeOslo = 'EUROPE_OSLO',
  /** Europe/Paris */
  EuropeParis = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EuropePodgorica = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EuropePrague = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EuropeRiga = 'EUROPE_RIGA',
  /** Europe/Rome */
  EuropeRome = 'EUROPE_ROME',
  /** Europe/Samara */
  EuropeSamara = 'EUROPE_SAMARA',
  /** Europe/San_Marino */
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EuropeSaratov = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EuropeSkopje = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EuropeSofia = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EuropeTallinn = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EuropeTirane = 'EUROPE_TIRANE',
  /** Europe/Tiraspol */
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  /** Europe/Ulyanovsk */
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EuropeVaduz = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EuropeVatican = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EuropeVienna = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EuropeVilnius = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EuropeWarsaw = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EuropeZagreb = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EuropeZurich = 'EUROPE_ZURICH',
  /** GB */
  Gb = 'GB',
  /** GB-Eire */
  GbEire = 'GB_EIRE',
  /** GMT */
  Gmt = 'GMT',
  /** GMT0 */
  Gmt0 = 'GMT0',
  /** GMT+0 */
  Gmt_0 = 'GMT_0',
  /** GMT-0 */
  Gmt_0_495 = 'GMT_0_495',
  /** Greenwich */
  Greenwich = 'GREENWICH',
  /** Hongkong */
  Hongkong = 'HONGKONG',
  /** HST */
  Hst = 'HST',
  /** Iceland */
  Iceland = 'ICELAND',
  /** Indian/Antananarivo */
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  IndianChagos = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  IndianChristmas = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  IndianCocos = 'INDIAN_COCOS',
  /** Indian/Comoro */
  IndianComoro = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  IndianKerguelen = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  IndianMahe = 'INDIAN_MAHE',
  /** Indian/Maldives */
  IndianMaldives = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  IndianMauritius = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  IndianMayotte = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  IndianReunion = 'INDIAN_REUNION',
  /** Iran */
  Iran = 'IRAN',
  /** Israel */
  Israel = 'ISRAEL',
  /** Jamaica */
  Jamaica = 'JAMAICA',
  /** Japan */
  Japan = 'JAPAN',
  /** Kwajalein */
  Kwajalein = 'KWAJALEIN',
  /** Libya */
  Libya = 'LIBYA',
  /** MET */
  Met = 'MET',
  /** Mexico/BajaNorte */
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  /** Mexico/BajaSur */
  MexicoBajasur = 'MEXICO_BAJASUR',
  /** Mexico/General */
  MexicoGeneral = 'MEXICO_GENERAL',
  /** MST */
  Mst = 'MST',
  /** MST7MDT */
  Mst7Mdt = 'MST7MDT',
  /** Navajo */
  Navajo = 'NAVAJO',
  /** NZ */
  Nz = 'NZ',
  /** NZ-CHAT */
  NzChat = 'NZ_CHAT',
  /** Pacific/Apia */
  PacificApia = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PacificAuckland = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PacificChatham = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PacificChuuk = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PacificEaster = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PacificEfate = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PacificFiji = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PacificGambier = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PacificGuam = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC_HONOLULU',
  /** Pacific/Johnston */
  PacificJohnston = 'PACIFIC_JOHNSTON',
  /** Pacific/Kanton */
  PacificKanton = 'PACIFIC_KANTON',
  /** Pacific/Kiritimati */
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PacificKosrae = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PacificMajuro = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PacificMidway = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PacificNauru = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PacificNiue = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PacificNorfolk = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PacificNoumea = 'PACIFIC_NOUMEA',
  /** Pacific/Pago_Pago */
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PacificPalau = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PacificPohnpei = 'PACIFIC_POHNPEI',
  /** Pacific/Ponape */
  PacificPonape = 'PACIFIC_PONAPE',
  /** Pacific/Port_Moresby */
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PacificSaipan = 'PACIFIC_SAIPAN',
  /** Pacific/Samoa */
  PacificSamoa = 'PACIFIC_SAMOA',
  /** Pacific/Tahiti */
  PacificTahiti = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PacificTarawa = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  /** Pacific/Truk */
  PacificTruk = 'PACIFIC_TRUK',
  /** Pacific/Wake */
  PacificWake = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PacificWallis = 'PACIFIC_WALLIS',
  /** Pacific/Yap */
  PacificYap = 'PACIFIC_YAP',
  /** Poland */
  Poland = 'POLAND',
  /** Portugal */
  Portugal = 'PORTUGAL',
  /** PRC */
  Prc = 'PRC',
  /** PST8PDT */
  Pst8Pdt = 'PST8PDT',
  /** ROC */
  Roc = 'ROC',
  /** ROK */
  Rok = 'ROK',
  /** Singapore */
  Singapore = 'SINGAPORE',
  /** Turkey */
  Turkey = 'TURKEY',
  /** UCT */
  Uct = 'UCT',
  /** Universal */
  Universal = 'UNIVERSAL',
  /** US/Alaska */
  UsAlaska = 'US_ALASKA',
  /** US/Aleutian */
  UsAleutian = 'US_ALEUTIAN',
  /** US/Arizona */
  UsArizona = 'US_ARIZONA',
  /** US/Central */
  UsCentral = 'US_CENTRAL',
  /** US/Eastern */
  UsEastern = 'US_EASTERN',
  /** US/East-Indiana */
  UsEastIndiana = 'US_EAST_INDIANA',
  /** US/Hawaii */
  UsHawaii = 'US_HAWAII',
  /** US/Indiana-Starke */
  UsIndianaStarke = 'US_INDIANA_STARKE',
  /** US/Michigan */
  UsMichigan = 'US_MICHIGAN',
  /** US/Mountain */
  UsMountain = 'US_MOUNTAIN',
  /** US/Pacific */
  UsPacific = 'US_PACIFIC',
  /** US/Samoa */
  UsSamoa = 'US_SAMOA',
  /** UTC */
  Utc = 'UTC',
  /** WET */
  Wet = 'WET',
  /** W-SU */
  WSu = 'W_SU',
  /** Zulu */
  Zulu = 'ZULU'
}

/**
 * Link a Cortex LimbixUser to their Supabase UUID.
 *
 * Called by Vercel after OTP verification to enable Supabase JWT -> Cortex auth.
 * Idempotent: re-linking the same UUID is a no-op.
 *
 * Security:
 *     - Requires operations permission (vercel-auth service JWT)
 *     - Validates UUID format
 *     - Rejects if supabase_id is already set to a different UUID (no silent overwrite)
 *     - DB unique constraint is defense-in-depth for race conditions
 *     - Generic error messages for all failure modes (HIPAA)
 *
 * Args:
 *     limbix_user_id: LimbixUser UID (ShortUUID string).
 *     supabase_id: Supabase auth user UUID (standard UUID string).
 *
 * Returns:
 *     success: True on link or idempotent re-link.
 *
 * Raises:
 *     GraphQLError: Generic "Link failed" on any failure.
 */
export type LinkSupabaseUser = {
  __typename?: 'LinkSupabaseUser';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum LocationCountry {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** \u00c5land Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barth\u00e9lemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia, Plurinational State of */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo, the Democratic Republic of the */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** C\u00f4te d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cape Verde */
  Cv = 'CV',
  /** Cura\u00e7ao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran, Islamic Republic of */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** Korea, Democratic People's Republic of */
  Kp = 'KP',
  /** Korea, Republic of */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova, Republic of */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia, the Former Yugoslav Republic of */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** R\u00e9union */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Swaziland */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan, Province of China */
  Tw = 'TW',
  /** Tanzania, United Republic of */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See (Vatican City State) */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela, Bolivarian Republic of */
  Ve = 'VE',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** Virgin Islands, U.S. */
  Vi = 'VI',
  /** Viet Nam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** An enumeration. */
export enum LocationState {
  /** Alabama */
  Alabama = 'ALABAMA',
  /** Alaska */
  Alaska = 'ALASKA',
  /** Arizona */
  Arizona = 'ARIZONA',
  /** Arkansas */
  Arkansas = 'ARKANSAS',
  /** - */
  A = 'A_',
  /** California */
  California = 'CALIFORNIA',
  /** Colorado */
  Colorado = 'COLORADO',
  /** Connecticut */
  Connecticut = 'CONNECTICUT',
  /** Delaware */
  Delaware = 'DELAWARE',
  /** Florida */
  Florida = 'FLORIDA',
  /** Georgia */
  Georgia = 'GEORGIA',
  /** Hawaii */
  Hawaii = 'HAWAII',
  /** Idaho */
  Idaho = 'IDAHO',
  /** Illinois */
  Illinois = 'ILLINOIS',
  /** Indiana */
  Indiana = 'INDIANA',
  /** Iowa */
  Iowa = 'IOWA',
  /** Kansas */
  Kansas = 'KANSAS',
  /** Kentucky */
  Kentucky = 'KENTUCKY',
  /** Louisiana */
  Louisiana = 'LOUISIANA',
  /** Maine */
  Maine = 'MAINE',
  /** Maryland */
  Maryland = 'MARYLAND',
  /** Massachusetts */
  Massachusetts = 'MASSACHUSETTS',
  /** Michigan */
  Michigan = 'MICHIGAN',
  /** Minnesota */
  Minnesota = 'MINNESOTA',
  /** Mississippi */
  Mississippi = 'MISSISSIPPI',
  /** Missouri */
  Missouri = 'MISSOURI',
  /** Montana */
  Montana = 'MONTANA',
  /** Nebraska */
  Nebraska = 'NEBRASKA',
  /** Nevada */
  Nevada = 'NEVADA',
  /** New Hampshire */
  NewHampshire = 'NEW_HAMPSHIRE',
  /** New Jersey */
  NewJersey = 'NEW_JERSEY',
  /** New Mexico */
  NewMexico = 'NEW_MEXICO',
  /** New York */
  NewYork = 'NEW_YORK',
  /** North Carolina */
  NorthCarolina = 'NORTH_CAROLINA',
  /** North Dakota */
  NorthDakota = 'NORTH_DAKOTA',
  /** Ohio */
  Ohio = 'OHIO',
  /** Oklahoma */
  Oklahoma = 'OKLAHOMA',
  /** Oregon */
  Oregon = 'OREGON',
  /** Pennsylvania */
  Pennsylvania = 'PENNSYLVANIA',
  /** Rhode Island */
  RhodeIsland = 'RHODE_ISLAND',
  /** South Carolina */
  SouthCarolina = 'SOUTH_CAROLINA',
  /** South Dakota */
  SouthDakota = 'SOUTH_DAKOTA',
  /** Tennessee */
  Tennessee = 'TENNESSEE',
  /** Texas */
  Texas = 'TEXAS',
  /** Utah */
  Utah = 'UTAH',
  /** Vermont */
  Vermont = 'VERMONT',
  /** Virginia */
  Virginia = 'VIRGINIA',
  /** Washington */
  Washington = 'WASHINGTON',
  /** West Virginia */
  WestVirginia = 'WEST_VIRGINIA',
  /** Wisconsin */
  Wisconsin = 'WISCONSIN',
  /** Wyoming */
  Wyoming = 'WYOMING'
}

/** Location */
export type LocationType = {
  __typename?: 'LocationType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<LocationCountry>;
  line?: Maybe<Array<Scalars['String']['output']>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<LocationState>;
  /** The address as a single string */
  text?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/**
 * LogEvent logs an event sent from a pdt for a given care team and creates and/or expires nudge opportunities affected
 * by the event.
 */
export type LogEvent = {
  __typename?: 'LogEvent';
  /** Successfully logged event */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** MarkNudgesSeen marks nudges in patient inbox as seen. */
export type MarkNudgesSeen = {
  __typename?: 'MarkNudgesSeen';
  /** Successfully marked nudges seen */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mark a study participant as Lost to Follow-up */
export type MarkParticipantAsLost = {
  __typename?: 'MarkParticipantAsLost';
  /** Whether the study participant was marked as lost to follow-up successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mark a study participant as a screen fail */
export type MarkParticipantAsScreenFail = {
  __typename?: 'MarkParticipantAsScreenFail';
  /** Whether the study participant was marked as screen fail successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Mark a tutorial as completed or skipped by the current user.
 * Updates the record with completed_at timestamp (server time).
 * Once completed_at is set, the tutorial will not show again for this user.
 * Server time is always used as the source of truth.
 */
export type MarkTutorialAsCompleted = {
  __typename?: 'MarkTutorialAsCompleted';
  /** The updated tutorial view record */
  tutorialView?: Maybe<TutorialViewType>;
};

/**
 * Mark a tutorial as first seen by the current user.
 * Creates a record with first_seen_at (server timestamp) when user first sees the tutorial.
 * If record already exists, returns it without modification (idempotent).
 */
export type MarkTutorialAsSeen = {
  __typename?: 'MarkTutorialAsSeen';
  /** The created tutorial view record */
  tutorialView?: Maybe<TutorialViewType>;
};

/** Result of looking up a Cortex user for Supabase migration. */
export type MigrationLookupResultType = {
  __typename?: 'MigrationLookupResultType';
  /** True if supabase_id is already set */
  alreadyLinked?: Maybe<Scalars['Boolean']['output']>;
  /** Active care team memberships to provision as entitlements */
  careTeams?: Maybe<Array<Maybe<CareTeamEntitlementType>>>;
  /** LimbixUser UID (ShortUUID) */
  limbixUserId?: Maybe<Scalars['String']['output']>;
};

/** (Deprecated) Mood log that a user creates during use of a PDT */
export type MoodLogType = {
  __typename?: 'MoodLogType';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  extraData?: Maybe<Scalars['JSONString']['output']>;
  mood?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Activate study participant */
  activateParticipant?: Maybe<ActivateParticipant>;
  /** Activate a user by access code */
  activateUserByAccessCode?: Maybe<ActivateUserByAccessCode>;
  /** Add a study CoInvestigator to a study */
  addStudyCoInvestigator?: Maybe<AddStudyCoInvestigator>;
  /** Add a study coordinator to a study */
  addStudyCoordinator?: Maybe<AddStudyCoordinator>;
  /** Assign a clinician report to a clinical concern */
  assignClinicianReport?: Maybe<AssignClinicianReport>;
  /** Cancel a periodic push notification */
  cancelPeriodicPushNotification?: Maybe<CancelPeriodicPushNotification>;
  /** Cancel periodic push notifications by type */
  cancelPeriodicPushNotificationsByType?: Maybe<CancelPeriodicPushNotificationByType>;
  /** Cancel a push notification */
  cancelPushNotification?: Maybe<CancelPushNotification>;
  /** Cancel push notifications by type */
  cancelPushNotificationsByType?: Maybe<CancelPushNotificationsByType>;
  /** Mark when an assignment was completed */
  completeAssignment?: Maybe<CompleteAssignment>;
  /** Complete a study participant */
  completeParticipant?: Maybe<CompleteParticipant>;
  /** Mark when a research assignment was completed */
  completeResearchAssignment?: Maybe<CompleteResearchAssignment>;
  /** Create a new assessment */
  createAssessment?: Maybe<CreateAssessment>;
  /** Create a BA task */
  createBehavioralActivationTask?: Maybe<CreateBehavioralActivationTask>;
  /** Create the base Clinical Concern object with necessary data */
  createClinicalConcern?: Maybe<CreateClinicalConcern>;
  /** Create a free-form text */
  createFreeFormText?: Maybe<CreateFreeFormText>;
  /** Create clinical concerns with mock data */
  createMockClinicalConcerns?: Maybe<CreateMockClinicalConcerns>;
  /** Create mock assignments for a study based on its assignment schedules */
  createMockStudyAssignments?: Maybe<CreateMockStudyAssignments>;
  /** Create a mood log */
  createMoodLog?: Maybe<CreateMoodLog>;
  /** Create a new order */
  createOrder?: Maybe<CreateOrder>;
  /** Create a new order from Provider Portal */
  createOrderWithProviderPortal?: Maybe<CreateOrderWithProviderPortal>;
  /** Create a new order from web form */
  createOrderWithWebForm?: Maybe<CreateOrderWithWebForm>;
  /** Create a Sci2Data */
  createSci2Data?: Maybe<CreateSci2Data>;
  /** Create a SleepioProgressReview */
  createSleepioProgressReview?: Maybe<CreateSleepioProgressReview>;
  /** Create a Sleepio sleep diary */
  createSleepioSleepDiary?: Maybe<CreateSleepioSleepDiary>;
  /** Create totp authenticator for current user */
  createTotpAuthenticator?: Maybe<CreateTotpAuthenticator>;
  /** Create a new user activity log */
  createUserActivityLog?: Maybe<CreateUserActivityLog>;
  /** Create a user log */
  createUserLog?: Maybe<CreateUserLog>;
  /** Create a new order from Xealth */
  createXealthOrder?: Maybe<CreateXealthOrder>;
  /** Decode an organization signup token */
  decodeOrganizationSignupToken?: Maybe<DecodeOrganizationSignupToken>;
  /** Delete an existing BA task */
  deleteBehavioralActivationTask?: Maybe<DeleteBehavioralActivationTask>;
  /** Delete a clinical concern */
  deleteClinicalConcern?: Maybe<DeleteClinicalConcern>;
  /** Delete a mood log */
  deleteMoodLog?: Maybe<DeleteMoodLog>;
  /** Delete study participant */
  deleteParticipant?: Maybe<DeleteParticipant>;
  /** Delete a Sci2Data */
  deleteSci2Data?: Maybe<DeleteSci2Data>;
  /** Delete a SleepioProgressReview */
  deleteSleepioProgressReview?: Maybe<DeleteSleepioProgressReview>;
  /** Delete a Sleepio sleep diary */
  deleteSleepioSleepDiary?: Maybe<DeleteSleepioSleepDiary>;
  /** Delete a study assignment schedule */
  deleteStudyAssignmentSchedule?: Maybe<DeleteStudyAssignmentSchedule>;
  /** Delete an user activity log */
  deleteUserActivityLog?: Maybe<DeleteUserActivityLog>;
  /** Delete a user log */
  deleteUserLog?: Maybe<DeleteUserLog>;
  /** Delete a user's reminder preference */
  deleteUserReminder?: Maybe<DeleteUserReminder>;
  /** Revoke a patient's mobile access and mobile refresh tokens */
  discontinueCare?: Maybe<DiscontinueCare>;
  /** Drop a study participant */
  dropParticipant?: Maybe<DropParticipant>;
  /** Edit a pre-existing assessment */
  editAssessment?: Maybe<EditAssessment>;
  /** Edit a user's parents */
  editParents?: Maybe<EditParents>;
  /** Edit a Study Participant's Notes, ID, Language, Account Type, First Name, Last Name, Gender, Date of Birth, and/or Referral Source */
  editParticipantData?: Maybe<EditParticipantData>;
  /** Edit a patient's info */
  editPatientInfo?: Maybe<EditPatientInfo>;
  /** Edit a patient's notes */
  editPractitionerNotes?: Maybe<EditPractitionerNotes>;
  /** Create new commercial patient and enroll them with PDT */
  enrollDirectAccessPatient?: Maybe<EnrollDirectAccessPatient>;
  /** Create new commercial patient and enroll them with only their email address */
  enrollDirectAccessPatientV2?: Maybe<EnrollDirectAccessPatientV2>;
  /** Create new patient and enroll them with PDT */
  enrollPatient?: Maybe<EnrollPatient>;
  /** Create and activates a patient account for platform-generated enrollment */
  enrollPatientPlatgen?: Maybe<EnrollPatientPlatgen>;
  /** Create and enroll a new user from Solera */
  enrollSoleraPatient?: Maybe<EnrollSoleraPatient>;
  /** Expire triggered nudges that are not the most recent nudge in their category */
  expireOutdatedNudges?: Maybe<ExpireOutdatedNudges>;
  /** Renew a patient's access to a PDT using an external organization token */
  externalOrganizationAccessRenewal?: Maybe<ExternalOrganizationAccessRenewal>;
  /** Create a user account using an external organization signup token */
  externalOrganizationSignup?: Maybe<ExternalOrganizationSignup>;
  /** Generate a participant's case report form */
  generateCaseReportForm?: Maybe<GenerateCaseReportForm>;
  /** Generate the case report forms for all participants in a study */
  generateCaseReportForms?: Maybe<GenerateCaseReportForms>;
  /** Generate the centralized change log for all study objects */
  generateCentralizedChangeLogCsv?: Maybe<GenerateCentralizedChangeLogCsv>;
  /** Generate the clinical concerns for all participants in a study */
  generateClinicalConcernsCsv?: Maybe<GenerateClinicalConcernsCsv>;
  /** Get a list of urls for downloading access code CSV files */
  getAccessCodeCsvUrls?: Maybe<GetAccessCodeCsvUrls>;
  /** Grant a practitioner Provider Portal access */
  grantProviderPortalAccess?: Maybe<GrantProviderPortalAccess>;
  /** Ingest a sleep diary entry */
  ingestSleepDiary?: Maybe<IngestSleepDiary>;
  /** Issue a new access code for a practitioner's a pdt */
  issueNewAccessCode?: Maybe<IssueNewAccessCode>;
  /** Link Cortex LimbixUser to Supabase UUID. Server-to-server only (vercel-auth JWT). Idempotent. */
  linkSupabaseUser?: Maybe<LinkSupabaseUser>;
  /** Log an event for a given care team */
  logEvent?: Maybe<LogEvent>;
  /** Mark nudge as seen by caller */
  markNudgesSeen?: Maybe<MarkNudgesSeen>;
  /** Mark a study participant as Lost to Follow-up */
  markParticipantAsLost?: Maybe<MarkParticipantAsLost>;
  /** Mark a study participant as screen fail */
  markParticipantAsScreenFail?: Maybe<MarkParticipantAsScreenFail>;
  /** Mark a tutorial as completed or skipped by the current user (sets completed_at). */
  markTutorialAsCompleted?: Maybe<MarkTutorialAsCompleted>;
  /** Mark a tutorial as first seen by the current user (sets first_seen_at). */
  markTutorialAsSeen?: Maybe<MarkTutorialAsSeen>;
  /** Record a single log entry for practicing a CBT technique */
  recordCbtTechniqueLog?: Maybe<RecordCbtTechniqueLog>;
  /** Record multiple log entries for practicing CBT techniques */
  recordCbtTechniqueLogs?: Maybe<RecordCbtTechniqueLogs>;
  /**
   * Record log entries for practicing CBT techniques associated with a diary date.
   * This will delete any existing logs for the given diary date that are not in the provided technique_keys.
   */
  recordDiaryCbtTechniqueLogs?: Maybe<RecordDiaryCbtTechniqueLogs>;
  /** Refresh an auth token given a refresh token */
  refreshToken?: Maybe<LimbixRefresh>;
  /** Refresh a mobile auth token given a refresh token */
  refreshTokenMobile?: Maybe<RefreshTokenMobile>;
  /** Register an existing user */
  registerExistingUser?: Maybe<RegisterExistingUser>;
  /** Create and register a new user */
  registerNewUser?: Maybe<RegisterNewUser>;
  /** Remove a Study CoInvestigator from a study */
  removeStudyCoInvestigator?: Maybe<RemoveStudyCoInvestigator>;
  /** Remove a study coordinator from a study */
  removeStudyCoordinator?: Maybe<RemoveStudyCoordinator>;
  /** Report an adverse event */
  reportAdverseEvent?: Maybe<ReportAdverseEvent>;
  /** Report an assessment result */
  reportAssessmentResult?: Maybe<ReportAssessmentResult>;
  /** Report assessment answers for a Clinical Concern */
  reportClinicalConcern?: Maybe<ReportClinicalConcern>;
  /** Report an assessment result */
  reportParticipantAssessmentResult?: Maybe<ReportParticipantAssessmentResult>;
  /** Report a research assessment result */
  reportResearchAssessmentResult?: Maybe<ReportResearchAssessmentResult>;
  /** Report when a user completes a task */
  reportTaskComplete?: Maybe<ReportTaskComplete>;
  /** Report when a user starts a task */
  reportTaskStart?: Maybe<ReportTaskStart>;
  /** Request account deletion */
  requestAccountDeletion?: Maybe<RequestAccountDeletion>;
  /** Self-serve account removal */
  requestAccountRemoval?: Maybe<RequestAccountRemoval>;
  /** Resend a practitioner's access code for a pdt */
  resendAccessCode?: Maybe<ResendAccessCode>;
  /** Resend verification email */
  resendEmailVerification?: Maybe<ResendEmailVerification>;
  /** Re-send an access code to a user */
  resendPatientAccessCode?: Maybe<ResendPatientAccessCode>;
  /** Reset users login access attempts */
  resetAccessAttempts?: Maybe<ResetAccessAttempts>;
  /** Send reset password email for account */
  resetPassword?: Maybe<ResetPassword>;
  /** Reset a patient's access attempts */
  resetPatientAccessAttempts?: Maybe<ResetPatientAccessAttempts>;
  /** Revoke a practitioner's access code for a pdt */
  revokeAccessCode?: Maybe<RevokeAccessCode>;
  /** Revoke a participant's mobile access */
  revokeMobileAccess?: Maybe<RevokeMobileAccess>;
  /** Revoke a patient's mobile access and mobile refresh tokens */
  revokePatientMobileAccess?: Maybe<RevokePatientMobileAccess>;
  /** Revoke a practitioner's Provider Portal access */
  revokeProviderPortalAccess?: Maybe<RevokeProviderPortalAccess>;
  revokeToken?: Maybe<Revoke>;
  /** Save coverage details for a patient */
  saveCoverageDetails?: Maybe<SaveCoverageDetails>;
  /** Save enrollment response data received from an external enrollment partner */
  saveExternalEnrollmentData?: Maybe<SaveExternalEnrollmentData>;
  /** Save password for, and activate, Solera user */
  savePasswordAndActivateSoleraUser?: Maybe<SavePasswordAndActivateSoleraUser>;
  /** Save password for a patient and activate their account */
  savePasswordAndActivateUser?: Maybe<SavePasswordAndActivateUser>;
  /** Schedule an Iterable campaign for a user */
  scheduleIterableCampaign?: Maybe<ScheduleIterableCampaign>;
  /** Schedule a periodic push notification */
  schedulePeriodicPushNotification?: Maybe<SchedulePeriodicPushNotification>;
  /** Schedule a periodic push notification with campaign names */
  schedulePeriodicPushNotificationByName?: Maybe<SchedulePeriodicPushNotificationByName>;
  /** Schedule a push notification */
  schedulePushNotification?: Maybe<SchedulePushNotification>;
  /** Schedule a push notification via Iterable */
  schedulePushNotificationByName?: Maybe<SchedulePushNotificationByName>;
  /** Schedule an update for a user in Iterable to be processed async */
  scheduleUpdateIterableFieldForUser?: Maybe<ScheduleUpdateIterableFieldForUser>;
  /** Create a study participant account with an access code */
  selfServeCreateParticipant?: Maybe<SelfServeCreateParticipant>;
  /** Create a new limbix user and a Patient tied to it */
  selfServeCreatePatient?: Maybe<SelfServeCreatePatient>;
  /** Create a new limbix user and a Practitioner tied to it */
  selfServeCreatePractitioner?: Maybe<SelfServeCreatePractitioner>;
  /** Send email verification for Solera user */
  sendEmailChangeVerification?: Maybe<SendEmailChangeVerification>;
  /** Mark nudge as sent by caller and store when the nudge was sent */
  sendNudge?: Maybe<SendNudge>;
  /** Schedule the ready to download SMS campaign to be sent, saving SMS details if provided */
  sendReadyToDownloadSms?: Maybe<SendReadyToDownloadSms>;
  /** Set email_verified for a user */
  setEmailVerified?: Maybe<SetEmailVerified>;
  /** Sets a user as blinded or unblinded for a particular study */
  setUserBlinded?: Maybe<SetUserBlinded>;
  /** Create or update a user's reminder preference */
  setUserReminder?: Maybe<SetUserReminder>;
  /** Mark when an assignment was started */
  startAssignment?: Maybe<StartAssignment>;
  /** Mark when a research assignment was started */
  startResearchAssignment?: Maybe<StartResearchAssignment>;
  /** Deauthenticate a user from Terra */
  terraDeauthenticateUser?: Maybe<TerraDeauthenticateUser>;
  /** Generate a Terra auth token for SDK connection */
  terraGenerateAuthToken?: Maybe<TerraGenerateAuthToken>;
  /** Get auth token for an account given valid credentials */
  tokenAuth?: Maybe<TokenAuth>;
  /** Get auth token for an account given valid credentials and one time password */
  tokenAuthMfa?: Maybe<TokenAuthMfa>;
  /** Get mobile auth token for an account given valid credentials */
  tokenAuthMobile?: Maybe<TokenAuthMobile>;
  /** Transition AccountType.CHILD to ADULT */
  transitionToAdult?: Maybe<TransitionToAdult>;
  /** Update user's app start date for a given PDT */
  updateAppStartDate?: Maybe<UpdateAppStartDate>;
  /** Update baseline data for a user */
  updateBaselineData?: Maybe<UpdateBaselineData>;
  /** Update user's start datetime for the baseline quiz */
  updateBaselineQuizStart?: Maybe<UpdateBaselineQuizStart>;
  /** Update user's baseline sleep efficiency score */
  updateBaselineSleepEfficiencyScore?: Maybe<UpdateBaselineSleepEfficiencyScore>;
  /** Update user's baseline sleep quality score */
  updateBaselineSleepQualityScore?: Maybe<UpdateBaselineSleepQualityScore>;
  /** Update an existing BA task */
  updateBehavioralActivationTask?: Maybe<UpdateBehavioralActivationTask>;
  /** Update user's current module and task number for a given PDT */
  updateCurrentModuleAndTask?: Maybe<UpdateCurrentModuleAndTask>;
  /** Update enrollment tracker data for a participant */
  updateEnrollmentTracker?: Maybe<UpdateEnrollmentTracker>;
  /** Update a single field for a user in Iterable */
  updateIterableFieldForUser?: Maybe<UpdateIterableFieldForUser>;
  /** Update user's last engagement date/time for a given PDT */
  updateLastEngagementTime?: Maybe<UpdateLastEngagementTime>;
  /** Update local timezone associated with user account */
  updateLocalTimezone?: Maybe<UpdateLocalTimezone>;
  /** Update a mood log */
  updateMoodLog?: Maybe<UpdateMoodLog>;
  /** Update user's onboarding start date for a given PDT */
  updateOnboardingStartDate?: Maybe<UpdateOnboardingStartDate>;
  /** Update or create a FCM device */
  updateOrCreateFcmDevice?: Maybe<UpdateOrCreateFcmDevice>;
  /** Update user's password */
  updatePassword?: Maybe<UpdatePassword>;
  /** Update user profile data on posthog */
  updatePosthogProfileUserData?: Maybe<UpdatePosthogProfileUserData>;
  /** Update user's research study id for a given PDT */
  updateResearchStudyId?: Maybe<UpdateResearchStudyId>;
  /** Update a Sci2Data */
  updateSci2Data?: Maybe<UpdateSci2Data>;
  /** Update a SleepioProgressReview */
  updateSleepioProgressReview?: Maybe<UpdateSleepioProgressReview>;
  /** Update a Sleepio sleep diary */
  updateSleepioSleepDiary?: Maybe<UpdateSleepioSleepDiary>;
  /** Update a study assignment schedule if it exists, otherwise create one */
  updateStudyAssignmentSchedule?: Maybe<UpdateStudyAssignmentSchedule>;
  /** Update a study's name */
  updateStudyName?: Maybe<UpdateStudyName>;
  /** Update additional data associated with a task */
  updateTaskAppData?: Maybe<UpdateTaskAppData>;
  /** Update user's acknowledgement of various consent forms */
  updateUserAcknowledgement?: Maybe<UpdateUserAcknowledgement>;
  /** Update an existing user activity log */
  updateUserActivityLog?: Maybe<UpdateUserActivityLog>;
  /** Update billable date for user to flag as billable */
  updateUserBillable?: Maybe<UpdateUserBillable>;
  /** Update language associated with user account */
  updateUserLanguage?: Maybe<UpdateUserLanguage>;
  /** Update a user log */
  updateUserLog?: Maybe<UpdateUserLog>;
  /** Update phone number associated with user account */
  updateUserPhoneNumber?: Maybe<UpdateUserPhoneNumber>;
  /** Update user's settings for a given PDT */
  updateUserSettings?: Maybe<UpdateUserSettings>;
  /** Batch upsert clinical user responses. Creates or reuses a single clinical check-in for all responses. */
  upsertBatchClinicalUserResponse?: Maybe<UpsertBatchClinicalUserResponse>;
  /** Upserts a clinical user response to a standardized clinical question. */
  upsertClinicalUserResponse?: Maybe<UpsertClinicalUserResponse>;
  /** Upsert a daily check-in. */
  upsertDailyCheckIn?: Maybe<UpsertDailyCheckIn>;
  /** Create or update a progress reward for a specific user */
  upsertProgressReward?: Maybe<UpsertProgressReward>;
  /** Create or update progress tracking for a specific module within a session. */
  upsertSessionProgress?: Maybe<UpsertSessionProgress>;
  /** Upserts a daily session. */
  upsertUserDailySession?: Maybe<UpsertUserDailySession>;
  /** Upserts a user response to a question. */
  upsertUserResponse?: Maybe<UpsertUserResponse>;
  /** Verify an access code */
  verifyAccessCode?: Maybe<VerifyAccessCode>;
  /** Verify patient email against access code. Returns limbix_user_id and org_slug on match. Server-to-server only (vercel-auth JWT). */
  verifyEmail?: Maybe<VerifyEmail>;
  /** Verify patient phone number against access code. Returns limbix_user_id and org_slug on match. Server-to-server only (vercel-auth JWT). */
  verifyPhone?: Maybe<VerifyPhone>;
  verifyToken?: Maybe<Verify>;
  /** Withdraw a study participant */
  withdrawParticipant?: Maybe<WithdrawParticipant>;
};


export type MutationActivateParticipantArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationActivateUserByAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationAddStudyCoInvestigatorArgs = {
  blinded?: InputMaybe<Scalars['Boolean']['input']>;
  studyUid: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationAddStudyCoordinatorArgs = {
  blinded?: InputMaybe<Scalars['Boolean']['input']>;
  studyUid: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationAssignClinicianReportArgs = {
  clinicalConcernUid: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationCancelPeriodicPushNotificationArgs = {
  periodicNotificationUid: Scalars['String']['input'];
};


export type MutationCancelPeriodicPushNotificationsByTypeArgs = {
  notificationType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationCancelPushNotificationArgs = {
  notificationTaskUid: Scalars['String']['input'];
};


export type MutationCancelPushNotificationsByTypeArgs = {
  notificationType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationCompleteAssignmentArgs = {
  assignmentUid: Scalars['String']['input'];
  completeTime: Scalars['DateTime']['input'];
  pdtUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteParticipantArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationCompleteResearchAssignmentArgs = {
  assignmentUid: Scalars['String']['input'];
  completeTime: Scalars['DateTime']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationCreateAssessmentArgs = {
  assessmentData: AssessmentInputType;
};


export type MutationCreateBehavioralActivationTaskArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  behavioralActivationTaskUid?: InputMaybe<Scalars['String']['input']>;
  completeTime?: InputMaybe<Scalars['DateTime']['input']>;
  didCompleteScheduledActivation?: InputMaybe<Scalars['Boolean']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  pdtUid: Scalars['String']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateClinicalConcernArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationCreateFreeFormTextArgs = {
  denyListMatches?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationCreateMockClinicalConcernsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  studyUid: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationCreateMockStudyAssignmentsArgs = {
  adultParticipantEmail?: InputMaybe<Scalars['String']['input']>;
  childParticipantEmail?: InputMaybe<Scalars['String']['input']>;
  parentParticipantEmail?: InputMaybe<Scalars['String']['input']>;
  researchUserEmail?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
  withAutogeneratedAnswers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMoodLogArgs = {
  date: Scalars['DateTime']['input'];
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  mood: Scalars['String']['input'];
  moodLogUid?: InputMaybe<Scalars['String']['input']>;
  pdtUid: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrderArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['String']['input']>;
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  externalPatientId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationIdSystem?: InputMaybe<Scalars['String']['input']>;
  locationIdType?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
  organizationUid: Scalars['String']['input'];
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  patientEmailAddress?: InputMaybe<Scalars['String']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLanguage?: InputMaybe<LanguageType>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pdtUid: Scalars['String']['input'];
  providerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  textConsentAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOrderWithProviderPortalArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  organizationUid: Scalars['String']['input'];
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  patientEmailAddress: Scalars['String']['input'];
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLanguage?: InputMaybe<LanguageType>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  providerEmailAddress: Scalars['String']['input'];
};


export type MutationCreateOrderWithWebFormArgs = {
  accessCode: Scalars['String']['input'];
  organizationUid?: InputMaybe<Scalars['String']['input']>;
  patientDateOfBirth: Scalars['Date']['input'];
  patientEmailAddress: Scalars['String']['input'];
  patientFirstName: Scalars['String']['input'];
  patientLanguage: LanguageType;
  patientLastName: Scalars['String']['input'];
  patientPhoneNumber: Scalars['String']['input'];
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  providerEmailAddress: Scalars['String']['input'];
  textConsentAcknowledged: Scalars['Boolean']['input'];
};


export type MutationCreateSci2DataArgs = {
  pdtUid: Scalars['String']['input'];
  sci2Data: Sci2DataInputType;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSleepioProgressReviewArgs = {
  pdtUid: Scalars['String']['input'];
  progressReviewData?: InputMaybe<SleepioProgressReviewInputType>;
  uid?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Array<InputMaybe<SleepioProgressReviewWeekInputType>>>;
};


export type MutationCreateSleepioSleepDiaryArgs = {
  awakeDuringNight: Scalars['Boolean']['input'];
  date: Scalars['DateTime']['input'];
  disturbances: Array<InputMaybe<Scalars['String']['input']>>;
  entryType: Scalars['String']['input'];
  getIntoBedTime: Scalars['DateTime']['input'];
  getOutOfBedTime: Scalars['DateTime']['input'];
  pdtUid: Scalars['String']['input'];
  restLevel: Scalars['Int']['input'];
  riseImmediately: Scalars['Boolean']['input'];
  sleepEfficiency: Scalars['Float']['input'];
  timeAsleep: Scalars['Int']['input'];
  timeAwake: Scalars['Int']['input'];
  timeInBed: Scalars['Int']['input'];
  timeToFallAsleep: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  tryToSleepTime?: InputMaybe<Scalars['DateTime']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  userSlept: Scalars['Boolean']['input'];
  wakeUpTime: Scalars['DateTime']['input'];
};


export type MutationCreateUserActivityLogArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activityLogUid?: InputMaybe<Scalars['String']['input']>;
  activityType: Scalars['String']['input'];
  completeTime?: InputMaybe<Scalars['DateTime']['input']>;
  didCompleteScheduledActivation?: InputMaybe<Scalars['Boolean']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  pdtUid: Scalars['String']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateUserLogArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  logUid?: InputMaybe<Scalars['String']['input']>;
  mood?: InputMaybe<Scalars['String']['input']>;
  pdtUid: Scalars['String']['input'];
  sudsRating?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateXealthOrderArgs = {
  organizationSlug: Scalars['String']['input'];
  patientDateOfBirth: Scalars['DateTime']['input'];
  patientEmailAddress: Scalars['String']['input'];
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber: Scalars['String']['input'];
  pdtSlug: Scalars['String']['input'];
  providerEmailAddress: Scalars['String']['input'];
  providerExternalId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDecodeOrganizationSignupTokenArgs = {
  pdtUid: Scalars['String']['input'];
  token: Scalars['String']['input'];
  tokenIssuer: Scalars['String']['input'];
};


export type MutationDeleteBehavioralActivationTaskArgs = {
  behavioralActivationTaskUid: Scalars['String']['input'];
};


export type MutationDeleteClinicalConcernArgs = {
  changeReason: Scalars['String']['input'];
  clinicalConcernUid: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationDeleteMoodLogArgs = {
  moodLogUid: Scalars['String']['input'];
};


export type MutationDeleteParticipantArgs = {
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationDeleteSci2DataArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSleepioProgressReviewArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteSleepioSleepDiaryArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeleteStudyAssignmentScheduleArgs = {
  assignmentScheduleUid: Scalars['String']['input'];
  changeReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserActivityLogArgs = {
  activityLogUid: Scalars['String']['input'];
};


export type MutationDeleteUserLogArgs = {
  logUid: Scalars['String']['input'];
};


export type MutationDeleteUserReminderArgs = {
  reminderUid: Scalars['String']['input'];
};


export type MutationDiscontinueCareArgs = {
  careteamUid: Scalars['String']['input'];
};


export type MutationDropParticipantArgs = {
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationEditAssessmentArgs = {
  assessmentData?: InputMaybe<AssessmentInputType>;
  changeReason: Scalars['String']['input'];
};


export type MutationEditParentsArgs = {
  changeReason: Scalars['String']['input'];
  childUid: Scalars['String']['input'];
  parentUids: Array<InputMaybe<Scalars['String']['input']>>;
  studyUid: Scalars['String']['input'];
};


export type MutationEditParticipantDataArgs = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  changeReason: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationEditPatientInfoArgs = {
  changeReason?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactEmail?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  patientUid?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditPractitionerNotesArgs = {
  changeReason: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  practitionerUid: Scalars['String']['input'];
};


export type MutationEnrollDirectAccessPatientArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  emergencyContactEmail?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  notIntendedToTreatAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  organizationSlug: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  posthogDistinctId?: InputMaybe<Scalars['String']['input']>;
  safetyAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  supabaseId?: InputMaybe<Scalars['String']['input']>;
  termsAndPrivacyAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEnrollDirectAccessPatientV2Args = {
  email: Scalars['String']['input'];
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  marketingSmsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationSlug: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  posthogDistinctId?: InputMaybe<Scalars['String']['input']>;
  sendVerificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndPrivacyAcknowledgedAt: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEnrollPatientArgs = {
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEnrollPatientPlatgenArgs = {
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
  password: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  posthogDistinctId?: InputMaybe<Scalars['String']['input']>;
  termsAndPrivacyAcknowledgedAt: Scalars['String']['input'];
};


export type MutationEnrollSoleraPatientArgs = {
  enrollmentId: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationExternalOrganizationAccessRenewalArgs = {
  externalIdentifier: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  token: Scalars['String']['input'];
  tokenIssuer: Scalars['String']['input'];
};


export type MutationExternalOrganizationSignupArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  initialAppVersion?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tokenIssuer: Scalars['String']['input'];
};


export type MutationGenerateCaseReportFormArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationGenerateCaseReportFormsArgs = {
  studyUid: Scalars['String']['input'];
};


export type MutationGenerateCentralizedChangeLogCsvArgs = {
  studyUid: Scalars['String']['input'];
};


export type MutationGenerateClinicalConcernsCsvArgs = {
  participantAttributes?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGrantProviderPortalAccessArgs = {
  changeReason: Scalars['String']['input'];
  portalAccessTime: Scalars['DateTime']['input'];
  practitionerUid: Scalars['String']['input'];
};


export type MutationIngestSleepDiaryArgs = {
  input: IngestSleepDiaryInput;
};


export type MutationIssueNewAccessCodeArgs = {
  pdtUid: Scalars['String']['input'];
  practitionerUid: Scalars['String']['input'];
};


export type MutationLinkSupabaseUserArgs = {
  limbixUserId: Scalars['String']['input'];
  supabaseId: Scalars['String']['input'];
};


export type MutationLogEventArgs = {
  eventName: Scalars['String']['input'];
  happenedAt: Scalars['DateTime']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationMarkNudgesSeenArgs = {
  pdtUid: Scalars['String']['input'];
};


export type MutationMarkParticipantAsLostArgs = {
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationMarkParticipantAsScreenFailArgs = {
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationMarkTutorialAsCompletedArgs = {
  tutorialId: Scalars['String']['input'];
};


export type MutationMarkTutorialAsSeenArgs = {
  tutorialId: Scalars['String']['input'];
};


export type MutationRecordCbtTechniqueLogArgs = {
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  diaryDate?: InputMaybe<Scalars['Date']['input']>;
  pdtUid: Scalars['String']['input'];
  practiceDate: Scalars['Date']['input'];
  source: Scalars['String']['input'];
  techniqueKey: Scalars['String']['input'];
};


export type MutationRecordCbtTechniqueLogsArgs = {
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  diaryDate?: InputMaybe<Scalars['Date']['input']>;
  pdtUid: Scalars['String']['input'];
  practiceDate: Scalars['Date']['input'];
  source: Scalars['String']['input'];
  techniqueKeys: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRecordDiaryCbtTechniqueLogsArgs = {
  diaryDate: Scalars['Date']['input'];
  pdtUid: Scalars['String']['input'];
  techniqueKeys: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefreshTokenMobileArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterExistingUserArgs = {
  referralSource?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterNewUserArgs = {
  accountType: Scalars['String']['input'];
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  referralSource?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
};


export type MutationRemoveStudyCoInvestigatorArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationRemoveStudyCoordinatorArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationReportAdverseEventArgs = {
  assignmentUid?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  isCausedByTreatment: Scalars['Boolean']['input'];
  pdtUid: Scalars['String']['input'];
  severity: Scalars['Int']['input'];
};


export type MutationReportAssessmentResultArgs = {
  assessmentAnswers: Array<InputMaybe<Scalars['String']['input']>>;
  assessmentResultUid?: InputMaybe<Scalars['String']['input']>;
  assessmentUid: Scalars['String']['input'];
  assignmentUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationReportClinicalConcernArgs = {
  assessmentAnswers: Array<InputMaybe<Scalars['String']['input']>>;
  changeReason: Scalars['String']['input'];
  clinicalConcernUid: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationReportParticipantAssessmentResultArgs = {
  assessmentAnswers: Array<InputMaybe<Scalars['String']['input']>>;
  assessmentResultUid?: InputMaybe<Scalars['String']['input']>;
  assessmentUid: Scalars['String']['input'];
  assignmentCompleteTime?: InputMaybe<Scalars['DateTime']['input']>;
  assignmentUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationReportResearchAssessmentResultArgs = {
  assessmentAnswers: Array<InputMaybe<Scalars['String']['input']>>;
  assessmentResultUid?: InputMaybe<Scalars['String']['input']>;
  assignmentUid: Scalars['String']['input'];
  changeReason?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
};


export type MutationReportTaskCompleteArgs = {
  completeTime: Scalars['DateTime']['input'];
  moduleNumber: Scalars['Int']['input'];
  pdtUid: Scalars['String']['input'];
  taskNumber: Scalars['Int']['input'];
};


export type MutationReportTaskStartArgs = {
  moduleNumber: Scalars['Int']['input'];
  pdtUid: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  taskNumber: Scalars['Int']['input'];
};


export type MutationResendAccessCodeArgs = {
  pdtUid: Scalars['String']['input'];
  practitionerUid: Scalars['String']['input'];
};


export type MutationResendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendPatientAccessCodeArgs = {
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationResetAccessAttemptsArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  pdtUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPatientAccessAttemptsArgs = {
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationRevokeAccessCodeArgs = {
  changeReason: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  practitionerUid: Scalars['String']['input'];
};


export type MutationRevokeMobileAccessArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationRevokePatientMobileAccessArgs = {
  changeReason: Scalars['String']['input'];
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationRevokeProviderPortalAccessArgs = {
  changeReason: Scalars['String']['input'];
  practitionerUid: Scalars['String']['input'];
};


export type MutationRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveCoverageDetailsArgs = {
  careTeamUid: Scalars['String']['input'];
  coverageCheckStartTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  coverageCheckStatus: Scalars['String']['input'];
  coverageCheckTimestamp: Scalars['DateTime']['input'];
  dateOfBirth: Scalars['Date']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSaveExternalEnrollmentDataArgs = {
  enrolledAt?: InputMaybe<Scalars['DateTime']['input']>;
  enrollmentFailedReason?: InputMaybe<Scalars['String']['input']>;
  enrollmentId?: InputMaybe<Scalars['String']['input']>;
  enrollmentSource?: InputMaybe<Scalars['String']['input']>;
  enrollmentSuccess: Scalars['Boolean']['input'];
  errors?: InputMaybe<Scalars['JSONString']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId: Scalars['String']['input'];
  responseCode: Scalars['String']['input'];
};


export type MutationSavePasswordAndActivateSoleraUserArgs = {
  careTeamUid: Scalars['String']['input'];
  clientType?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSavePasswordAndActivateUserArgs = {
  careTeamUid: Scalars['String']['input'];
  clientType?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};


export type MutationScheduleIterableCampaignArgs = {
  campaignName: Scalars['String']['input'];
  delay?: InputMaybe<Scalars['Int']['input']>;
  pdtId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSchedulePeriodicPushNotificationArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  frequencyHours: Scalars['Int']['input'];
  notificationContent: Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>;
  notificationType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSchedulePeriodicPushNotificationByNameArgs = {
  campaignNames: Array<InputMaybe<Scalars['String']['input']>>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  frequencyHours: Scalars['Int']['input'];
  notificationType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSchedulePushNotificationArgs = {
  eta: Scalars['DateTime']['input'];
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  message: Scalars['String']['input'];
  notificationType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSchedulePushNotificationByNameArgs = {
  campaignName: Scalars['String']['input'];
  eta: Scalars['DateTime']['input'];
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  notificationType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};


export type MutationScheduleUpdateIterableFieldForUserArgs = {
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
  pdtId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSelfServeCreateParticipantArgs = {
  accessCode: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelfServeCreatePatientArgs = {
  accessCode: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  initialAppVersion?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  notIntendedToTreatAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  safetyAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  termsAndPrivacyAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelfServeCreatePractitionerArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identifierState?: InputMaybe<Scalars['String']['input']>;
  identifierSystem: Scalars['String']['input'];
  identifierValue: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationAccessCodeType?: InputMaybe<Scalars['String']['input']>;
  organizationEmail: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  organizationPaymentType?: InputMaybe<Scalars['String']['input']>;
  organizationPhone: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  pdtUid: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendEmailChangeVerificationArgs = {
  email: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  previousEmail: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendNudgeArgs = {
  careteamUid: Scalars['String']['input'];
  nudgeUid: Scalars['String']['input'];
};


export type MutationSendReadyToDownloadSmsArgs = {
  careTeamUid: Scalars['String']['input'];
  marketingSmsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  textConsentAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetEmailVerifiedArgs = {
  careTeamUid: Scalars['String']['input'];
  coverageCheckStartedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSetUserBlindedArgs = {
  blinded: Scalars['Boolean']['input'];
  studyUid: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationSetUserReminderArgs = {
  pdtUid: Scalars['String']['input'];
  reminderType: Scalars['String']['input'];
  status: ReminderStatusEnum;
  time: Scalars['String']['input'];
};


export type MutationStartAssignmentArgs = {
  assignmentUid: Scalars['String']['input'];
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
};


export type MutationStartResearchAssignmentArgs = {
  assignmentUid: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationTerraDeauthenticateUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationTerraGenerateAuthTokenArgs = {
  referenceId: Scalars['String']['input'];
};


export type MutationTokenAuthArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationTokenAuthMfaArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  mfaCode?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationTokenAuthMobileArgs = {
  email: Scalars['String']['input'];
  initialAppVersion?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationTransitionToAdultArgs = {
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationUpdateAppStartDateArgs = {
  appStartDate: Scalars['DateTime']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateBaselineDataArgs = {
  baselineData: Scalars['JSONString']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateBaselineQuizStartArgs = {
  baselineQuizStartTimestamp: Scalars['DateTime']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateBaselineSleepEfficiencyScoreArgs = {
  baselineSleepEfficiencyScore: Scalars['Float']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateBaselineSleepQualityScoreArgs = {
  baselineSleepQualityScore: Scalars['Int']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateBehavioralActivationTaskArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  behavioralActivationTaskUid: Scalars['String']['input'];
  completeTime?: InputMaybe<Scalars['DateTime']['input']>;
  didCompleteScheduledActivation?: InputMaybe<Scalars['Boolean']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateCurrentModuleAndTaskArgs = {
  currentModuleNumber: Scalars['Int']['input'];
  currentTaskNumber: Scalars['Int']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateEnrollmentTrackerArgs = {
  assessmentAnswers: Array<InputMaybe<Scalars['String']['input']>>;
  changeReason: Scalars['String']['input'];
  enrollmentTrackerResultUid: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationUpdateIterableFieldForUserArgs = {
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateLastEngagementTimeArgs = {
  lastEngagementTime: Scalars['DateTime']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateLocalTimezoneArgs = {
  localTimezone: Scalars['String']['input'];
};


export type MutationUpdateMoodLogArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  mood?: InputMaybe<Scalars['String']['input']>;
  moodLogUid: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOnboardingStartDateArgs = {
  onboardingStartDate: Scalars['DateTime']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateOrCreateFcmDeviceArgs = {
  active: Scalars['Boolean']['input'];
  registrationId: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type MutationUpdatePosthogProfileUserDataArgs = {
  pdtUid: Scalars['String']['input'];
  profileUserData: PosthogProfileUserDataInput;
};


export type MutationUpdateResearchStudyIdArgs = {
  pdtUid: Scalars['String']['input'];
  researchStudyId: Scalars['String']['input'];
};


export type MutationUpdateSci2DataArgs = {
  sci2Data: Sci2DataInputType;
  uid: Scalars['String']['input'];
};


export type MutationUpdateSleepioProgressReviewArgs = {
  progressReviewData?: InputMaybe<SleepioProgressReviewInputType>;
  uid: Scalars['String']['input'];
};


export type MutationUpdateSleepioSleepDiaryArgs = {
  awakeDuringNight: Scalars['Boolean']['input'];
  date: Scalars['DateTime']['input'];
  disturbances: Array<InputMaybe<Scalars['String']['input']>>;
  entryType: Scalars['String']['input'];
  getIntoBedTime: Scalars['DateTime']['input'];
  getOutOfBedTime: Scalars['DateTime']['input'];
  restLevel: Scalars['Int']['input'];
  riseImmediately: Scalars['Boolean']['input'];
  sleepEfficiency: Scalars['Float']['input'];
  timeAsleep: Scalars['Int']['input'];
  timeAwake: Scalars['Int']['input'];
  timeInBed: Scalars['Int']['input'];
  timeToFallAsleep: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  tryToSleepTime?: InputMaybe<Scalars['DateTime']['input']>;
  uid: Scalars['String']['input'];
  userSlept: Scalars['Boolean']['input'];
  wakeUpTime: Scalars['DateTime']['input'];
};


export type MutationUpdateStudyAssignmentScheduleArgs = {
  assignmentScheduleData: AssignmentScheduleInputType;
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationUpdateStudyNameArgs = {
  name: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type MutationUpdateTaskAppDataArgs = {
  appData: Scalars['JSONString']['input'];
  moduleNumber: Scalars['Int']['input'];
  pdtUid: Scalars['String']['input'];
  taskNumber: Scalars['Int']['input'];
};


export type MutationUpdateUserAcknowledgementArgs = {
  acknowledgedAt: Scalars['DateTime']['input'];
  acknowledgementType: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpdateUserActivityLogArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activityLogUid: Scalars['String']['input'];
  activityType?: InputMaybe<Scalars['String']['input']>;
  completeTime?: InputMaybe<Scalars['DateTime']['input']>;
  didCompleteScheduledActivation?: InputMaybe<Scalars['Boolean']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateUserBillableArgs = {
  pdtUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationUpdateUserLogArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  extraData?: InputMaybe<Scalars['JSONString']['input']>;
  logUid: Scalars['String']['input'];
  mood?: InputMaybe<Scalars['String']['input']>;
  sudsRating?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationUpdateUserSettingsArgs = {
  appSettings: Scalars['JSONString']['input'];
  pdtUid: Scalars['String']['input'];
};


export type MutationUpsertBatchClinicalUserResponseArgs = {
  clinicalCheckInId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  responses: Array<InputMaybe<ClinicalUserResponseInput>>;
};


export type MutationUpsertClinicalUserResponseArgs = {
  clinicalCheckInId?: InputMaybe<Scalars['String']['input']>;
  clinicalQuestionType?: InputMaybe<ClinicalAssessmentType>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contentfulQuestionId: Scalars['String']['input'];
  purpose?: InputMaybe<Array<InputMaybe<ResponsePurposeType>>>;
  questionOrder?: InputMaybe<Scalars['Int']['input']>;
  responseId?: InputMaybe<Scalars['String']['input']>;
  responseInt?: InputMaybe<Scalars['Int']['input']>;
  responseText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertDailyCheckInArgs = {
  checkInId?: InputMaybe<Scalars['String']['input']>;
  contentfulDailySessionId: Scalars['String']['input'];
  contentfulModuleId: Scalars['String']['input'];
  sessionDate: Scalars['Date']['input'];
};


export type MutationUpsertProgressRewardArgs = {
  checkInId?: InputMaybe<Scalars['String']['input']>;
  contentfulRewardIdentifier: Scalars['String']['input'];
  rewardId?: InputMaybe<Scalars['String']['input']>;
  rewardStarCount: Scalars['Int']['input'];
};


export type MutationUpsertSessionProgressArgs = {
  contentfulModuleId: Scalars['String']['input'];
  contentfulTechniqueId?: InputMaybe<Scalars['String']['input']>;
  dailySessionId: Scalars['String']['input'];
  moduleName: Scalars['String']['input'];
  moduleOrder?: InputMaybe<Scalars['Int']['input']>;
  progressId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertUserDailySessionArgs = {
  checkInId?: InputMaybe<Scalars['String']['input']>;
  contentfulDailySessionId: Scalars['String']['input'];
  dailySessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertUserResponseArgs = {
  canTriggerReward?: InputMaybe<Scalars['Boolean']['input']>;
  checkInId?: InputMaybe<Scalars['String']['input']>;
  contentfulQuestionId: Scalars['String']['input'];
  responseDecimal?: InputMaybe<Scalars['Decimal']['input']>;
  responseId?: InputMaybe<Scalars['String']['input']>;
  responseInt?: InputMaybe<Scalars['Int']['input']>;
  responseText?: InputMaybe<Scalars['String']['input']>;
  skillsPracticedAndContentfulIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['GenericScalar']['input']>>>;
};


export type MutationVerifyAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  isStudyCode?: InputMaybe<Scalars['Boolean']['input']>;
  pdtUid: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  accessCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationVerifyPhoneArgs = {
  accessCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWithdrawParticipantArgs = {
  changeReason: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};

/** An enumeration. */
export enum NotificationTaskPlatformType {
  /** Email */
  Email = 'EMAIL',
  /** Push Notification */
  Push = 'PUSH',
  /** SMS */
  Sms = 'SMS'
}

/** Scheduled notification */
export type NotificationTaskType = {
  __typename?: 'NotificationTaskType';
  eta: Scalars['DateTime']['output'];
  notificationType: Scalars['String']['output'];
  pdt?: Maybe<PdtType>;
  platformType: NotificationTaskPlatformType;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  user: UserType;
};

export type NudgeMessageType = {
  __typename?: 'NudgeMessageType';
  body?: Maybe<Scalars['String']['output']>;
  /** Body text */
  bodyTemplate?: Maybe<Scalars['TranslationString']['output']>;
  bodyTemplateTranslations?: Maybe<TextTranslationType>;
  header?: Maybe<Scalars['String']['output']>;
  /** Header text */
  headerTemplate?: Maybe<Scalars['TranslationString']['output']>;
  headerTemplateTranslations?: Maybe<TextTranslationType>;
  nudgeOpportunityConfig?: Maybe<NudgeOpportunityConfigType>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};


export type NudgeMessageTypeBodyArgs = {
  nudgeOpportunityUid: Scalars['String']['input'];
};


export type NudgeMessageTypeBodyTemplateArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NudgeMessageTypeHeaderArgs = {
  nudgeOpportunityUid: Scalars['String']['input'];
};


export type NudgeMessageTypeHeaderTemplateArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NudgeOpportunityConfigType = {
  __typename?: 'NudgeOpportunityConfigType';
  active: Scalars['Boolean']['output'];
  /** DEPRECATED: category of the nudge config */
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  internalName: Scalars['String']['output'];
  /** category of the nudge config */
  nudgeCategory?: Maybe<Scalars['String']['output']>;
  /** nudge message options */
  nudgeMessages?: Maybe<Array<Maybe<NudgeMessageType>>>;
  pdt: PdtType;
  providerNotificationTemplate: TextTranslationType;
  providerNotificationTemplateTranslations?: Maybe<TextTranslationType>;
  /** nudge reason */
  reason?: Maybe<Scalars['TranslationString']['output']>;
  reasonTranslations?: Maybe<TextTranslationType>;
  total?: Maybe<Scalars['Int']['output']>;
  triggerTimeOffset: Scalars['Float']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type NudgeOpportunityConfigTypeReasonArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NudgeOpportunityType = {
  __typename?: 'NudgeOpportunityType';
  /** body text */
  body?: Maybe<Scalars['String']['output']>;
  careTeam?: Maybe<CareTeamType>;
  createdAt: Scalars['DateTime']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** header text */
  header?: Maybe<Scalars['String']['output']>;
  nudgeMessage: NudgeMessageType;
  nudgeOpportunityConfig: NudgeOpportunityConfigType;
  /** provider notification text */
  providerNotification?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  sender?: Maybe<UserType>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** status of the nudge opportunity */
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  triggeredAt: Scalars['DateTime']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum OrderSource {
  /** GraphQL Order */
  GraphqlOrder = 'GRAPHQL_ORDER',
  /** Orders API */
  Orderapi = 'ORDERAPI',
  /** Provider Portal Order */
  ProviderPortal = 'PROVIDER_PORTAL',
  /** Web Order Form */
  WebOrderForm = 'WEB_ORDER_FORM',
  /** Xealth */
  Xealth = 'XEALTH'
}

/** Order type for GraphQL */
export type OrderType = {
  __typename?: 'OrderType';
  accessCodeDispensed?: Maybe<Scalars['String']['output']>;
  careTeam?: Maybe<PractitionerDashboardTableType>;
  createdAt: Scalars['DateTime']['output'];
  encounterId?: Maybe<Scalars['String']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalPatientId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationIdSystem?: Maybe<Scalars['String']['output']>;
  locationIdType?: Maybe<Scalars['String']['output']>;
  orderedPdt?: Maybe<PdtType>;
  organization?: Maybe<OrganizationType>;
  patientEmailAddress?: Maybe<Scalars['String']['output']>;
  patientPhoneNumber?: Maybe<Scalars['String']['output']>;
  providerEmailAddress?: Maybe<Scalars['String']['output']>;
  requestJson: Scalars['JSONString']['output'];
  source: OrderSource;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

/** "Lite", public-facing information about organizations */
export type OrganizationLiteType = {
  __typename?: 'OrganizationLiteType';
  name?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum OrganizationOrdersApiAccessCodeType {
  /** Patient */
  Patient = 'PATIENT',
  /** Practitioner */
  Practitioner = 'PRACTITIONER'
}

/** An enumeration. */
export enum OrganizationOrganizationType {
  /** Non-Healthcare Business or Corporation */
  Bus = 'BUS',
  /** Community Group */
  Cg = 'CG',
  /** Clinical Research Sponsor */
  Crs = 'CRS',
  /** Hospital Department */
  Dept = 'DEPT',
  /** Educational Institute */
  Edu = 'EDU',
  /** Employer */
  Emp = 'EMP',
  /** Government */
  Govt = 'GOVT',
  /** Insurance Company */
  Ins = 'INS',
  /** Other */
  Other = 'OTHER',
  /** Payer */
  Pay = 'PAY',
  /** Healthcare Provider */
  Prov = 'PROV',
  /** Religious Institution */
  Reli = 'RELI',
  /** Organizational team */
  Team = 'TEAM'
}

/** An enumeration. */
export enum OrganizationPdtConfigPaymentType {
  /** Fixed */
  Fixed = 'FIXED',
  /** Free */
  Free = 'FREE',
  /** Variable */
  Variable = 'VARIABLE'
}

/** Organization PDT Config */
export type OrganizationPdtConfigType = {
  __typename?: 'OrganizationPdtConfigType';
  adherenceThresholds: Array<Scalars['Float']['output']>;
  appAccessDurationDays?: Maybe<Scalars['Int']['output']>;
  organization: OrganizationType;
  paymentType: OrganizationPdtConfigPaymentType;
  pdt: PdtType;
  textEncryptionEnabled: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

/** Organization */
export type OrganizationType = {
  __typename?: 'OrganizationType';
  email?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  isLimbix: Scalars['Boolean']['output'];
  location?: Maybe<LocationType>;
  name?: Maybe<Scalars['String']['output']>;
  ordersApiAccessCodeType: OrganizationOrdersApiAccessCodeType;
  organizationType?: Maybe<OrganizationOrganizationType>;
  parentOrganization?: Maybe<OrganizationType>;
  pdtConfigs?: Maybe<Array<Maybe<OrganizationPdtConfigType>>>;
  phone?: Maybe<Scalars['String']['output']>;
  practitioners?: Maybe<Array<Maybe<PractitionerType>>>;
  /** Folder ID where reporting files are stored for the Organization */
  reportsFolderId?: Maybe<Scalars['String']['output']>;
  topOrganization?: Maybe<OrganizationType>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** Result of an individual completing an assessment */
export type ParticipantAssessmentResultType = {
  __typename?: 'ParticipantAssessmentResultType';
  answers?: Maybe<Scalars['JSONString']['output']>;
  assessment?: Maybe<AssessmentType>;
  assessmentAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assessmentResultItems?: Maybe<Array<Maybe<AssessmentResultItemType>>>;
  assignment?: Maybe<StudyAssignmentsTableType>;
  createdAt: Scalars['DateTime']['output'];
  lastUserToEdit?: Maybe<UserType>;
  pdt?: Maybe<PdtType>;
  score?: Maybe<Scalars['Float']['output']>;
  scores?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Patient Dashboard data */
export type PatientDashboardDataType = {
  __typename?: 'PatientDashboardDataType';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  baselinePhq?: Maybe<Scalars['Decimal']['output']>;
  enrollmentDate?: Maybe<Scalars['DateTime']['output']>;
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  mostRecentPhq?: Maybe<Scalars['Decimal']['output']>;
};

/** Patient */
export type PatientType = {
  __typename?: 'PatientType';
  careteams?: Maybe<Array<Maybe<CareTeamType>>>;
  emergencyContactEmail?: Maybe<Scalars['String']['output']>;
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationType>;
  notes?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  user: UserType;
};

/** PDT app */
export type PdtType = {
  __typename?: 'PdtType';
  minimumVersionNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** Scheduled notification */
export type PeriodicPushNotificationType = {
  __typename?: 'PeriodicPushNotificationType';
  endTime?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  notificationContent?: Maybe<Array<Maybe<Array<Scalars['String']['output']>>>>;
  notificationType: Scalars['String']['output'];
  pdt?: Maybe<PdtType>;
  startTime: Scalars['DateTime']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  user: UserType;
};

export type PostHogDistinctId = {
  __typename?: 'PostHogDistinctID';
  distinctId?: Maybe<Scalars['String']['output']>;
  userUid?: Maybe<Scalars['String']['output']>;
};

export type PostHogFeatureFlag = {
  __typename?: 'PostHogFeatureFlag';
  /** Time-to-live for feature flag, in milliseconds */
  ttl?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

export type PostHogFeatureFlags = {
  __typename?: 'PostHogFeatureFlags';
  /** Time-to-live for all feature flags, in milliseconds */
  ttl?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<Scalars['GenericScalar']['output']>;
};

export type PosthogProfileUserDataInput = {
  /** The font size used by the user on their device. */
  deviceFontSize?: InputMaybe<Scalars['String']['input']>;
  /** A boolean flag that specifies if a sleep diary has been completed */
  lastSleepDiaryCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** A boolean flag that specifies if a sleep diary has been started */
  lastSleepDiaryStarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the last task completed */
  lastTaskCompleted?: InputMaybe<Scalars['String']['input']>;
  /** The name of the last task started */
  lastTaskStarted?: InputMaybe<Scalars['String']['input']>;
  /** The name of the last technique completed */
  lastTechniqueCompleted?: InputMaybe<Scalars['String']['input']>;
  /** The source of the last technique completed */
  lastTechniqueSource?: InputMaybe<Scalars['String']['input']>;
  /** The name of the last technique started */
  lastTechniqueStarted?: InputMaybe<Scalars['String']['input']>;
  /** The value corresponding to the 'nights with problems' progress event answer */
  problemSleepNightsCount?: InputMaybe<Scalars['String']['input']>;
  /** A boolean flag that specifies if a progress review has been completed */
  progressReviewCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** A boolean flag that specifies if a progress review has been started */
  progressReviewStarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The value corresponding to the 'nights with troubles' progress event answer */
  troubleLevel?: InputMaybe<Scalars['String']['input']>;
};

/** Access Code */
export type PractitionerAccessCodeType = {
  __typename?: 'PractitionerAccessCodeType';
  code: Scalars['String']['output'];
  expirationTime?: Maybe<Scalars['DateTime']['output']>;
  pdt?: Maybe<PdtType>;
  practitioner?: Maybe<PractitionerType>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Practitioner Dashboard Table */
export type PractitionerDashboardTableType = {
  __typename?: 'PractitionerDashboardTableType';
  baselinePhqScore?: Maybe<Scalars['String']['output']>;
  baselineQuestionsAnswered?: Maybe<Scalars['Int']['output']>;
  completedPhqCount?: Maybe<Scalars['Int']['output']>;
  enrolledTime?: Maybe<Scalars['DateTime']['output']>;
  lastEngagementTime?: Maybe<Scalars['DateTime']['output']>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  patientAge?: Maybe<Scalars['Int']['output']>;
  patientDateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  patientEmail?: Maybe<Scalars['String']['output']>;
  patientFirstName?: Maybe<Scalars['String']['output']>;
  patientLastName?: Maybe<Scalars['String']['output']>;
  patientPhone?: Maybe<Scalars['String']['output']>;
  patientProgramName?: Maybe<Scalars['String']['output']>;
  patientUid?: Maybe<Scalars['String']['output']>;
  programStatusText?: Maybe<Scalars['String']['output']>;
  recentPhqScore?: Maybe<Scalars['String']['output']>;
  recentQuestionsAnswered?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalActiveDaysOfWeek?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum PractitionerIdentifierState {
  /** Alabama */
  Alabama = 'ALABAMA',
  /** Alaska */
  Alaska = 'ALASKA',
  /** Arizona */
  Arizona = 'ARIZONA',
  /** Arkansas */
  Arkansas = 'ARKANSAS',
  /** - */
  A = 'A_',
  /** California */
  California = 'CALIFORNIA',
  /** Colorado */
  Colorado = 'COLORADO',
  /** Connecticut */
  Connecticut = 'CONNECTICUT',
  /** Delaware */
  Delaware = 'DELAWARE',
  /** Florida */
  Florida = 'FLORIDA',
  /** Georgia */
  Georgia = 'GEORGIA',
  /** Hawaii */
  Hawaii = 'HAWAII',
  /** Idaho */
  Idaho = 'IDAHO',
  /** Illinois */
  Illinois = 'ILLINOIS',
  /** Indiana */
  Indiana = 'INDIANA',
  /** Iowa */
  Iowa = 'IOWA',
  /** Kansas */
  Kansas = 'KANSAS',
  /** Kentucky */
  Kentucky = 'KENTUCKY',
  /** Louisiana */
  Louisiana = 'LOUISIANA',
  /** Maine */
  Maine = 'MAINE',
  /** Maryland */
  Maryland = 'MARYLAND',
  /** Massachusetts */
  Massachusetts = 'MASSACHUSETTS',
  /** Michigan */
  Michigan = 'MICHIGAN',
  /** Minnesota */
  Minnesota = 'MINNESOTA',
  /** Mississippi */
  Mississippi = 'MISSISSIPPI',
  /** Missouri */
  Missouri = 'MISSOURI',
  /** Montana */
  Montana = 'MONTANA',
  /** Nebraska */
  Nebraska = 'NEBRASKA',
  /** Nevada */
  Nevada = 'NEVADA',
  /** New Hampshire */
  NewHampshire = 'NEW_HAMPSHIRE',
  /** New Jersey */
  NewJersey = 'NEW_JERSEY',
  /** New Mexico */
  NewMexico = 'NEW_MEXICO',
  /** New York */
  NewYork = 'NEW_YORK',
  /** North Carolina */
  NorthCarolina = 'NORTH_CAROLINA',
  /** North Dakota */
  NorthDakota = 'NORTH_DAKOTA',
  /** Ohio */
  Ohio = 'OHIO',
  /** Oklahoma */
  Oklahoma = 'OKLAHOMA',
  /** Oregon */
  Oregon = 'OREGON',
  /** Pennsylvania */
  Pennsylvania = 'PENNSYLVANIA',
  /** Rhode Island */
  RhodeIsland = 'RHODE_ISLAND',
  /** South Carolina */
  SouthCarolina = 'SOUTH_CAROLINA',
  /** South Dakota */
  SouthDakota = 'SOUTH_DAKOTA',
  /** Tennessee */
  Tennessee = 'TENNESSEE',
  /** Texas */
  Texas = 'TEXAS',
  /** Utah */
  Utah = 'UTAH',
  /** Vermont */
  Vermont = 'VERMONT',
  /** Virginia */
  Virginia = 'VIRGINIA',
  /** Washington */
  Washington = 'WASHINGTON',
  /** West Virginia */
  WestVirginia = 'WEST_VIRGINIA',
  /** Wisconsin */
  Wisconsin = 'WISCONSIN',
  /** Wyoming */
  Wyoming = 'WYOMING'
}

/** An enumeration. */
export enum PractitionerIdentifierSystemName {
  /** NPI */
  Npi = 'NPI',
  /** State License */
  StateLicense = 'STATE_LICENSE'
}

export type PractitionerIdentifierType = {
  __typename?: 'PractitionerIdentifierType';
  practitioner: PractitionerType;
  state?: Maybe<PractitionerIdentifierState>;
  systemName: PractitionerIdentifierSystemName;
  total?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

/** Practitioner Nudges Table */
export type PractitionerNudgesTableType = {
  __typename?: 'PractitionerNudgesTableType';
  careTeam?: Maybe<CareTeamType>;
  category?: Maybe<Scalars['String']['output']>;
  nudgeOpportunityConfig: NudgeOpportunityConfigType;
  patientDateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  patientFirstName?: Maybe<Scalars['String']['output']>;
  patientLastName?: Maybe<Scalars['String']['output']>;
  providerNotification?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  triggeredAt: Scalars['DateTime']['output'];
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum PractitionerPractitionerRole {
  /** Administrator */
  Admin = 'ADMIN',
  /** Doctor */
  Doctor = 'DOCTOR',
  /** ICT professional */
  Ict = 'ICT',
  /** Nurse */
  Nurse = 'NURSE',
  /** Practice Administrator */
  PracticeAdmin = 'PRACTICE_ADMIN',
  /** Researcher */
  Researcher = 'RESEARCHER',
  /** Teacher/educator */
  Teacher = 'TEACHER'
}

/** An enumeration. */
export enum PractitionerPreferredContactMethod {
  /** Email */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE'
}

/** Practitioner */
export type PractitionerType = {
  __typename?: 'PractitionerType';
  accessCodes?: Maybe<Array<Maybe<PractitionerAccessCodeType>>>;
  careteams?: Maybe<Array<Maybe<CareTeamType>>>;
  identifiers?: Maybe<Array<Maybe<PractitionerIdentifierType>>>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<LocationType>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  patients?: Maybe<Array<Maybe<PatientType>>>;
  portalAccessTime?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  practitionerRole?: Maybe<PractitionerPractitionerRole>;
  preferredContactMethod?: Maybe<PractitionerPreferredContactMethod>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  user: UserType;
};

export enum ProgramProgess {
  Completed = 'COMPLETED',
  Discontinued = 'DISCONTINUED',
  Invalid = 'INVALID',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** Reward completed by user for progressing through content */
export type ProgressRewardType = {
  __typename?: 'ProgressRewardType';
  /** Check-in linked to this reward */
  checkIn?: Maybe<DailyCheckInType>;
  /** Contentful identifier for what triggered the reward */
  contentfulRewardIdentifier: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the progress reward */
  id: Scalars['UUID']['output'];
  /** How many stars the reward is worth */
  rewardStarCount: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  _debug?: Maybe<DjangoDebug>;
  allFeatureFlags?: Maybe<PostHogFeatureFlags>;
  /** Specific assessment given an assessment UID */
  assessment?: Maybe<AssessmentType>;
  /** Assessment results for the current user given a specific PDT */
  assessmentResults?: Maybe<Array<Maybe<AssessmentResultType>>>;
  /** List of assessments available to a specific PDT */
  assessments?: Maybe<Array<Maybe<AssessmentType>>>;
  /** A specific Assignment's details */
  assignment?: Maybe<AssignmentType>;
  /** List of assignments for the current user */
  assignments?: Maybe<Array<Maybe<AssignmentType>>>;
  /** Specific BA task given the task UID */
  behavioralActivationTask?: Maybe<BehavioralActivationTaskType>;
  /** Behavioral activation tasks for the current user */
  behavioralActivationTasks?: Maybe<Array<Maybe<BehavioralActivationTaskType>>>;
  /** Get the access token for the Box API */
  boxAccessToken?: Maybe<BoxAccessToken>;
  /** Get nudge history for the given care_team identified by uid */
  careTeamNudgeHistory?: Maybe<Array<Maybe<NudgeOpportunityType>>>;
  /** Get information about a Care Team given a Patients UID and a PDT UID or given the Careteam UID */
  careteam?: Maybe<CareTeamType>;
  /** Get a list of careteams from the PDT UID */
  careteams?: Maybe<Array<Maybe<CareTeamType>>>;
  /** Get CBT content for a user, given the PDT UID */
  cbtContent?: Maybe<CbtContent>;
  /** Get a list of progress for each of the PDT's CBT techniques. */
  cbtTechniqueProgress?: Maybe<Array<Maybe<CbtTechniqueProgressType>>>;
  /** Specific clinical concern log for a participant */
  clinicalConcern?: Maybe<ClinicalConcernType>;
  /** Retrieve clinical data for a patient. Only selected fields in the query will be fetched and returned. */
  clinicalData?: Maybe<ClinicalDataDictType>;
  /** Get daily check-ins for authenticated Daylight user */
  dailyCheckIns?: Maybe<Array<Maybe<DailyCheckInType>>>;
  /** List of deny list items */
  denyList?: Maybe<DenyListType>;
  /** Get a list of CBT techniques that the user has practiced for a given diary date. */
  diaryCbtTechniques?: Maybe<Array<Maybe<CbtTechniqueType>>>;
  /** Configuration around organization */
  eligibilityConfiguration?: Maybe<EligibilityConfigurationType>;
  /** Whether the potential commercial patient is eligible for given pdt */
  eligibilityStatus?: Maybe<EligibilityStatusType>;
  /** Enrollment tracker result for a study participant */
  enrollmentTrackerResult?: Maybe<EnrollmentTrackerResultType>;
  featureFlag?: Maybe<PostHogFeatureFlag>;
  /** Get feature flag assignments for the current user and PDT */
  featureFlagAssignments?: Maybe<Array<Maybe<FeatureFlagAssignmentType>>>;
  /** Free-form text with the given PDT UID and UID */
  freeFormText?: Maybe<FreeFormTextType>;
  /** Free-form texts associated by PDT UID and User UID. Requires operations permissions. */
  freeFormTexts?: Maybe<Array<Maybe<FreeFormTextType>>>;
  /** Generate an Intercom Identity Verification JWT token for the current user */
  getIntercomToken?: Maybe<IntercomTokenType>;
  /** Get anxiety insights data aggregated by day/week/month with navigation support. Note: Weekly aggregation uses Monday-anchored weeks (Monday = week start). */
  insights?: Maybe<InsightsResponseType>;
  /** Check if an Intercom JWT token is valid (not expired) */
  isIntercomTokenValid?: Maybe<Scalars['Boolean']['output']>;
  /** Check if a specific tutorial has already been completed by the current user. Returns True if completed_at is set, False otherwise. Tutorial should be shown if this returns False. */
  isTutorialCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** A mapping of current Iterable campaign names to their IDs */
  iterableCampaignMapping?: Maybe<Scalars['JSONString']['output']>;
  /** API token for client-side requests to Iterable */
  iterableClientApiToken?: Maybe<Scalars['String']['output']>;
  /** Signed JWT for the current user */
  iterableClientJwt?: Maybe<Scalars['String']['output']>;
  /** List of the last tasks in each module for the current user and specified PDT */
  lastTasksData?: Maybe<Array<Maybe<TaskDataType>>>;
  /** Get the date of the latest SCI-2 data saved for a user */
  latestSci2DataDate?: Maybe<Scalars['String']['output']>;
  /** Get a list of CBT technique user data that the user has learned for a given PDT. */
  learnedCbtTechniqueUserData?: Maybe<Array<Maybe<CbtTechniqueUserDataType>>>;
  /** list of all library items */
  libraryItems?: Maybe<Array<Maybe<LibraryItemType>>>;
  limbixStudies?: Maybe<Array<Maybe<LimbixStudyType>>>;
  limbixStudy?: Maybe<LimbixStudyType>;
  /** Fetch information about a location */
  location?: Maybe<LocationType>;
  /** Look up a Cortex user by phone or email for JIT migration to Supabase. Returns active care teams for entitlement provisioning. Server-to-server only (vercel-auth JWT). */
  lookupUserForMigration?: Maybe<MigrationLookupResultType>;
  /** Fetch account information for current user */
  me?: Maybe<UserType>;
  /** Specific mood log given the mood log UID */
  moodLog?: Maybe<MoodLogType>;
  /** List of mood logs for the current user */
  moodLogs?: Maybe<Array<Maybe<MoodLogType>>>;
  /** Get information about the current user's careteam for the specified PDT UID */
  myCareteam?: Maybe<CareTeamType>;
  /** Specific nudge opportunity given a UID */
  nudgeOpportunity?: Maybe<NudgeOpportunityType>;
  /** Get a list of an organization's dashboard table from the PDT UIDs. Optionally includes care teams from child organizations when include_child_organizations is True. */
  orgPractitionerDashboardTable?: Maybe<Array<Maybe<PractitionerDashboardTableType>>>;
  /** Fetch list of practitioners from given organization UID. Optionally includes practitioners from child organizations when include_child_organizations is True. */
  orgPractitioners?: Maybe<Array<Maybe<PractitionerType>>>;
  /** Get information about a given Organization if you are a member of the organization hierarchy */
  organization?: Maybe<OrganizationType>;
  /** Find all the assignment schedules for a particular organization */
  organizationAssignmentSchedules?: Maybe<Array<Maybe<AssignmentScheduleType>>>;
  organizationName?: Maybe<OrganizationLiteType>;
  /** A List of all organizations, only accessible by Limbix */
  organizations?: Maybe<Array<Maybe<OrganizationType>>>;
  organizationsByPrefix?: Maybe<Array<Maybe<OrganizationLiteType>>>;
  /** Assessment results for the current user given a specific PDT */
  participantAssessmentResults?: Maybe<Array<Maybe<ParticipantAssessmentResultType>>>;
  /** List of assignments for a study participant */
  participantAssignments?: Maybe<Array<Maybe<AssignmentType>>>;
  /** List of Clinical Concerns filtered by Limbix Study and Limbix User */
  participantClinicalConcerns?: Maybe<Array<Maybe<ClinicalConcernType>>>;
  /** List of Free Form Texts for a participant */
  participantFreeFormTexts?: Maybe<Array<Maybe<FreeFormTextType>>>;
  /** Patient profile; without patient_uid, returns one linked Patient row or errors if none */
  patient?: Maybe<PatientType>;
  /** Assessment results for a given Patient and specific PDT */
  patientAssessmentResults?: Maybe<Array<Maybe<ParticipantAssessmentResultType>>>;
  /** List of Assignments for a given patient uid and pdt uid */
  patientAssignments?: Maybe<Array<Maybe<AssignmentType>>>;
  /** Behavioral activation tasks for a Patient */
  patientBehavioralActivationTasks?: Maybe<Array<Maybe<BehavioralActivationTaskType>>>;
  /** Get a paginated list of CBT technique user data for a specific patient and PDT. */
  patientCbtTechniques?: Maybe<Array<Maybe<CbtTechniqueUserDataType>>>;
  /** get patient's dashboard data via patients email */
  patientDashboardData?: Maybe<PatientDashboardDataType>;
  /** List of the last tasks in each module for the specified patient and PDT */
  patientLastTasksData?: Maybe<Array<Maybe<TaskDataType>>>;
  /** List of mood logs for a Patient */
  patientMoodLogs?: Maybe<Array<Maybe<MoodLogType>>>;
  /** Returns list of nudges sent to caller for a given pdt */
  patientNudges?: Maybe<Array<Maybe<NudgeOpportunityType>>>;
  /** Get Patient Session information */
  patientSessions?: Maybe<Array<Maybe<SessionType>>>;
  /** Fetch a task given the specified patient, PDT, module number, and task number */
  patientTaskData?: Maybe<TaskDataType>;
  /** List of tasks for the specified patient and PDT, filtering by module number if provided */
  patientTasksData?: Maybe<Array<Maybe<TaskDataType>>>;
  /** Patient's user data for a given PDT and Patient UID */
  patientUserData?: Maybe<UserPdtDataType>;
  pdts?: Maybe<Array<Maybe<PdtType>>>;
  /** Fetch list of practitioners from given pdt UID */
  periodicPushNotifications?: Maybe<Array<Maybe<PeriodicPushNotificationType>>>;
  posthogDistinctId?: Maybe<PostHogDistinctId>;
  posthogDistinctIdWithEmail?: Maybe<PostHogDistinctId>;
  /** Fetch information about a practitioner */
  practitioner?: Maybe<PractitionerType>;
  practitionerDashboardTable?: Maybe<Array<Maybe<PractitionerDashboardTableType>>>;
  /** Get a list of a practitioner's nudges table rows for pdt identified by given uid */
  practitionerNudgesTable?: Maybe<Array<Maybe<PractitionerNudgesTableType>>>;
  /** Fetch list of practitioners from given pdt UID */
  practitioners?: Maybe<Array<Maybe<PractitionerType>>>;
  /** Get progress rewards for authenticated Daylight user */
  progressRewards?: Maybe<Array<Maybe<ProgressRewardType>>>;
  /** Research assessment results given a specific study */
  researchAssessmentResults?: Maybe<Array<Maybe<ResearchAssessmentResultType>>>;
  /** Specific external resource link given an organization */
  resourceLink?: Maybe<ResourceLinkType>;
  /** Get a specific SCI-2 data by UID */
  sci2Data?: Maybe<Sci2DataType>;
  /** Get all SCI-2 data for a user */
  sci2DataList?: Maybe<Array<Maybe<Sci2DataType>>>;
  /** Get module progress for a specific session */
  sessionProgress?: Maybe<Array<Maybe<UserSessionProgressType>>>;
  /** List of SleepioProgressReviews for the current patient, ordered by week */
  sleepioProgressChart?: Maybe<Array<Maybe<SleepioProgressChartType>>>;
  /** Specific SleepioProgressReview given its UID */
  sleepioProgressReview?: Maybe<SleepioProgressReviewType>;
  /** List of SleepioProgressReviews for the current user */
  sleepioProgressReviews?: Maybe<Array<Maybe<SleepioProgressReviewType>>>;
  /** List of Sleepio sleep diaries for the current user */
  sleepioSleepDiaries?: Maybe<Array<Maybe<SleepioSleepDiaryType>>>;
  /** Specific Sleepio sleep diary given the sleep diary UID */
  sleepioSleepDiary?: Maybe<SleepioSleepDiaryType>;
  /** Current study arm that current user is in */
  studyArm?: Maybe<StudyArmType>;
  /** Find all the assignment schedules for a particular study */
  studyAssignmentSchedules?: Maybe<Array<Maybe<AssignmentScheduleType>>>;
  /** List of participant assignments for a study */
  studyAssignments?: Maybe<Array<Maybe<AssignmentType>>>;
  /** List of assignments for a study */
  studyAssignmentsTable?: Maybe<Array<Maybe<StudyAssignmentsTableType>>>;
  /** List of Clinical Concerns filtered by Limbix Study */
  studyClinicalConcerns?: Maybe<Array<Maybe<ClinicalConcernType>>>;
  /** List of enrollment tracker results filtered by Limbix Study */
  studyEnrollmentTrackerResults?: Maybe<Array<Maybe<EnrollmentTrackerResultType>>>;
  /** List of Free Form Texts for a study */
  studyFreeFormTexts?: Maybe<Array<Maybe<FreeFormTextType>>>;
  studyParticipant?: Maybe<StudyParticipantType>;
  studyParticipants?: Maybe<Array<Maybe<StudyParticipantType>>>;
  /** List of research assignments for a study */
  studyResearchAssignments?: Maybe<Array<Maybe<AssignmentType>>>;
  /** Fetch a task given the specified PDT, module number, and task number for the current user */
  taskData?: Maybe<TaskDataType>;
  /** List of tasks for the current user and specified PDT, filtering by module number if provided */
  tasksData?: Maybe<Array<Maybe<TaskDataType>>>;
  /** Get technique unit IDs from Supabase */
  techniqueUnitIds?: Maybe<TechniqueUnitIds>;
  /** Get Terra configuration for SDK initialization */
  terraConfig?: Maybe<TerraConfigResponse>;
  /** Fetch available integrations from Terra API */
  terraIntegrations?: Maybe<TerraIntegrationsResponse>;
  /** Fetch user info from Terra API */
  terraUserInfo?: Maybe<TerraUserInfoResponse>;
  /** TOTP Authenticator for the current user */
  totpAuthenticator?: Maybe<TotpAuthenticatorType>;
  /** Specific translation given a UID */
  translation?: Maybe<TextTranslationType>;
  /** Specific user activity log given the UID */
  userActivityLog?: Maybe<UserActivityLogType>;
  /** Activities for the current user */
  userActivityLogs?: Maybe<Array<Maybe<UserActivityLogType>>>;
  /** Get daily sessions for authenticated Daylight user */
  userDailySessions?: Maybe<Array<Maybe<UserDailySessionType>>>;
  /** Current user's data for a given PDT */
  userData?: Maybe<UserPdtDataType>;
  /** Specific user log given the log UID */
  userLog?: Maybe<UserLogType>;
  /** List of user logs for the current user */
  userLogs?: Maybe<Array<Maybe<UserLogType>>>;
  /** Get user's reminder preferences with optional filters */
  userReminders?: Maybe<Array<Maybe<UserReminderType>>>;
  /** Get user responses by question IDs. Returns the most recent X responses for each question ID. */
  userResponsesByQuestionIds?: Maybe<Array<Maybe<UserResponseType>>>;
  /** Get a list of a user's weekly engagement table */
  weeklyEngagementTable?: Maybe<WeeklyEngagementTableType>;
};


export type QueryAssessmentArgs = {
  assessmentName?: InputMaybe<Scalars['String']['input']>;
  assessmentUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssessmentResultsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryAssessmentsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssignmentArgs = {
  assignmentUid?: InputMaybe<Scalars['String']['input']>;
  studyUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssignmentsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  clientType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyVisible: Scalars['Boolean']['input'];
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryBehavioralActivationTaskArgs = {
  behavioralActivationTaskUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryBehavioralActivationTasksArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryCareTeamNudgeHistoryArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  careteamUid: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryCareteamArgs = {
  careteamUid?: InputMaybe<Scalars['String']['input']>;
  patientUid?: InputMaybe<Scalars['String']['input']>;
  pdtUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareteamsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryCbtContentArgs = {
  pdtUid: Scalars['String']['input'];
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCbtTechniqueProgressArgs = {
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryClinicalConcernArgs = {
  clinicalConcernUid: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
};


export type QueryClinicalDataArgs = {
  numWeeks?: InputMaybe<Scalars['Int']['input']>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  referenceDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryDailyCheckInsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryDenyListArgs = {
  pdtUid: Scalars['String']['input'];
};


export type QueryDiaryCbtTechniquesArgs = {
  diaryDate: Scalars['Date']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryEligibilityConfigurationArgs = {
  organizationSlug: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryEligibilityStatusArgs = {
  dateOfBirth: Scalars['Date']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrollmentTrackerResultArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type QueryFeatureFlagArgs = {
  email: Scalars['String']['input'];
  featureFlagName: Scalars['String']['input'];
};


export type QueryFeatureFlagAssignmentsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  flagName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryFreeFormTextArgs = {
  freeFormTextUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryFreeFormTextsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  date: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  userUid: Scalars['String']['input'];
};


export type QueryInsightsArgs = {
  periodOffset?: InputMaybe<Scalars['Int']['input']>;
  viewType: ViewTypeEnum;
  windowSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIsIntercomTokenValidArgs = {
  token: Scalars['String']['input'];
};


export type QueryIsTutorialCompletedArgs = {
  tutorialId: Scalars['String']['input'];
};


export type QueryLastTasksDataArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryLatestSci2DataDateArgs = {
  pdtUid: Scalars['String']['input'];
};


export type QueryLearnedCbtTechniqueUserDataArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  referenceDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryLibraryItemsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  liveItemsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryLimbixStudiesArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryLimbixStudyArgs = {
  studyUid: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  locationUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLookupUserForMigrationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoodLogArgs = {
  moodLogUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryMoodLogsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryMyCareteamArgs = {
  pdtUid: Scalars['String']['input'];
};


export type QueryNudgeOpportunityArgs = {
  careteamUid: Scalars['String']['input'];
  nudgeOpportunityUid: Scalars['String']['input'];
};


export type QueryOrgPractitionerDashboardTableArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  includeChildOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUids: Array<InputMaybe<Scalars['String']['input']>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  useTopOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrgPractitionersArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  includeChildOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationUid?: InputMaybe<Scalars['String']['input']>;
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  useTopOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizationArgs = {
  organizationUid: Scalars['String']['input'];
};


export type QueryOrganizationAssignmentSchedulesArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryOrganizationNameArgs = {
  organizationSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryOrganizationsByPrefixArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prefix: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryParticipantAssessmentResultsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryParticipantAssignmentsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid?: InputMaybe<Scalars['String']['input']>;
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParticipantClinicalConcernsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type QueryParticipantFreeFormTextsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientArgs = {
  patientUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientAssessmentResultsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientAssignmentsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientBehavioralActivationTasksArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientCbtTechniquesArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientDashboardDataArgs = {
  patientEmail?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientLastTasksDataArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientMoodLogsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientNudgesArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientSessionsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientTaskDataArgs = {
  moduleNumber: Scalars['Int']['input'];
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  taskNumber: Scalars['Int']['input'];
};


export type QueryPatientTasksDataArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleNumber?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPatientUserDataArgs = {
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryPdtsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPeriodicPushNotificationsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  showExpired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPosthogDistinctIdWithEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPractitionerArgs = {
  practitionerUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPractitionerDashboardTableArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUids: Array<InputMaybe<Scalars['String']['input']>>;
  practitionerUid?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPractitionerNudgesTableArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  careteamUid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryPractitionersArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryProgressRewardsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryResearchAssessmentResultsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
};


export type QuerySci2DataArgs = {
  uid: Scalars['String']['input'];
};


export type QuerySci2DataListArgs = {
  pdtUid: Scalars['String']['input'];
};


export type QuerySessionProgressArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  sessionId: Scalars['String']['input'];
};


export type QuerySleepioProgressChartArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QuerySleepioProgressReviewArgs = {
  uid: Scalars['String']['input'];
};


export type QuerySleepioProgressReviewsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QuerySleepioSleepDiariesArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QuerySleepioSleepDiaryArgs = {
  uid: Scalars['String']['input'];
};


export type QueryStudyArmArgs = {
  pdtUid: Scalars['String']['input'];
};


export type QueryStudyAssignmentSchedulesArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
};


export type QueryStudyAssignmentsArgs = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  assessmentUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStudyAssignmentsTableArgs = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  assessmentUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studyUid: Scalars['String']['input'];
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStudyClinicalConcernsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
};


export type QueryStudyEnrollmentTrackerResultsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
};


export type QueryStudyFreeFormTextsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
};


export type QueryStudyParticipantArgs = {
  studyUid: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};


export type QueryStudyParticipantsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  studyUid: Scalars['String']['input'];
};


export type QueryStudyResearchAssignmentsArgs = {
  aboutUserUid: Scalars['String']['input'];
  studyUid: Scalars['String']['input'];
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskDataArgs = {
  moduleNumber: Scalars['Int']['input'];
  pdtUid: Scalars['String']['input'];
  taskNumber: Scalars['Int']['input'];
};


export type QueryTasksDataArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleNumber?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryTerraUserInfoArgs = {
  referenceId: Scalars['String']['input'];
};


export type QueryTranslationArgs = {
  uid: Scalars['String']['input'];
};


export type QueryUserActivityLogArgs = {
  activityLogUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryUserActivityLogsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryUserDailySessionsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryUserDataArgs = {
  pdtUid: Scalars['String']['input'];
};


export type QueryUserLogArgs = {
  logUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};


export type QueryUserLogsArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid: Scalars['String']['input'];
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryUserRemindersArgs = {
  andFilters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orFilters?: InputMaybe<Scalars['JSONString']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  reminderType?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<ReminderStatusEnum>;
};


export type QueryUserResponsesByQuestionIdsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  questionIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryWeeklyEngagementTableArgs = {
  patientUid: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
};

export type QuestionConditionInputType = {
  answer?: InputMaybe<Scalars['String']['input']>;
  isNegated?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Condition for rendering a question */
export type QuestionConditionType = {
  __typename?: 'QuestionConditionType';
  dependsOnAnswer: AnswerType;
  dependsOnQuestion: QuestionType;
  isNegated: Scalars['Boolean']['output'];
  ordinal: Scalars['Int']['output'];
  question: QuestionType;
  total?: Maybe<Scalars['Int']['output']>;
};

export type QuestionInputType = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInputType>>>;
  conditions?: InputMaybe<Array<InputMaybe<QuestionConditionInputType>>>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  keyString?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<TextTranslationInputType>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum QuestionQuestionType {
  /** Date Field */
  DateField = 'DATE_FIELD',
  /** Free-form Text */
  FreeFormText = 'FREE_FORM_TEXT',
  /** Multiple Choice */
  MultipleChoice = 'MULTIPLE_CHOICE',
  /** Multi Select */
  MultiSelect = 'MULTI_SELECT'
}

/** Question on an assessment */
export type QuestionType = {
  __typename?: 'QuestionType';
  /** Answers that are linked with a question */
  answers?: Maybe<Array<Maybe<AnswerType>>>;
  assessment: AssessmentType;
  /** Condition for rendering a question */
  conditions?: Maybe<Array<Maybe<QuestionConditionType>>>;
  isOptional: Scalars['Boolean']['output'];
  isSensitive: Scalars['Boolean']['output'];
  keyString?: Maybe<Scalars['String']['output']>;
  ordinal: Scalars['Int']['output'];
  questionType: QuestionQuestionType;
  /** Question text */
  text?: Maybe<Scalars['TranslationString']['output']>;
  /** Question text translations */
  textTranslations?: Maybe<TextTranslationType>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};


/** Question on an assessment */
export type QuestionTypeTextArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  withFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record a single log entry for practicing a CBT technique */
export type RecordCbtTechniqueLog = {
  __typename?: 'RecordCbtTechniqueLog';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Record multiple log entries for practicing CBT techniques */
export type RecordCbtTechniqueLogs = {
  __typename?: 'RecordCbtTechniqueLogs';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Record log entries for practicing CBT techniques associated with a diary date.
 * This will delete any existing logs for the given diary date that are not in the provided technique_keys.
 */
export type RecordDiaryCbtTechniqueLogs = {
  __typename?: 'RecordDiaryCbtTechniqueLogs';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Refresh an auth token given a refresh token */
export type RefreshTokenMobile = {
  __typename?: 'RefreshTokenMobile';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** Register an existing user */
export type RegisterExistingUser = {
  __typename?: 'RegisterExistingUser';
  /** Whether the study participant was registered successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Create a new account and register that user */
export type RegisterNewUser = {
  __typename?: 'RegisterNewUser';
  /** Whether the user was created and registered successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Status enum for reminder preferences */
export enum ReminderStatusEnum {
  NotSet = 'NOT_SET',
  Off = 'OFF',
  On = 'ON'
}

/** Remove a CoInvestigator */
export type RemoveStudyCoInvestigator = {
  __typename?: 'RemoveStudyCoInvestigator';
  /** Whether the Study CoInvestigator was removed successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Remove a Study Coordinator */
export type RemoveStudyCoordinator = {
  __typename?: 'RemoveStudyCoordinator';
  /** Whether the study coordinator was removed successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Result of reporting an adverse event */
export type ReportAdverseEvent = {
  __typename?: 'ReportAdverseEvent';
  /** Adverse event reported during use of a PDT */
  adverseEvent?: Maybe<AdverseEventType>;
};

/** Result of reporting a assessment result */
export type ReportAssessmentResult = {
  __typename?: 'ReportAssessmentResult';
  /** Reported assessment result */
  assessmentResult?: Maybe<AssessmentResultType>;
};

/** Report assessment answers for a Clinical Concern */
export type ReportClinicalConcern = {
  __typename?: 'ReportClinicalConcern';
  clinicalConcern?: Maybe<ClinicalConcernType>;
};

/** Result of reporting a assessment result */
export type ReportParticipantAssessmentResult = {
  __typename?: 'ReportParticipantAssessmentResult';
  /** Reported assessment result */
  participantAssessmentResult?: Maybe<ParticipantAssessmentResultType>;
};

/** Result of reporting a research assessment result */
export type ReportResearchAssessmentResult = {
  __typename?: 'ReportResearchAssessmentResult';
  /** Reported research assessment result */
  researchAssessmentResult?: Maybe<ResearchAssessmentResultType>;
};

/** Report when a user completes a task */
export type ReportTaskComplete = {
  __typename?: 'ReportTaskComplete';
  /** Task that was completed */
  taskData?: Maybe<TaskDataType>;
};

/** Report when a user starts a task */
export type ReportTaskStart = {
  __typename?: 'ReportTaskStart';
  /** Task that was started */
  taskData?: Maybe<TaskDataType>;
};

/**
 * Request account deletion
 * Immediately deactivates the user account and sends an email requesting that the user be fully deleted from all
 * Big Health systems.
 */
export type RequestAccountDeletion = {
  __typename?: 'RequestAccountDeletion';
  /** User account that was updated */
  user?: Maybe<UserType>;
};

/** Allows a user to request account removal in a self-service fashion */
export type RequestAccountRemoval = {
  __typename?: 'RequestAccountRemoval';
  /** Whether the account removal was requested successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Result of an Researcher completing an assessment */
export type ResearchAssessmentResultType = {
  __typename?: 'ResearchAssessmentResultType';
  answers?: Maybe<Scalars['JSONString']['output']>;
  assessment?: Maybe<AssessmentType>;
  assessmentAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assessmentResultItems?: Maybe<Array<Maybe<AssessmentResultItemType>>>;
  assignment?: Maybe<StudyAssignmentsTableType>;
  createdAt: Scalars['DateTime']['output'];
  lastUserToEdit?: Maybe<UserType>;
  /** Score of the assessment result */
  score?: Maybe<Scalars['Float']['output']>;
  scores?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  study: LimbixStudyType;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Resend a practitioner's access code for a pdt */
export type ResendAccessCode = {
  __typename?: 'ResendAccessCode';
  /** Whether the practitioner's access code was sent to them successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Resend verification email */
export type ResendEmailVerification = {
  __typename?: 'ResendEmailVerification';
  /** Whether the user can continue with the authentication flow without waiting for email verification */
  canContinue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the verification email successfully sent */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Re-sends the access code for a Patient */
export type ResendPatientAccessCode = {
  __typename?: 'ResendPatientAccessCode';
  /** Whether the access code was reset successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Reset users access attempts */
export type ResetAccessAttempts = {
  __typename?: 'ResetAccessAttempts';
  /** Whether the access attempts were reset successfully sent */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Send password reset email for user account */
export type ResetPassword = {
  __typename?: 'ResetPassword';
  /** Did the reset password email successfully send */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Reset a patient's access attempts */
export type ResetPatientAccessAttempts = {
  __typename?: 'ResetPatientAccessAttempts';
  /** Whether the access attempts were reset successfully sent */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** External resource link associated with a user's organization */
export type ResourceLinkType = {
  __typename?: 'ResourceLinkType';
  buttonText?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  subtitleText?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
};

/** Purpose types for clinical user responses. */
export enum ResponsePurposeType {
  EmployerReporting = 'EMPLOYER_REPORTING',
  GoalSetting = 'GOAL_SETTING'
}

export type Revoke = {
  __typename?: 'Revoke';
  revoked: Scalars['Int']['output'];
};

/** Revoke a practitioner's access code for a pdt */
export type RevokeAccessCode = {
  __typename?: 'RevokeAccessCode';
  /** Whether the practitioner's access code was revoked successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Revoke a participant's mobile access and mobile refresh tokens */
export type RevokeMobileAccess = {
  __typename?: 'RevokeMobileAccess';
  /** Whether the all mobile access has been revoked successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Revoke a patient's mobile access and mobile refresh tokens */
export type RevokePatientMobileAccess = {
  __typename?: 'RevokePatientMobileAccess';
  /** Whether the all mobile access has been revoked successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Revoke a practitioner's Provider Portal access */
export type RevokeProviderPortalAccess = {
  __typename?: 'RevokeProviderPortalAccess';
  /** Whether the practitioner's Provider Portal access was revoked successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RewardResultType = {
  __typename?: 'RewardResultType';
  identifier?: Maybe<Scalars['String']['output']>;
  starCount?: Maybe<Scalars['Int']['output']>;
  triggered?: Maybe<Scalars['Boolean']['output']>;
};

/** Save the information the user enters on the coverage check screen. */
export type SaveCoverageDetails = {
  __typename?: 'SaveCoverageDetails';
  /** Email of the user */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether coverage details were saved successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** User uid */
  userUid?: Maybe<Scalars['String']['output']>;
};

/**
 * Save enrollment response data received from an external enrollment partner for a given care team.
 * Creates or updates the ExternalEnrollmentResponse record associated with the care team.
 *
 * Note: Enrollment data means data from when a user hit a billing point
 */
export type SaveExternalEnrollmentData = {
  __typename?: 'SaveExternalEnrollmentData';
  /** Whether the enrollment data was saved successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Save the user's password and activate the user. */
export type SavePasswordAndActivateSoleraUser = {
  __typename?: 'SavePasswordAndActivateSoleraUser';
  /** Auth token for the user if successful */
  authToken?: Maybe<TokenAuth>;
  /** Whether password was saved successfully and user was activated */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Save the user's password and activate the user. */
export type SavePasswordAndActivateUser = {
  __typename?: 'SavePasswordAndActivateUser';
  /** Auth token for the user if successful */
  authToken?: Maybe<TokenAuth>;
  /** Whether password was saved successfully and user was activated */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Schedule an Iterable campaign for a user */
export type ScheduleIterableCampaign = {
  __typename?: 'ScheduleIterableCampaign';
  /** Whether the campaign was scheduled successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Schedule a periodic push notification */
export type SchedulePeriodicPushNotification = {
  __typename?: 'SchedulePeriodicPushNotification';
  /** Scheduled periodic notification */
  periodicNotification?: Maybe<PeriodicPushNotificationType>;
};

/** Schedule a periodic push notification */
export type SchedulePeriodicPushNotificationByName = {
  __typename?: 'SchedulePeriodicPushNotificationByName';
  /** Scheduled periodic notification */
  periodicNotification?: Maybe<PeriodicPushNotificationType>;
};

/** Schedule a push notification */
export type SchedulePushNotification = {
  __typename?: 'SchedulePushNotification';
  /** Scheduled notification task */
  notificationTask?: Maybe<NotificationTaskType>;
};

/** Schedule a push notification */
export type SchedulePushNotificationByName = {
  __typename?: 'SchedulePushNotificationByName';
  /** Scheduled notification task */
  notificationTask?: Maybe<NotificationTaskType>;
};

/** Updates a single field for a user in Iterable asynchronously. Mostly used for testing and/or manual manipulation */
export type ScheduleUpdateIterableFieldForUser = {
  __typename?: 'ScheduleUpdateIterableFieldForUser';
  /** Whether the update was scheduled. Always true, errors otherwise */
  scheduled?: Maybe<Scalars['Boolean']['output']>;
};

/** Common arguments for creating and updating a Sci2Data */
export type Sci2DataInputType = {
  /** How many nights have you had a sleep problem? */
  howManyNightsSleepProblem: Scalars['Int']['input'];
  /** How much has sleep troubled you? */
  howMuchHasSleepTroubled: Scalars['Int']['input'];
  /** The number of the week within the program that this SCI-2 data is for */
  weekNumber: Scalars['Int']['input'];
};

/** SCI-2 Data */
export type Sci2DataType = {
  __typename?: 'Sci2DataType';
  createdAt: Scalars['DateTime']['output'];
  howManyNightsSleepProblem: Scalars['Int']['output'];
  howMuchHasSleepTroubled: Scalars['Int']['output'];
  /** Calculated SCI-2 score */
  sci2Score?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  weekNumber: Scalars['Int']['output'];
};

/** Allows study participants to create their own accounts in app with an access code */
export type SelfServeCreateParticipant = {
  __typename?: 'SelfServeCreateParticipant';
  /** The study participant that was created */
  studyParticipant?: Maybe<StudyParticipantType>;
};

/** Allows patients to create their own accounts in app */
export type SelfServeCreatePatient = {
  __typename?: 'SelfServeCreatePatient';
  /** The Patient that was created */
  patient?: Maybe<PatientType>;
  /** Whether patient was created */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Allows practitioners to create their own accounts */
export type SelfServeCreatePractitioner = {
  __typename?: 'SelfServeCreatePractitioner';
  /** The outcome of creating a Practitioner */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Sends verification email for new user coming in on the Solera flow, who changed their email */
export type SendEmailChangeVerification = {
  __typename?: 'SendEmailChangeVerification';
  /** Whether the verification email successfully sent */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** SendNudge marks who sent a nudge and when it was sent */
export type SendNudge = {
  __typename?: 'SendNudge';
  /** Nudge sent */
  nudge?: Maybe<NudgeOpportunityType>;
  /** Whether the nudge was sent */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReadyToDownloadSms = {
  __typename?: 'SendReadyToDownloadSMS';
  /** Whether SMS was scheduled successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Sessions */
export type SessionType = {
  __typename?: 'SessionType';
  deviceBrandName: Scalars['String']['output'];
  deviceModelName: Scalars['String']['output'];
  deviceOperatingSystem: Scalars['String']['output'];
  deviceOperatingSystemVersion: Scalars['String']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  pdt: PdtType;
  startTime: Scalars['DateTime']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  user: UserType;
};

/** Set the user as having verified their email address. */
export type SetEmailVerified = {
  __typename?: 'SetEmailVerified';
  /** Unique identifier for PostHog */
  distinctId?: Maybe<Scalars['String']['output']>;
  /** Email for user */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether email_verified was set successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** User uid */
  userUid?: Maybe<Scalars['String']['output']>;
};

/** Blinds or unblinds a user for a particular study */
export type SetUserBlinded = {
  __typename?: 'SetUserBlinded';
  /** Whether the user was blinded/unblinded successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Create or update a user's reminder preference.
 * If a reminder already exists for the user/product/reminder_type/time combination,
 * it will be updated. Otherwise, a new one will be created.
 */
export type SetUserReminder = {
  __typename?: 'SetUserReminder';
  /** The created or updated reminder */
  userReminder?: Maybe<UserReminderType>;
};

/** Sleepio Chart data, mostly populated from SleepioProgressReviewWeek */
export type SleepioProgressChartType = {
  __typename?: 'SleepioProgressChartType';
  averageSleepEfficiency?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

/** Common arguments for creating and updating a SleepioProgressReview */
export type SleepioProgressReviewInputType = {
  /** Do you have a hard time staying awake? */
  hardTimeStayingAwake: Scalars['Boolean']['input'];
  /** How have you been dealing with sleep? */
  howBeenDealingWithSleep: Scalars['Int']['input'];
  /** How many nights have you had a sleep problem? */
  howManyNightsSleepProblem?: InputMaybe<Scalars['Int']['input']>;
  /** How much has sleep troubled you? */
  howMuchHasSleepTroubled?: InputMaybe<Scalars['Int']['input']>;
  /** How much has poor sleep affected your daytime goal? */
  howMuchPoorSleepAffectedDaytimeGoal: Scalars['Int']['input'];
  /** How much has poor sleep affected your emotional goal? */
  howMuchPoorSleepAffectedEmotionalGoal: Scalars['Int']['input'];
  /** The number of the week within the program that this progress review is for */
  progressReviewWeekNumber: Scalars['Int']['input'];
};

/** Sleepio Progress Review */
export type SleepioProgressReviewType = {
  __typename?: 'SleepioProgressReviewType';
  createdAt: Scalars['DateTime']['output'];
  hardTimeStayingAwake: Scalars['Boolean']['output'];
  howBeenDealingWithSleep: Scalars['Int']['output'];
  howManyNightsSleepProblem?: Maybe<Scalars['Int']['output']>;
  howMuchHasSleepTroubled?: Maybe<Scalars['Int']['output']>;
  howMuchPoorSleepAffectedDaytimeGoal: Scalars['Int']['output'];
  howMuchPoorSleepAffectedEmotionalGoal: Scalars['Int']['output'];
  progressReviewWeekNumber: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** Type for inputting a SleepioProgressReviewWeek to a mutation */
export type SleepioProgressReviewWeekInputType = {
  /** The average rest level reported by the user this week */
  averageRestLevel: Scalars['Float']['input'];
  /** The average sleep efficiency calculated for this week */
  averageSleepEfficiency: Scalars['Float']['input'];
  /** The average total time the user was asleep each night this week, in minutes */
  averageTimeAsleep: Scalars['Float']['input'];
  /** The average time the user was awake during the night this week, in minutes */
  averageTimeAwake: Scalars['Float']['input'];
  /** The average total time the user spent in bed each night this week, in minutes */
  averageTimeInBed: Scalars['Float']['input'];
  /** The average time it took the user to fall asleep this week, in minutes */
  averageTimeToFallAsleep: Scalars['Float']['input'];
  /** The UIDs of the sleep diaries that were aggregated to create this week's data */
  diariesAggregated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The week number this data is for */
  weekNumber: Scalars['Int']['input'];
};

/** SleepioSleepDiary that a user creates during use of a PDT */
export type SleepioSleepDiaryType = {
  __typename?: 'SleepioSleepDiaryType';
  awakeDuringNight: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  disturbances: Array<Scalars['String']['output']>;
  entryType: Scalars['String']['output'];
  getIntoBedTime: Scalars['DateTime']['output'];
  getOutOfBedTime: Scalars['DateTime']['output'];
  restLevel: Scalars['Int']['output'];
  riseImmediately: Scalars['Boolean']['output'];
  sleepEfficiency: Scalars['Float']['output'];
  timeAsleep: Scalars['Int']['output'];
  timeAwake: Scalars['Int']['output'];
  timeInBed: Scalars['Int']['output'];
  timeToFallAsleep: Scalars['Int']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  tryToSleepTime?: Maybe<Scalars['DateTime']['output']>;
  uid: Scalars['String']['output'];
  userSlept: Scalars['Boolean']['output'];
  wakeUpTime: Scalars['DateTime']['output'];
};

/** Result of starting an assignment */
export type StartAssignment = {
  __typename?: 'StartAssignment';
  /** Assignment that was started */
  assignment?: Maybe<AssignmentType>;
};

/** Result of starting an assignment */
export type StartResearchAssignment = {
  __typename?: 'StartResearchAssignment';
  /** Assignment that was started */
  assignment?: Maybe<AssignmentType>;
};

/** Arm of a Limbix study */
export type StudyArmType = {
  __typename?: 'StudyArmType';
  isControl: Scalars['Boolean']['output'];
  isInitialArm: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** Study Assignments Table */
export type StudyAssignmentsTableType = {
  __typename?: 'StudyAssignmentsTableType';
  aboutParticipantId?: Maybe<Scalars['String']['output']>;
  aboutUser?: Maybe<UserType>;
  accountType: AssignmentAccountType;
  assessment?: Maybe<AssessmentType>;
  canEditAfterCompletion: Scalars['Boolean']['output'];
  canSkipQuestions: Scalars['Boolean']['output'];
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  ordinal: Scalars['Int']['output'];
  organization?: Maybe<OrganizationType>;
  participantId?: Maybe<Scalars['String']['output']>;
  participantStatus?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study?: Maybe<LimbixStudyType>;
  total?: Maybe<Scalars['Int']['output']>;
  typeOfAssignment: AssignmentTypeOfAssignment;
  typeOfClient: AssignmentTypeOfClient;
  uid: Scalars['String']['output'];
  user?: Maybe<UserType>;
  visibleDate: Scalars['DateTime']['output'];
  weekInProgram?: Maybe<Scalars['String']['output']>;
};

/** Study Participant */
export type StudyParticipantType = {
  __typename?: 'StudyParticipantType';
  activationTime?: Maybe<Scalars['DateTime']['output']>;
  behavioralActivations?: Maybe<Array<Maybe<BehavioralActivationTaskType>>>;
  canAccessPdt?: Maybe<Scalars['Boolean']['output']>;
  canActivate?: Maybe<Scalars['Boolean']['output']>;
  canBeDropped?: Maybe<Scalars['Boolean']['output']>;
  canBeLostToFollowup?: Maybe<Scalars['Boolean']['output']>;
  canComplete?: Maybe<Scalars['Boolean']['output']>;
  canScreenFail?: Maybe<Scalars['Boolean']['output']>;
  canWithdraw?: Maybe<Scalars['Boolean']['output']>;
  caseReportFormData?: Maybe<Scalars['String']['output']>;
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentArmStartTime?: Maybe<Scalars['DateTime']['output']>;
  deteriorationAlerts?: Maybe<Array<Maybe<Scalars['JSONString']['output']>>>;
  droppedTime?: Maybe<Scalars['DateTime']['output']>;
  enrollmentTrackerResult?: Maybe<EnrollmentTrackerResultType>;
  exitReason?: Maybe<Scalars['String']['output']>;
  hasMobileTokens?: Maybe<Scalars['Boolean']['output']>;
  lostToFollowupTime?: Maybe<Scalars['DateTime']['output']>;
  moodLogs?: Maybe<Array<Maybe<MoodLogType>>>;
  notes?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  screenFailTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study: LimbixStudyType;
  studyArm?: Maybe<StudyArmType>;
  tasks?: Maybe<Array<Maybe<TaskDataType>>>;
  total?: Maybe<Scalars['Int']['output']>;
  turnsEighteenWhileEnrolled?: Maybe<Scalars['Boolean']['output']>;
  user: UserType;
  userLogs?: Maybe<Array<Maybe<UserLogType>>>;
  userPdtData?: Maybe<UserPdtDataType>;
  withdrawTime?: Maybe<Scalars['DateTime']['output']>;
};

/** Task that a user engages in during use of a PDT */
export type TaskDataType = {
  __typename?: 'TaskDataType';
  appData?: Maybe<Scalars['JSONString']['output']>;
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  moduleNumber: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  taskNumber: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export type TechniqueUnit = {
  __typename?: 'TechniqueUnit';
  contentfulUnitId?: Maybe<Scalars['String']['output']>;
  techniqueId?: Maybe<Scalars['String']['output']>;
};

export type TechniqueUnitIds = {
  __typename?: 'TechniqueUnitIds';
  techniqueUnits?: Maybe<Array<Maybe<TechniqueUnit>>>;
};

export type TerraConfigResponse = {
  __typename?: 'TerraConfigResponse';
  /** Terra developer ID for SDK initialization */
  developerId: Scalars['String']['output'];
};

export type TerraDeauthenticateUser = {
  __typename?: 'TerraDeauthenticateUser';
  /** Response status from Terra API */
  status?: Maybe<Scalars['String']['output']>;
};

export type TerraGenerateAuthToken = {
  __typename?: 'TerraGenerateAuthToken';
  /** Token expiry time in seconds */
  expiresIn?: Maybe<Scalars['Int']['output']>;
  /** Response status from Terra API */
  status?: Maybe<Scalars['String']['output']>;
  /** Auth token for Terra SDK initConnection() */
  token?: Maybe<Scalars['String']['output']>;
};

export type TerraIntegrationType = {
  __typename?: 'TerraIntegrationType';
  /** Whether this integration is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** URL to the integration icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Display name of the integration */
  name?: Maybe<Scalars['String']['output']>;
  /** Provider identifier (e.g. APPLE, FITBIT) */
  provider?: Maybe<Scalars['String']['output']>;
  /** Setup method (e.g. sdk, widget) */
  setup?: Maybe<Scalars['String']['output']>;
  /** Supported data types */
  types?: Maybe<TerraIntegrationTypesType>;
};

export type TerraIntegrationTypesType = {
  __typename?: 'TerraIntegrationTypesType';
  activity?: Maybe<Scalars['Boolean']['output']>;
  body?: Maybe<Scalars['Boolean']['output']>;
  daily?: Maybe<Scalars['Boolean']['output']>;
  menstruation?: Maybe<Scalars['Boolean']['output']>;
  nutrition?: Maybe<Scalars['Boolean']['output']>;
  sleep?: Maybe<Scalars['Boolean']['output']>;
};

export type TerraIntegrationsResponse = {
  __typename?: 'TerraIntegrationsResponse';
  /** Available provider integrations */
  providers?: Maybe<Array<Maybe<TerraIntegrationType>>>;
  /** Response status from Terra API */
  status?: Maybe<Scalars['String']['output']>;
};

export type TerraUserInfoResponse = {
  __typename?: 'TerraUserInfoResponse';
  /** List of Terra user connections for this reference ID */
  users?: Maybe<Array<Maybe<TerraUserType>>>;
};

export type TerraUserType = {
  __typename?: 'TerraUserType';
  /** Whether this user connection receives data updates */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Last time a webhook update was sent for this connection */
  lastWebhookUpdate?: Maybe<Scalars['String']['output']>;
  /** Connection data source (e.g. APPLE, FITBIT) */
  provider?: Maybe<Scalars['String']['output']>;
  /** Developer-side identifier tying this connection back to a user */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Permissions granted during authentication */
  scopes?: Maybe<Scalars['String']['output']>;
  /** Terra identifier for the wearable connection */
  userId?: Maybe<Scalars['String']['output']>;
};

export type TextTranslationInputType = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  ko?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** A translation object */
export type TextTranslationType = {
  __typename?: 'TextTranslationType';
  en: Scalars['String']['output'];
  es?: Maybe<Scalars['String']['output']>;
  ko?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export type TokenAuth = {
  __typename?: 'TokenAuth';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
  /** User account associated with credentials */
  user?: Maybe<UserType>;
};

export type TokenAuthMfa = {
  __typename?: 'TokenAuthMFA';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
  /** User account associated with credentials */
  user?: Maybe<UserType>;
};

/** Get mobile auth token for an account given valid credentials */
export type TokenAuthMobile = {
  __typename?: 'TokenAuthMobile';
  /** Whether the current user can access the given PDT */
  canAccessPdt?: Maybe<Scalars['Boolean']['output']>;
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
  /** User account associated with credentials */
  user?: Maybe<UserType>;
};

/** TOTP Authenticator */
export type TotpAuthenticatorType = {
  __typename?: 'TotpAuthenticatorType';
  qrcodeSvg?: Maybe<Scalars['String']['output']>;
};

/** Transition User with Account Type 'Child' To 'Adult' */
export type TransitionToAdult = {
  __typename?: 'TransitionToAdult';
  /** Whether the user was transitioned to adult successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a tutorial that has been viewed by a user */
export type TutorialViewType = {
  __typename?: 'TutorialViewType';
  /** Timestamp when the user completed or skipped the tutorial. Tutorial will not show again if this is set. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when the user first saw the tutorial */
  firstSeenAt: Scalars['DateTime']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the tutorial (e.g. '5Ce40OBlYiGMAuQ14b0cAQ') */
  tutorialId: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Update when app usage started */
export type UpdateAppStartDate = {
  __typename?: 'UpdateAppStartDate';
  /** User data with updated app start date */
  userData?: Maybe<UserPdtDataType>;
};

/** Update baseline data for a user */
export type UpdateBaselineData = {
  __typename?: 'UpdateBaselineData';
  /** User PDT specific data that was updated */
  userData?: Maybe<UserPdtDataType>;
};

/** Update when baseline quiz starts */
export type UpdateBaselineQuizStart = {
  __typename?: 'UpdateBaselineQuizStart';
  /** User data with updated baseline quiz start */
  userData?: Maybe<UserPdtDataType>;
};

/** Update user's baseline sleep efficiency score */
export type UpdateBaselineSleepEfficiencyScore = {
  __typename?: 'UpdateBaselineSleepEfficiencyScore';
  /** User data with baseline sleep efficiency score */
  userData?: Maybe<UserPdtDataType>;
};

/** Update user's baseline sleep quality score */
export type UpdateBaselineSleepQualityScore = {
  __typename?: 'UpdateBaselineSleepQualityScore';
  /** User data with baseline sleep quality score */
  userData?: Maybe<UserPdtDataType>;
};

/** Legacy update a behavioral activation task */
export type UpdateBehavioralActivationTask = {
  __typename?: 'UpdateBehavioralActivationTask';
  /** Behavioral activation user engages in during use of a PDT */
  behavioralActivationTask?: Maybe<BehavioralActivationTaskType>;
};

/** Update user's current module and task number */
export type UpdateCurrentModuleAndTask = {
  __typename?: 'UpdateCurrentModuleAndTask';
  /** User data with updated current module and task number */
  userData?: Maybe<UserPdtDataType>;
};

/** Report assessment answers for an Enrollment Tracker assessment */
export type UpdateEnrollmentTracker = {
  __typename?: 'UpdateEnrollmentTracker';
  enrollmentTrackerResult?: Maybe<EnrollmentTrackerResultType>;
};

/** Updates a single field for a user in Iterable. Mostly used for testing and/or manual manipulation */
export type UpdateIterableFieldForUser = {
  __typename?: 'UpdateIterableFieldForUser';
  /** Whether the field was successfully updated */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update the last date/time user engaged with the application */
export type UpdateLastEngagementTime = {
  __typename?: 'UpdateLastEngagementTime';
  /** User data with updated last engagement date/time */
  userData?: Maybe<UserPdtDataType>;
};

/** Update local timezone associated with user account */
export type UpdateLocalTimezone = {
  __typename?: 'UpdateLocalTimezone';
  /** User account that was updated */
  user?: Maybe<UserType>;
};

/** Legacy method for updating a mood log */
export type UpdateMoodLog = {
  __typename?: 'UpdateMoodLog';
  /** Mood log that was updated */
  moodLog?: Maybe<MoodLogType>;
};

/** Update the date when in-app onboarding was started */
export type UpdateOnboardingStartDate = {
  __typename?: 'UpdateOnboardingStartDate';
  /** User data with updated onboarding start date */
  userData?: Maybe<UserPdtDataType>;
};

/** Create/Edit an FCM device */
export type UpdateOrCreateFcmDevice = {
  __typename?: 'UpdateOrCreateFCMDevice';
  /** Device that was created or edited */
  fcmDevice?: Maybe<FcmDeviceType>;
};

/** Reset the password for user account */
export type UpdatePassword = {
  __typename?: 'UpdatePassword';
  /** URL to redirect to on success */
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Update user data on posthog profile */
export type UpdatePosthogProfileUserData = {
  __typename?: 'UpdatePosthogProfileUserData';
  /** Updated posthog profile user data */
  profileUserData?: Maybe<Scalars['GenericScalar']['output']>;
};

/**
 * It is responsible for updating the 'research_study_id'
 * field in the UserPdtData model.
 */
export type UpdateResearchStudyId = {
  __typename?: 'UpdateResearchStudyId';
  /** User data with updated research study id */
  userData?: Maybe<UserPdtDataType>;
};

/** Update a Sci2Data */
export type UpdateSci2Data = {
  __typename?: 'UpdateSci2Data';
  /** The Sci2Data that was updated */
  sci2Data?: Maybe<Sci2DataType>;
};

/** Update a SleepioProgressReview */
export type UpdateSleepioProgressReview = {
  __typename?: 'UpdateSleepioProgressReview';
  /** The SleepioProgressReview that was updated */
  sleepioProgressReview?: Maybe<SleepioProgressReviewType>;
};

/** Update a SleepioSleepDiary */
export type UpdateSleepioSleepDiary = {
  __typename?: 'UpdateSleepioSleepDiary';
  /** Sleepio sleep diary that was updated */
  sleepioSleepDiary?: Maybe<SleepioSleepDiaryType>;
};

/** Update or Create Assignment Schedules for a given Study UID */
export type UpdateStudyAssignmentSchedule = {
  __typename?: 'UpdateStudyAssignmentSchedule';
  assignmentSchedule?: Maybe<AssignmentScheduleType>;
};

/** Update the Name of a Study */
export type UpdateStudyName = {
  __typename?: 'UpdateStudyName';
  /** Whether the study's name was updated successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update additional data associated with a task */
export type UpdateTaskAppData = {
  __typename?: 'UpdateTaskAppData';
  taskData?: Maybe<TaskDataType>;
};

/** Update user's acknowledgement of various consent forms */
export type UpdateUserAcknowledgement = {
  __typename?: 'UpdateUserAcknowledgement';
  /** User data with updated acknowledgement */
  userData?: Maybe<UserPdtDataType>;
};

/** Update a user activity log */
export type UpdateUserActivityLog = {
  __typename?: 'UpdateUserActivityLog';
  /** User activity log user engages in during use of a PDT */
  userActivityLog?: Maybe<UserActivityLogType>;
};

/** Update billable date for a user */
export type UpdateUserBillable = {
  __typename?: 'UpdateUserBillable';
  /** User who has hit billable point */
  user?: Maybe<UserType>;
};

/** Update language associated with user account */
export type UpdateUserLanguage = {
  __typename?: 'UpdateUserLanguage';
  /** User whose language was updated */
  user?: Maybe<UserType>;
};

/** Update a log */
export type UpdateUserLog = {
  __typename?: 'UpdateUserLog';
  /** UserLog that was updated */
  userLog?: Maybe<UserLogType>;
};

/** Update phone number associated with user account */
export type UpdateUserPhoneNumber = {
  __typename?: 'UpdateUserPhoneNumber';
  /** User whose phone number was updated */
  user?: Maybe<UserType>;
};

/** Update user's settings for a given PDT */
export type UpdateUserSettings = {
  __typename?: 'UpdateUserSettings';
  /** User PDT specific data that was updated */
  userData?: Maybe<UserPdtDataType>;
};

/** Batch upsert clinical user responses. Creates or reuses a single clinical check-in for all responses. */
export type UpsertBatchClinicalUserResponse = {
  __typename?: 'UpsertBatchClinicalUserResponse';
  /** The clinical check-in (created or reused) */
  checkIn?: Maybe<ClinicalCheckInType>;
  /** The created or updated clinical user responses */
  responses?: Maybe<Array<Maybe<ClinicalUserResponseType>>>;
};

/** Upserts a clinical user response to a standardized clinical question. */
export type UpsertClinicalUserResponse = {
  __typename?: 'UpsertClinicalUserResponse';
  response?: Maybe<ClinicalUserResponseType>;
};

/** Upsert a daily check-in. */
export type UpsertDailyCheckIn = {
  __typename?: 'UpsertDailyCheckIn';
  checkIn?: Maybe<DailyCheckInType>;
};

/** Create or update a progress reward for a specific user */
export type UpsertProgressReward = {
  __typename?: 'UpsertProgressReward';
  reward?: Maybe<ProgressRewardType>;
};

/** Create or update progress tracking for a specific module within a session. */
export type UpsertSessionProgress = {
  __typename?: 'UpsertSessionProgress';
  progress?: Maybe<UserSessionProgressType>;
};

/** Upserts a daily session. */
export type UpsertUserDailySession = {
  __typename?: 'UpsertUserDailySession';
  session?: Maybe<UserDailySessionType>;
};

/** Upserts a user response to a question. */
export type UpsertUserResponse = {
  __typename?: 'UpsertUserResponse';
  response?: Maybe<UserResponseType>;
  rewards?: Maybe<Array<Maybe<RewardResultType>>>;
};

/** An enumeration. */
export enum UserActivityLogActivityType {
  /** Behavioral Activation */
  Ba = 'BA',
  /** Exposure */
  Exposure = 'EXPOSURE'
}

/** Activity that a user engages in during use of a PDT */
export type UserActivityLogType = {
  __typename?: 'UserActivityLogType';
  activity?: Maybe<Scalars['String']['output']>;
  activityType: UserActivityLogActivityType;
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  didCompleteScheduledActivation: Scalars['Boolean']['output'];
  extraData?: Maybe<Scalars['JSONString']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum UserDailySessionStatus {
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS'
}

/** Daily therapeutic session based on check-in. */
export type UserDailySessionType = {
  __typename?: 'UserDailySessionType';
  /** Check-in linked to this session */
  checkIn?: Maybe<DailyCheckInType>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reference to Supabase contentful_daily_session.id */
  contentfulDailySessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the user daily session */
  id: Scalars['UUID']['output'];
  /** Module progress for this session */
  progress?: Maybe<Array<Maybe<UserSessionProgressType>>>;
  status?: Maybe<UserDailySessionStatus>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum UserLogCategory {
  /** Mood Log */
  MoodLog = 'MOOD_LOG',
  /** Thought Checker */
  ThoughtChecker = 'THOUGHT_CHECKER',
  /** Wrap Up Your Day */
  WrapUpYourDay = 'WRAP_UP_YOUR_DAY'
}

/** UserLog that a user creates during use of a PDT */
export type UserLogType = {
  __typename?: 'UserLogType';
  category: UserLogCategory;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  extraData?: Maybe<Scalars['JSONString']['output']>;
  mood?: Maybe<Scalars['String']['output']>;
  sudsRating?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

/** PDT specific user data */
export type UserPdtDataType = {
  __typename?: 'UserPdtDataType';
  appAccessDurationDays?: Maybe<Scalars['Int']['output']>;
  appAccessExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  appSettings?: Maybe<Scalars['JSONString']['output']>;
  appStartDate?: Maybe<Scalars['DateTime']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  baselineData?: Maybe<Scalars['JSONString']['output']>;
  baselineQuizStartTimestamp?: Maybe<Scalars['DateTime']['output']>;
  baselineSleepEfficiencyScore?: Maybe<Scalars['Float']['output']>;
  baselineSleepQualityScore?: Maybe<Scalars['Int']['output']>;
  behavioralActivationTasks?: Maybe<Array<Maybe<BehavioralActivationTaskType>>>;
  billableDate?: Maybe<Scalars['DateTime']['output']>;
  currentModuleNumber: Scalars['Int']['output'];
  currentTaskNumber: Scalars['Int']['output'];
  devModeAllowed: Scalars['Boolean']['output'];
  historicalAdherenceScore?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  initialAppVersion?: Maybe<Scalars['String']['output']>;
  lastAccessCodeSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastEngagementTime?: Maybe<Scalars['DateTime']['output']>;
  lastTaskCompleteTime?: Maybe<Scalars['DateTime']['output']>;
  latestAdherenceScore?: Maybe<Scalars['Int']['output']>;
  minimumVersionNumber?: Maybe<Scalars['String']['output']>;
  minutesSpentInApp?: Maybe<Scalars['Int']['output']>;
  moodLogs?: Maybe<Array<Maybe<MoodLogType>>>;
  moodTrackingTimerStart?: Maybe<Scalars['DateTime']['output']>;
  notIntendedToTreatAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingStartDate?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationSlug?: Maybe<Scalars['String']['output']>;
  pdt: PdtType;
  researchStudyId?: Maybe<Scalars['String']['output']>;
  safetyAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  termsAndPrivacyAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  textConsentAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  textEncryptionEnabled: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  user: UserType;
  userActivityLogs?: Maybe<Array<Maybe<UserActivityLogType>>>;
  userLogs?: Maybe<Array<Maybe<UserLogType>>>;
};

/** User's reminder preference for a specific product and reminder type */
export type UserReminderType = {
  __typename?: 'UserReminderType';
  createdAt: Scalars['DateTime']['output'];
  product?: Maybe<PdtType>;
  /** Type of reminder (e.g., 'sleep_diary', 'daily_learning') */
  reminderType: Scalars['String']['output'];
  status?: Maybe<ReminderStatusEnum>;
  time?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

/**
 * User responses to daily check-in questions.
 * Questions are defined in Contentful via CBT Config.
 */
export type UserResponseType = {
  __typename?: 'UserResponseType';
  /** Reference to question ID from CBT Config/Contentful */
  contentfulQuestionId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user response */
  id: Scalars['UUID']['output'];
  respondedAt: Scalars['DateTime']['output'];
  /** Decimal response for precise measurements */
  responseDecimal?: Maybe<Scalars['Decimal']['output']>;
  /** Integer response for scale/numeric questions */
  responseInt?: Maybe<Scalars['Int']['output']>;
  /** Text response for text/multiple choice questions */
  responseText?: Maybe<Scalars['String']['output']>;
  rewardStarCount?: Maybe<Scalars['Int']['output']>;
  rewardTriggered?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum UserSessionProgressStatus {
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS'
}

/** Module-level progress within a daily session. */
export type UserSessionProgressType = {
  __typename?: 'UserSessionProgressType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Contentful module identifier */
  contentfulModuleId?: Maybe<Scalars['String']['output']>;
  /** Contentful technique identifier */
  contentfulTechniqueId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the user session progress */
  id: Scalars['UUID']['output'];
  /** Module name within session (e.g., check_in, learn_it, try_it, do_it) */
  moduleName: Scalars['String']['output'];
  /** Order of module within session */
  moduleOrder?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<UserSessionProgressStatus>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** User account information */
export type UserType = {
  __typename?: 'UserType';
  accessAttempts?: Maybe<Scalars['Int']['output']>;
  accountType: LimbixUserAccountType;
  ageAtEnrollment?: Maybe<Scalars['Int']['output']>;
  baselinePhqScore?: Maybe<Scalars['Float']['output']>;
  billableDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentAge?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<LimbixUserGender>;
  isActive: Scalars['Boolean']['output'];
  isBlindedForStudy?: Maybe<Scalars['Boolean']['output']>;
  isOperations: Scalars['Boolean']['output'];
  isResearch: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  language: LimbixUserLanguage;
  lastName?: Maybe<Scalars['String']['output']>;
  localTimezone: LimbixUserLocalTimezone;
  notIntendedToTreatAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  parents: Array<UserType>;
  phone?: Maybe<Scalars['String']['output']>;
  posthogDistinctId?: Maybe<Scalars['String']['output']>;
  posthogProfileUrl?: Maybe<Scalars['String']['output']>;
  safetyAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  termsAndPrivacyAcknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};


/** User account information */
export type UserTypeIsBlindedForStudyArgs = {
  studyUid?: InputMaybe<Scalars['String']['input']>;
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar']['output'];
};

/** Verify if an access code is valid for a given PDT UID */
export type VerifyAccessCode = {
  __typename?: 'VerifyAccessCode';
  /** Whether the access code is valid */
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Verify patient email against access code.
 *
 * Server-to-server mutation called by Vercel during Spark activation.
 * Returns limbix_user_id and org_slug if the submitted email matches the
 * email on file for the access code's patient. Raises a generic error on
 * any mismatch.
 *
 * Model chain (guaranteed by Orders API):
 *     PatientAccessCode → CareTeam → Patient → LimbixUser
 *     PatientAccessCode → CareTeam → Organization (for org_slug)
 *
 * Security:
 *     - JWT service auth (vercel-auth) — not public
 *     - Same error for not-found and mismatch — never reveals if code exists
 *     - HIPAA-safe logging (hashed identifiers only)
 *     - Email comparison is case-insensitive
 */
export type VerifyEmail = {
  __typename?: 'VerifyEmail';
  /** The patient's LimbixUser UID (ShortUUID). Only returned on successful email verification. */
  limbixUserId?: Maybe<Scalars['String']['output']>;
  /** The slug of the organization associated with this patient's care team. */
  orgSlug?: Maybe<Scalars['String']['output']>;
};

/**
 * Verify patient phone number against access code.
 *
 * Server-to-server mutation called by Vercel during Spark activation.
 * Returns limbix_user_id and org_slug if the submitted phone matches the
 * phone on file for the access code's patient. Raises a generic error on
 * any mismatch.
 *
 * Model chain (guaranteed by Orders API in Phase 1):
 *     PatientAccessCode → CareTeam → Patient → LimbixUser
 *     PatientAccessCode → CareTeam → Organization (for org_slug)
 *
 * Security:
 *     - JWT service auth (vercel-auth) — not public
 *     - Same error for not-found and mismatch — never reveals if code exists
 *     - HIPAA-safe logging (hashed identifiers only)
 *     - Phone normalized to E.164 before comparison
 */
export type VerifyPhone = {
  __typename?: 'VerifyPhone';
  /** The patient's LimbixUser UID (ShortUUID). Only returned on successful phone verification. */
  limbixUserId?: Maybe<Scalars['String']['output']>;
  /** The slug of the organization associated with this patient's care team. */
  orgSlug?: Maybe<Scalars['String']['output']>;
};

/** Enum for insights view type selection. */
export enum ViewTypeEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Weekly Engagement Table */
export type WeeklyEngagementTableType = {
  __typename?: 'WeeklyEngagementTableType';
  averageRestLevel?: Maybe<Scalars['Float']['output']>;
  averageSleepEfficiency?: Maybe<Scalars['Float']['output']>;
  programProgress?: Maybe<ProgramProgess>;
  totalActiveDaysOfWeek?: Maybe<Scalars['String']['output']>;
};

/** Withdraw a study participant */
export type WithdrawParticipant = {
  __typename?: 'WithdrawParticipant';
  /** Whether the study participant was withdrawn successfully */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  clientType: Scalars['String']['input'];
}>;


export type RequestTokenMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'TokenAuth', token: string, refreshToken: string, user?: { __typename?: 'UserType', uid: string, emailVerified: boolean, firstName?: string | null, language: LimbixUserLanguage } | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'LimbixRefresh', token: string, refreshToken: string } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPassword', success?: boolean | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  userUid: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UpdatePassword', redirectUrl?: string | null } | null };

export type ReportParticipantMutationVariables = Exact<{
  pdtUid: Scalars['String']['input'];
  assessmentUid: Scalars['String']['input'];
  assessmentAnswers: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  assignmentUid: Scalars['String']['input'];
  assignmentCompleteTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ReportParticipantMutation = { __typename?: 'Mutation', reportParticipantAssessmentResult?: { __typename?: 'ReportParticipantAssessmentResult', participantAssessmentResult?: { __typename?: 'ParticipantAssessmentResultType', uid: string } | null } | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendEmailVerification?: { __typename?: 'ResendEmailVerification', success?: boolean | null } | null };

export type SendEmailChangeVerificationMutationVariables = Exact<{
  previousEmail: Scalars['String']['input'];
  email: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SendEmailChangeVerificationMutation = { __typename?: 'Mutation', sendEmailChangeVerification?: { __typename?: 'SendEmailChangeVerification', success?: boolean | null } | null };

export type EnrollDirectAccessPatientMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  pdtUid: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactEmail?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  safetyAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  termsAndPrivacyAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type EnrollDirectAccessPatientMutation = { __typename?: 'Mutation', enrollDirectAccessPatient?: { __typename?: 'EnrollDirectAccessPatient', success?: boolean | null, patientUid?: string | null } | null };

export type EnrollPatientPlatgenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  organizationSlug: Scalars['String']['input'];
  termsAndPrivacyAcknowledgedAt: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  posthogDistinctId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EnrollPatientPlatgenMutation = { __typename?: 'Mutation', enrollPatientPlatgen?: { __typename?: 'EnrollPatientPlatgen', success?: boolean | null, patientUid?: string | null, userUid?: string | null } | null };

export type EnrollDirectAccessPatientV2MutationVariables = Exact<{
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  organizationSlug: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  termsAndPrivacyAcknowledgedAt: Scalars['String']['input'];
  posthogDistinctId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  marketingSmsConsent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EnrollDirectAccessPatientV2Mutation = { __typename?: 'Mutation', enrollDirectAccessPatientV2?: { __typename?: 'EnrollDirectAccessPatientV2', success?: boolean | null, patientUid?: string | null, userUid?: string | null } | null };

export type SetEmailVerifiedMutationVariables = Exact<{
  careTeamUid: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetEmailVerifiedMutation = { __typename?: 'Mutation', setEmailVerified?: { __typename?: 'SetEmailVerified', success?: boolean | null, userUid?: string | null, distinctId?: string | null } | null };

export type SaveCoverageDetailsMutationVariables = Exact<{
  careTeamUid: Scalars['String']['input'];
  token: Scalars['String']['input'];
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  coverageCheckTimestamp: Scalars['DateTime']['input'];
  coverageCheckStartTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  coverageCheckStatus: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveCoverageDetailsMutation = { __typename?: 'Mutation', saveCoverageDetails?: { __typename?: 'SaveCoverageDetails', success?: boolean | null, email?: string | null, userUid?: string | null } | null };

export type SavePasswordAndActivateUserMutationVariables = Exact<{
  careTeamUid: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SavePasswordAndActivateUserMutation = { __typename?: 'Mutation', savePasswordAndActivateUser?: { __typename?: 'SavePasswordAndActivateUser', success?: boolean | null, authToken?: { __typename?: 'TokenAuth', token: string, refreshToken: string, user?: { __typename?: 'UserType', uid: string, email: string } | null } | null } | null };

export type SavePasswordAndActivateSoleraUserMutationVariables = Exact<{
  careTeamUid: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  token: Scalars['String']['input'];
  clientType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SavePasswordAndActivateSoleraUserMutation = { __typename?: 'Mutation', savePasswordAndActivateSoleraUser?: { __typename?: 'SavePasswordAndActivateSoleraUser', success?: boolean | null, authToken?: { __typename?: 'TokenAuth', token: string, refreshToken: string, user?: { __typename?: 'UserType', uid: string, email: string } | null } | null } | null };

export type SendReadyToDownloadSmsMutationVariables = Exact<{
  careTeamUid: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  textConsentAcknowledgedAt?: InputMaybe<Scalars['String']['input']>;
  marketingSmsConsent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SendReadyToDownloadSmsMutation = { __typename?: 'Mutation', sendReadyToDownloadSms?: { __typename?: 'SendReadyToDownloadSMS', success?: boolean | null } | null };

export type EnrollSoleraPatientMutationVariables = Exact<{
  enrollmentId: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
}>;


export type EnrollSoleraPatientMutation = { __typename?: 'Mutation', enrollSoleraPatient?: { __typename?: 'EnrollSoleraPatient', success?: boolean | null, careTeamUid?: string | null, token?: string | null, patient?: { __typename?: 'PatientType', uid: string, user: { __typename?: 'UserType', uid: string, email: string, firstName?: string | null, lastName?: string | null, phone?: string | null }, location?: { __typename?: 'LocationType', city?: string | null, state?: LocationState | null, postalCode?: string | null } | null } | null } | null };

export type VerifyAccessCodeMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  isStudyCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VerifyAccessCodeMutation = { __typename?: 'Mutation', verifyAccessCode?: { __typename?: 'VerifyAccessCode', valid?: boolean | null } | null };

export type EditPatientInfoMutationVariables = Exact<{
  changeReason: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditPatientInfoMutation = { __typename?: 'Mutation', editPatientInfo?: { __typename?: 'EditPatientInfo', success?: boolean | null } | null };

export type AssessmentQueryVariables = Exact<{
  assessmentUid: Scalars['String']['input'];
}>;


export type AssessmentQuery = { __typename?: 'Query', assessment?: { __typename?: 'AssessmentType', uid: string, isLocked?: boolean | null, name?: any | null, contextText?: any | null, introText?: any | null, preQuestionText?: any | null, questions?: Array<{ __typename?: 'QuestionType', uid: string, text?: any | null, questionType: QuestionQuestionType, ordinal: number, isOptional: boolean, isSensitive: boolean, answers?: Array<{ __typename?: 'AnswerType', uid: string, text?: any | null } | null> | null, conditions?: Array<{ __typename?: 'QuestionConditionType', isNegated: boolean, dependsOnQuestion: { __typename?: 'QuestionType', uid: string, questionType: QuestionQuestionType, ordinal: number }, dependsOnAnswer: { __typename?: 'AnswerType', uid: string } } | null> | null } | null> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', accountType: LimbixUserAccountType, phone?: string | null, uid: string } | null };

export type AssignmentsQueryVariables = Exact<{
  pdtUid?: InputMaybe<Scalars['String']['input']>;
  onlyVisible: Scalars['Boolean']['input'];
  clientType: Scalars['String']['input'];
}>;


export type AssignmentsQuery = { __typename?: 'Query', assignments?: Array<{ __typename?: 'AssignmentType', uid: string, dueDate?: any | null, typeOfAssignment: AssignmentTypeOfAssignment, completeTime?: any | null, canSkipQuestions: boolean, pdt: { __typename?: 'PdtType', uid: string, name: string }, assessment?: { __typename?: 'AssessmentType', name?: any | null, uid: string } | null, aboutUser?: { __typename?: 'UserType', firstName?: string | null, language: LimbixUserLanguage } | null } | null> | null };

export type EligibilityStatusQueryVariables = Exact<{
  pdtUid: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  dateOfBirth: Scalars['Date']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  organizationSlug: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmCampaignDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type EligibilityStatusQuery = { __typename?: 'Query', eligibilityStatus?: { __typename?: 'EligibilityStatusType', isEligible?: boolean | null } | null };

export type EligibilityConfigurationQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
}>;


export type EligibilityConfigurationQuery = { __typename?: 'Query', eligibilityConfiguration?: { __typename?: 'EligibilityConfigurationType', isValid?: boolean | null, collectZipcodeForEligibility?: boolean | null, hasEmployeeId?: boolean | null, hasAddressField?: boolean | null, employeeIdFieldRename?: string | null, isGeneric?: boolean | null, employeeIdValidationEnabled?: boolean | null, employeeIdAllowedChars?: string | null, employeeIdMinLength?: number | null, employeeIdMaxLength?: number | null, employeeIdValidationErrorMessage?: string | null, employeeIdExample?: string | null } | null };

export type PosthogDistinctIdWithEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type PosthogDistinctIdWithEmailQuery = { __typename?: 'Query', posthogDistinctIdWithEmail?: { __typename?: 'PostHogDistinctID', distinctId?: string | null, userUid?: string | null } | null };

export type PosthogFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PosthogFeatureFlagsQuery = { __typename?: 'Query', allFeatureFlags?: { __typename?: 'PostHogFeatureFlags', values?: any | null } | null };

export type PosthogFeatureFlagQueryVariables = Exact<{
  email: Scalars['String']['input'];
  featureFlagName: Scalars['String']['input'];
}>;


export type PosthogFeatureFlagQuery = { __typename?: 'Query', featureFlag?: { __typename?: 'PostHogFeatureFlag', value?: any | null } | null };

export type OrganizationNameQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type OrganizationNameQuery = { __typename?: 'Query', organizationName?: { __typename?: 'OrganizationLiteType', name?: string | null } | null };

export type OrganizationsByPrefixQueryVariables = Exact<{
  prefix: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  searchFilters: Scalars['JSONString']['input'];
}>;


export type OrganizationsByPrefixQuery = { __typename?: 'Query', organizationsByPrefix?: Array<{ __typename?: 'OrganizationLiteType', name?: string | null, slug: string } | null> | null };

export type DecodeOrganizationSignupTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  tokenIssuer: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
}>;


export type DecodeOrganizationSignupTokenMutation = { __typename?: 'Mutation', decodeOrganizationSignupToken?: { __typename?: 'DecodeOrganizationSignupToken', tokenPayload?: any | null, existingCareTeam?: { __typename?: 'CareTeamType', canAccessPdt?: boolean | null, patient: { __typename?: 'PatientType', user: { __typename?: 'UserType', email: string, emailVerified: boolean } } } | null } | null };

export type ExternalOrganizationSignupMutationVariables = Exact<{
  token: Scalars['String']['input'];
  tokenIssuer: Scalars['String']['input'];
  externalIdentifier: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExternalOrganizationSignupMutation = { __typename?: 'Mutation', externalOrganizationSignup?: { __typename?: 'ExternalOrganizationSignup', success?: boolean | null, careTeam?: { __typename?: 'CareTeamType', patient: { __typename?: 'PatientType', user: { __typename?: 'UserType', email: string } } } | null } | null };

export type ExternalOrganizationAccessRenewalMutationVariables = Exact<{
  token: Scalars['String']['input'];
  tokenIssuer: Scalars['String']['input'];
  externalIdentifier: Scalars['String']['input'];
  pdtUid: Scalars['String']['input'];
}>;


export type ExternalOrganizationAccessRenewalMutation = { __typename?: 'Mutation', externalOrganizationAccessRenewal?: { __typename?: 'ExternalOrganizationAccessRenewal', success?: boolean | null } | null };


export const RequestTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]} as unknown as DocumentNode<RequestTokenMutation, RequestTokenMutationVariables>;
export const RefreshTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const ReportParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentAnswers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentCompleteTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportParticipantAssessmentResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"assessmentUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"assessmentAnswers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentAnswers"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignmentUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignmentCompleteTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentCompleteTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}}]}}]}}]} as unknown as DocumentNode<ReportParticipantMutation, ReportParticipantMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendEmailVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const SendEmailChangeVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEmailChangeVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailChangeVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"previousEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SendEmailChangeVerificationMutation, SendEmailChangeVerificationMutationVariables>;
export const EnrollDirectAccessPatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enrollDirectAccessPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"safetyAcknowledgedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDependent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollDirectAccessPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"emergencyContactName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactName"}}},{"kind":"Argument","name":{"kind":"Name","value":"emergencyContactEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"emergencyContactPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"safetyAcknowledgedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"safetyAcknowledgedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmMedium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaignDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDependent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDependent"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"patientUid"}}]}}]}}]} as unknown as DocumentNode<EnrollDirectAccessPatientMutation, EnrollDirectAccessPatientMutationVariables>;
export const EnrollPatientPlatgenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enrollPatientPlatgen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"posthogDistinctId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollPatientPlatgen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"posthogDistinctId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posthogDistinctId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"patientUid"}},{"kind":"Field","name":{"kind":"Name","value":"userUid"}}]}}]}}]} as unknown as DocumentNode<EnrollPatientPlatgenMutation, EnrollPatientPlatgenMutationVariables>;
export const EnrollDirectAccessPatientV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enrollDirectAccessPatientV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"posthogDistinctId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDependent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketingSmsConsent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollDirectAccessPatientV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsAndPrivacyAcknowledgedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"posthogDistinctId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posthogDistinctId"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmMedium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaignDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDependent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDependent"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketingSmsConsent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketingSmsConsent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"patientUid"}},{"kind":"Field","name":{"kind":"Name","value":"userUid"}}]}}]}}]} as unknown as DocumentNode<EnrollDirectAccessPatientV2Mutation, EnrollDirectAccessPatientV2MutationVariables>;
export const SetEmailVerifiedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetEmailVerified"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setEmailVerified"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"careTeamUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"userUid"}},{"kind":"Field","name":{"kind":"Name","value":"distinctId"}}]}}]}}]} as unknown as DocumentNode<SetEmailVerifiedMutation, SetEmailVerifiedMutationVariables>;
export const SaveCoverageDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCoverageDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageCheckTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageCheckStartTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageCheckStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCoverageDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"careTeamUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverageCheckTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageCheckTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverageCheckStartTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageCheckStartTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverageCheckStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageCheckStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userUid"}}]}}]}}]} as unknown as DocumentNode<SaveCoverageDetailsMutation, SaveCoverageDetailsMutationVariables>;
export const SavePasswordAndActivateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"savePasswordAndActivateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePasswordAndActivateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"careTeamUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmMedium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaignDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"authToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SavePasswordAndActivateUserMutation, SavePasswordAndActivateUserMutationVariables>;
export const SavePasswordAndActivateSoleraUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"savePasswordAndActivateSoleraUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePasswordAndActivateSoleraUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"careTeamUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"authToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SavePasswordAndActivateSoleraUserMutation, SavePasswordAndActivateSoleraUserMutationVariables>;
export const SendReadyToDownloadSmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendReadyToDownloadSms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textConsentAcknowledgedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketingSmsConsent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReadyToDownloadSms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"careTeamUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careTeamUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"textConsentAcknowledgedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textConsentAcknowledgedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketingSmsConsent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketingSmsConsent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SendReadyToDownloadSmsMutation, SendReadyToDownloadSmsMutationVariables>;
export const EnrollSoleraPatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enrollSoleraPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enrollmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollSoleraPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"enrollmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enrollmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"careTeamUid"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnrollSoleraPatientMutation, EnrollSoleraPatientMutationVariables>;
export const VerifyAccessCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyAccessCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isStudyCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyAccessCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"isStudyCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isStudyCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}}]}}]}}]} as unknown as DocumentNode<VerifyAccessCodeMutation, VerifyAccessCodeMutationVariables>;
export const EditPatientInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editPatientInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPatientInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"changeReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<EditPatientInfoMutation, EditPatientInfoMutationVariables>;
export const AssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Assessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assessmentUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentUid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contextText"}},{"kind":"Field","name":{"kind":"Name","value":"introText"}},{"kind":"Field","name":{"kind":"Name","value":"preQuestionText"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","name":{"kind":"Name","value":"isSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dependsOnQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dependsOnAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNegated"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssessmentQuery, AssessmentQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const AssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Assignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyVisible"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyVisible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyVisible"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientType"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"pdt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"typeOfAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"completeTime"}},{"kind":"Field","name":{"kind":"Name","value":"canSkipQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]} as unknown as DocumentNode<AssignmentsQuery, AssignmentsQueryVariables>;
export const EligibilityStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eligibilityStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibilityStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmMedium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmMedium"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaign"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmId"}}},{"kind":"Argument","name":{"kind":"Name","value":"utmCampaignDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utmCampaignDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEligible"}}]}}]}}]} as unknown as DocumentNode<EligibilityStatusQuery, EligibilityStatusQueryVariables>;
export const EligibilityConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eligibilityConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibilityConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"collectZipcodeForEligibility"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"hasAddressField"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdFieldRename"}},{"kind":"Field","name":{"kind":"Name","value":"isGeneric"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdValidationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdAllowedChars"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdMinLength"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdValidationErrorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"employeeIdExample"}}]}}]}}]} as unknown as DocumentNode<EligibilityConfigurationQuery, EligibilityConfigurationQueryVariables>;
export const PosthogDistinctIdWithEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"posthogDistinctIdWithEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posthogDistinctIdWithEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distinctId"}},{"kind":"Field","name":{"kind":"Name","value":"userUid"}}]}}]}}]} as unknown as DocumentNode<PosthogDistinctIdWithEmailQuery, PosthogDistinctIdWithEmailQueryVariables>;
export const PosthogFeatureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"posthogFeatureFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allFeatureFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]}}]} as unknown as DocumentNode<PosthogFeatureFlagsQuery, PosthogFeatureFlagsQueryVariables>;
export const PosthogFeatureFlagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"posthogFeatureFlag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureFlagName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"featureFlagName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureFlagName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PosthogFeatureFlagQuery, PosthogFeatureFlagQueryVariables>;
export const OrganizationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrganizationNameQuery, OrganizationNameQueryVariables>;
export const OrganizationsByPrefixDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationsByPrefix"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prefix"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationsByPrefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prefix"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prefix"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<OrganizationsByPrefixQuery, OrganizationsByPrefixQueryVariables>;
export const DecodeOrganizationSignupTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DecodeOrganizationSignupToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIssuer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decodeOrganizationSignupToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"tokenIssuer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIssuer"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenPayload"}},{"kind":"Field","name":{"kind":"Name","value":"existingCareTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAccessPdt"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DecodeOrganizationSignupTokenMutation, DecodeOrganizationSignupTokenMutationVariables>;
export const ExternalOrganizationSignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExternalOrganizationSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIssuer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalOrganizationSignup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"tokenIssuer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIssuer"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalIdentifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"careTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalOrganizationSignupMutation, ExternalOrganizationSignupMutationVariables>;
export const ExternalOrganizationAccessRenewalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExternalOrganizationAccessRenewal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIssuer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalOrganizationAccessRenewal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"tokenIssuer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIssuer"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalIdentifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdtUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdtUid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ExternalOrganizationAccessRenewalMutation, ExternalOrganizationAccessRenewalMutationVariables>;